var _g, _circle, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBiometricPasport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.004,
    height: 63.025,
    viewBox: "0 0 64.004 63.025",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_18880",
    "data-name": "Group 18880",
    transform: "translate(-9.639 -8.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18865",
    "data-name": "Group 18865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18562",
    "data-name": "Group 18562"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18556",
    "data-name": "Group 18556"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18553",
    "data-name": "Group 18553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22225",
    "data-name": "Path 22225",
    d: "M13.986,17.074a5.211,5.211,0,0,1,.225-1.845,2.638,2.638,0,0,1,2.77-1.791c1.924.158,24.9,3.022,24.9,3.022s2.541.424,2.541,2.413l-.429.231s-.32-1.063-2.112-1.362-11.933-.253-14.945-.253-11.517.037-12.248.035S13.986,17.074,13.986,17.074Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7510",
    "data-name": "Rectangle 7510",
    width: 34.307,
    height: 40.41,
    rx: 7.331,
    transform: "translate(10.116 18.105)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22226",
    "data-name": "Path 22226",
    d: "M14.385,16.151c.174-.053.329-.263.364-.689a.558.558,0,0,1,.033-.182,1.633,1.633,0,0,1,.179-.408,1.9,1.9,0,0,1,.864-.761,2.207,2.207,0,0,1-.3.215,1.979,1.979,0,0,1,.405-.206,2.1,2.1,0,0,1,.319-.166,2.072,2.072,0,0,1,.662.014l.017-.052c.52.07.722.163,1.145.208,1.585.152,1.266.1,2.4.178.116.116,1.789.206,2.067.312,1.51.1,3.68.4,5.65.61l-.16-.028c.848.052.947.189,1.857.274l-.225-.042c1.172.083,3.208.372,4.307.544-.224-.042-.1-.06.252-.015.3.055-.3.036.325.09-.153-.028-.028-.035.115-.019l.606.122c1.612.154,3.508.34,5.17.564.312.019.089-.026.019-.052l.986.128a4.848,4.848,0,0,1,.947.176,2.2,2.2,0,0,1,1.34,1.071.817.817,0,0,1,.1.078c.063.158.031.173.017.193a.051.051,0,0,0-.016.041c-.008,0,.024.13-.009.077-.018-.03.024.058.043.051.006-.056.01-.132.017-.167a1.031,1.031,0,0,1,.028.26c.007.054-.02-.007-.032-.021l-.041-.063-.108-.172a.423.423,0,0,0-.071-.086,2.45,2.45,0,0,0-.364-.27,2.644,2.644,0,0,1,.225.236,5.109,5.109,0,0,0-.786-.443,3.268,3.268,0,0,0-.438-.192,2.766,2.766,0,0,0-1.128-.028,7.859,7.859,0,0,1-1.422.042c-.261-.032.086-.048-.175-.081-1.162.017-1.3-.029-2.465-.013-.622.1.593,0-.084.092l.885-.022c-.763.052.694.013.575.072-.572.017-1.442-.033-2.189-.052,0,.044.868,0,.523.065l-.383-.018a1.61,1.61,0,0,0,.347.028,5.052,5.052,0,0,1-.816,0c-.025-.023-.006-.056.115-.087a.693.693,0,0,1-.1.016c-.748-.064-2.013-.016-2.655-.066.1.013.015.017-.019.028-.453,0-.919-.056-1.527-.073-.331.032.192.1-.781.079-.173-.036.26-.1-.556-.1,0,0,.712.03.331.056a4.535,4.535,0,0,0-.988.053c-.418-.052-.8.018-.887-.066a3.667,3.667,0,0,1-.693.076c.224-.045-.954-.045-.92-.1-.207.063.852.077.193.142a9.765,9.765,0,0,1-1.356-.125c-.345.015-.5.04-1.039.047a1.417,1.417,0,0,1,.243.015c-.954-.045-2.362,0-2.9-.082.192.1-2.027.012-1.3.1-.4,0-1.026-.044-1.163-.063a12.283,12.283,0,0,1-1.422.064c-.224-.043-.939-.028-1.372-.053.193.009.3.022.228.043a2.839,2.839,0,0,0-.781.035c-.661-.023.121-.058-.278-.094-.572.017-.086.048-.19.079l-.852-.077a1.647,1.647,0,0,0-.364.043,5.083,5.083,0,0,0-.971-.018h.73l-.28.039-.868-.049a3.525,3.525,0,0,0-.863.089h0a3.015,3.015,0,0,0-.494.031c.078.008.154.01.23.025.079,0,.158-.009.237-.019.01.025.068.052.107.078h-.08A2.95,2.95,0,0,0,9.8,20.726v1.561l-.056.28c.011-.827.059-2.044.073-2.475a3.314,3.314,0,0,0-.063.411,1.428,1.428,0,0,1,.139-.836c.066-.166.145-.255.061-.034a3.02,3.02,0,0,1,.153-.389,2.162,2.162,0,0,0-.317.716,4.3,4.3,0,0,0-.117,1.124c.011-.2.047-.712.07-.555-.033.583-.049,1.126-.069,1.685a4.336,4.336,0,0,1,.064-.471,8.893,8.893,0,0,1-.035.937c.018.179.03.3.044.182-.019.589-.023,1.057,0,1.681,0,0,.027-.572.051-.389v.321c-.028.93-.076,1.222-.1,2.357-.075,1.431.046,2.774-.009,3.769-.02.055-.035-.743-.048-.1.04-.111.026.389.042.419-.059.7.013,1.033-.027,1.529a2.7,2.7,0,0,1,.043.56c.05-.078.02.774.091-.247-.075,1.05.019,1.858-.1,2.637l-.014-.268L9.7,36.186v-.035c.008.456,0,.527.047,1.141.007-.267.017-.642.024-.91.044.563-.037,1.169-.039,1.792.036-.027.013-.65.056-.465.006.443-.021.821-.031,1.234l.02-.058c.045,1.1-.1.429-.031,1.234-.012-.026-.025.077-.036.027.021.3.057,1,.082.305,0,.382-.018.817-.04,1.012a3.084,3.084,0,0,0-.052-.526l-.021,1.541c0,.172.02-.127.02-.344.106,1.809-.09,3.66.038,5.7-.033-.23-.029.148-.051.344.01.662,0,1.662.021,2.274l.022-.2c-.027,1.574-.063,2.659-.049,3.7-.01.051.032-.008.038-.2-.04.765.087,1.681,0,1.9a3.347,3.347,0,0,0,.673,1.984,2.931,2.931,0,0,0,2.052,1.145c.185-.023-.042-.017-.267-.066s-.449-.123-.289-.108a6.329,6.329,0,0,0,1.584.116c.533.007,1.078.014,1.641,0-.183-.007-.141-.013-.23-.016,1.122-.035-.124.054.822.046-.051-.027,0-.034.309-.048l.278.044c.046-.007.039-.041-.1-.054.42.057,1.677.018,2.009.072.085-.014-.15-.064-.02-.084q.591-.016,1.183.026h0c.353-.038,1.216-.032,1.032-.039.9-.018.143.03.83.063l-.72.025,1.272.013-.5-.027c.583-.022,1.183.026,1.862.025l-.311.03.775.019c.076-.064.991-.014.566-.088,1.441-.033,2.366.051,3.679.056-.228,0-.139-.014-.185-.025a16.589,16.589,0,0,1,1.683.052,2.186,2.186,0,0,1-.279-.043c.9,0,.55.037,1.549.056-.276-.027-.19-.041.083-.047-.042.023.188.04.371.047-.752-.128,1.119-.053.646-.153.05.027,1.6.083,1.157.134L32.6,58.8a2.5,2.5,0,0,0,.617.024,2.3,2.3,0,0,1-.3-.022c1.415.042,2.9,0,4.489.036-.138-.013-.779-.037-.37-.047,1.578-.019,2.5.048,4.088.08.072-.082-1.722-.012-1.782-.089l2.574.026a3.053,3.053,0,0,0,2.419-1.442,5.372,5.372,0,0,0,.436-1.375,11.537,11.537,0,0,0,.01-1.783,4.553,4.553,0,0,0,.053-1.148c-.031.226-.032-.469-.055-.276a13,13,0,0,0-.025-2.179c.072-.151,0-1.239.047-1.714-.027-.729.015-1.562-.007-2.476a9.217,9.217,0,0,0,.041-1.243,1.275,1.275,0,0,1-.016.239c-.039-.274.035-1.053.011-1.568-.016-.233-.042.057-.046-.322a5.442,5.442,0,0,0,.042-.765c.008-.412.008-.887-.012-1.144a2.519,2.519,0,0,1-.028.387c.055-2.434-.012-5.03.053-7.516l-.054.441a22.439,22.439,0,0,1,.082-2.252c-.027-3.367-.1-6.863-.069-10.148.016-.241.019.14.042.18a4.886,4.886,0,0,1-.023-.755l.029.087c-.012-.227-.019-.485-.023-.763,0-.2-.006-.423-.02-.655h.015v-.23c0-.35,0-.712.007-1.071v-.532a2.738,2.738,0,0,0-.062-.564,2.4,2.4,0,0,0-.932-1.453,3.231,3.231,0,0,0-1.8-.783c-.617-.067-1.27-.14-2.09-.274-.526-.034.6.123-.109.048l-1.523-.227.082.014c-1.462-.264-3.919-.357-5.763-.64l.078.014a2.4,2.4,0,0,1-.645-.036c-.1-.027.1-.011.282-.008-1.647-.23-2.009-.273-3.315-.434.56.1-.527-.034-.589,0-.34-.069.2-.022-.558-.136-1.088-.132-2.1-.212-3-.3a6.131,6.131,0,0,1-.862-.178L20.595,13.4l-.04.012c-.4-.107-1.311-.123-1.589-.19.04.026.2.054.158.066l-.684-.1c.322.056.5.135-.063.075-.582-.111.164-.01-.118-.078l-.182.035c-.442-.058-.561-.136-.017-.089L16.928,13a2.893,2.893,0,0,0-1.186.147,2.953,2.953,0,0,0-1.714,1.523l.1-.127a3.036,3.036,0,0,0-.364,1.314C13.764,16.067,14.211,16.2,14.385,16.151Zm-.634,1.236a5.558,5.558,0,0,0,.921-.029m-.007-.007a2.38,2.38,0,0,1-.28-.02h.265m-1.123,1.052c-.048,0-.021-.014-.043-.021a7,7,0,0,1,1.111.052c-.062-.02-.182-.027-.184-.044.6,0,.363.037,1.022.056-.182-.027-.125-.041.055-.048-.028.023.124.04.245.047-.5-.128.739-.052.427-.154.033.027,1.058.083.764.134l-.179-.009c-.021.035.223.021.407.024a1.122,1.122,0,0,1-.2-.021c.933.042,1.914,0,2.963.035-.091-.014-.514-.036-.244-.047,1.042-.019,1.648.048,2.7.08.047-.082-1.137-.012-1.177-.089l3.477.088c.43-.119,1.2.049,1.964-.045-.072.041.308.056.722.056-.142-.033.3-.033.173-.056A4.951,4.951,0,0,0,28.9,18.4a10.748,10.748,0,0,0,1.078.05c.458-.028.983.014,1.557-.007-.2.048.571.021.782.042-.059,0-.18-.01-.15-.017.172-.042.662.035.986.011.147-.017-.036-.044.2-.048a5.472,5.472,0,0,0,1.2.032.9.9,0,0,1-.243-.03c1.53.058,3.163-.013,4.727.056l-.277-.057c.976-.073.641.094,1.416.085l1.6-.026a2.106,2.106,0,0,1,1.35.5,2.319,2.319,0,0,1,.756,1.287,11.186,11.186,0,0,1,.037,1.606c-.016.159-.02-.092-.042-.119a2.207,2.207,0,0,1,.023.5l-.029-.057c.079.991-.054,2.86.07,3.6-.047.948.034,1.615-.036,2.765.026.363.05-.422.057.07L43.916,29.7v-.058c-.088,1.029.1,2.719.035,4.011V33.6a1.212,1.212,0,0,1,.038.445c-.014.073-.022-.068-.039-.193-.034,1.151-.035,1.4-.042,2.314.03-.393.026.365.068.4-.027.24-.043-.138-.066.4,0,.758.032,1.457.047,2.086a3.107,3.107,0,0,1-.073.607c-.007.856-.012,1.334-.021,2.384l.016.027c-.058.283.029.911,0,1.106.021-.028.029-.14.045-.112l-.019.477c.018-.225.072-.354.078.039-.041.409-.028-.112-.061.086l.054.124c-.006.308-.067.4-.083.018-.006,1.052-.011,2.09-.016,3.027l.035-.1c-.013.519-.013,1.22.018,1.528-.01.014-.028.142-.04.059-.047.618.057.066.006.741a2.409,2.409,0,0,1,.04-.407l-.043,1.263a7.314,7.314,0,0,1,.062,1.315c-.015.021-.035-.133-.037-.268l-.013.342.061.263-.053.5.05.008c-.01.366-.075.509-.07.8.032,1.1.049.879.1,1.663-.1.08.022,1.268-.091,1.418a2.165,2.165,0,0,1-.746,1.486,2.22,2.22,0,0,1-.823.448,3.315,3.315,0,0,1-.951.1l.107.009c-.559.047-.637-.078-1.239-.056l.151.015a28.243,28.243,0,0,1-2.866-.038c.15.015.074.047-.163.043-.2-.019.195-.07-.221-.052.1.01.021.032-.073.033L36.67,57.9c-1.068.035-2.324.071-3.431.042-.2.018-.055.036-.007.054l-2.544-.062-.08.058c-.388,0-.24-.09-.746-.037-.112.008.334,0,.473.03-.78.044-.46-.057-1.2-.051l.194.066a2.057,2.057,0,0,1-.858-.074c-.8-.078-.569.127-1.66.069-.173-.033.057-.048-.116-.081-.767.017-.858-.029-1.627-.013-.41.1.391,0-.056.092l.584-.022c-.5.052.458.013.379.072-.378.017-.952-.033-1.445-.052,0,.044.573.005.345.065l-.253-.018a.68.68,0,0,0,.229.029,2.106,2.106,0,0,1-.538,0c-.016-.023,0-.056.076-.088a.183.183,0,0,1-.064.016c-.494-.063-1.328-.015-1.752-.066.068.013.01.017-.013.028-.3,0-.606-.056-1.007-.073-.219.033.126.1-.516.08-.114-.037.171-.1-.367-.1,0,0,.47.03.219.056-.528-.026-.171.012-.653.054-.275-.052-.526.018-.585-.066a1.592,1.592,0,0,1-.458.076c.148-.046-.629-.045-.607-.1-.136.063.562.077.127.142a4.2,4.2,0,0,1-.9-.125c-.228.015-.331.04-.686.047a.723.723,0,0,1,.16.015c-.63-.045-1.559,0-1.915-.082.127.1-1.338.012-.857.1a6.572,6.572,0,0,1-.768-.063c.028.076-.653.019-.939.064a3.08,3.08,0,0,1-.828-.175c.107.049.168.071.121.083a2.722,2.722,0,0,0-.463-.151c-.344-.237.089-.009-.1-.171-.294-.19-.07.01-.139,0a2.225,2.225,0,0,1-.34-.421,1.306,1.306,0,0,0-.17-.154c-.088-.168-.143-.323-.264-.555a2.07,2.07,0,0,0,.194.419c-.038-.045-.084-.087-.118-.136a2.234,2.234,0,0,1-.143-.539,4.425,4.425,0,0,0-.15-.541h0l.014-.33-.055.151a.787.787,0,0,0,.007.161c-.024,0-.048.04-.071.069V51.473l.056-.185a9.967,9.967,0,0,0-.01,1.63l.01-.271a1.13,1.13,0,0,1,.031.548c-.008.114-.048.19-.046.035l.016.274a10.445,10.445,0,0,0,.07-1.237c-.019.133-.033.463-.061.363.02-.375.04-.745.059-1.108a2.068,2.068,0,0,1-.064.311,3.644,3.644,0,0,1,.035-.618c-.018-.118-.03-.2-.044-.121a9.751,9.751,0,0,0,0-1.108s-.027.377-.051.256V50.03c.028-.614.076-.807.1-1.556.075-.944-.046-1.831.008-2.488.02-.036.035.491.048.065-.04.074-.026-.256-.042-.277.058-.462-.013-.681.027-1.009-.014.077-.03-.193-.043-.37-.05.052-.02-.511-.091.163.075-.693-.018-1.226.1-1.741l.014.177-.023-.7v.03a5.119,5.119,0,0,0-.047-.753l-.024.6a10.162,10.162,0,0,1,.039-1.184c-.036.019-.013.429-.056.308-.006-.293.021-.543.031-.814l-.02.039c-.045-.726.1-.283.031-.814.012.016.025-.051.036-.018-.021-.2-.057-.659-.082-.2a4.8,4.8,0,0,1,.04-.668,1.319,1.319,0,0,0,.052.347l.015-1.016c0-.114-.019.084-.02.227-.106-1.194.09-2.416-.038-3.761.033.152.029-.1.051-.228-.01-.437,0-1.1-.022-1.5l-.022.129c.027-1.039.063-1.755.049-2.441.01-.034-.032.005-.039.129a10.894,10.894,0,0,1,0-1.252l.007.186c-.014-1,.048-2.109.059-3.143-.052-.242-.006.6-.067.385-.021-.717.023-1.445.006-2.227-.007.127-.013.1-.016.159-.034-.778.052.085.044-.569-.026.035-.032,0-.046-.215l.042-.192c-.007-.032-.039-.027-.051.07.055-.291.018-1.162.069-1.392-.013-.058-.061.1-.081.014a5.762,5.762,0,0,1,.025-.82h0c-.036-.244-.031-.841-.037-.715-.01-.623.022-.1.08-.562a3.94,3.94,0,0,0,0,.486,2.743,2.743,0,0,1,.1-.835,2.2,2.2,0,0,0-.09.32,2.2,2.2,0,0,1,.469-1.109,1.532,1.532,0,0,0-.087.183,2.39,2.39,0,0,1,.31-.378c-.018-.091.467-.418.215-.307a1.918,1.918,0,0,1,1.105-.436C12.77,18.351,13.127,18.381,13.527,18.383ZM33.938,58.034c-.106,0-.147-.016-.11-.033h.458A1.689,1.689,0,0,0,33.938,58.034Zm-.967-.04h0ZM10.3,47.89l.039.151a1.624,1.624,0,0,1-.039.293Zm0,2.974c.015-.027.033.021.044.093l-.044.433Zm0-13.988c.013-.012.028,0,.039.013a1.152,1.152,0,0,1-.039.35ZM9.8,22.421v.814c-.015.039-.033-.048-.044-.158Zm30.651-5.77h0l.39.049Zm-1.589-.188a4.273,4.273,0,0,0,.531.028c.16.018.217.042.159.052ZM9.8,43.851v.561c-.014.018-.028,0-.039-.021A2.712,2.712,0,0,1,9.8,43.851ZM9.765,27.494A3.7,3.7,0,0,1,9.8,27.05v.673Z",
    fill: "#3b3b3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18554",
    "data-name": "Group 18554"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22227",
    "data-name": "Path 22227",
    d: "M32.715,28.832c-.009-.12-.02.028-.034.018-.039-.185.048-.434-.006-.7-.021-.212-.055-.269-.075-.444v-.047c.017-.035.036.066.036.066a1.087,1.087,0,0,0,0-.312c.01.022.019,0,.032-.034,0-.088-.042-.059-.025-.174a.3.3,0,0,1,.046.087l-.042-.311c.02-.028.03.064.044.1a1.2,1.2,0,0,0-.05-.348l-.011.077c0-.044.027-.023.033.01.025.1-.011.148-.022.154l-.007-.076c-.067.078.011.3.007.458L32.6,27.3v-.891a.177.177,0,0,0-.177-.176h-.015a.2.2,0,0,0,.02-.056.223.223,0,0,0,.059.016.206.206,0,0,1,.07-.012.245.245,0,0,0-.133-.026h0c-.013-.023-.056-.045-.168-.063l-.169.034-.055-.027h.142a.286.286,0,0,0-.189.013.118.118,0,0,0-.071-.029l-.166.052c-.02-.021.075-.042-.037-.054-.078.024.075.048-.054.064-.081-.025-.057-.045-.152-.024-.014-.015.007-.023.044-.029a1.33,1.33,0,0,0-.267.036c-.084-.031-.285.008-.277-.044a.977.977,0,0,1-.227.042c.142-.062-.29,0-.253-.07a3.359,3.359,0,0,1-.565.056.084.084,0,0,1,.047-.011,1.208,1.208,0,0,1-.2-.032c-.014.046-.176.057-.264.085-.128-.045.078-.055.038-.1.007.037-.223.037-.179.069-.1-.028-.084-.014-.135-.052-.017.058-.091.01-.173.045-.142-.028-.036-.054-.192-.036-.074-.018.064-.038.064-.038-.159,0-.075.042-.108.068-.189.012-.088-.032-.152-.054-.118.011-.209.051-.3.05-.006-.007-.024-.01,0-.019-.125.035-.372,0-.517.045a.047.047,0,0,1-.019-.012.059.059,0,0,1,.022.059c-.071,0-.132.027-.159,0a.094.094,0,0,0,.068-.019l-.075.012c-.067-.041.1-.014.1-.044a2.652,2.652,0,0,1-.426.035c-.023-.04.26-.014.112-.049l.173.015c-.132-.063.1,0-.016-.063-.227-.012-.254.02-.48.008-.051.022.017.033-.034.055-.322.04-.253-.1-.49-.047a.3.3,0,0,1-.253.05l.057-.045c-.219,0-.125.065-.355.035.041-.018.173-.015.139-.021-.149-.036-.1.026-.22.026l-.024-.04-.751.042c.014-.012.058-.023,0-.036a7.781,7.781,0,0,1-1.013-.028l-.12.034c-.028,0-.052-.014-.022-.021-.123-.013-.006.021-.065.035s-.092-.02-.048-.029a3.684,3.684,0,0,1-.846.026l.044-.01c-.178-.014-.2.07-.365.038l.032-.006a.413.413,0,0,0-.188.02.274.274,0,0,0-.151.16.278.278,0,0,0-.017.111v.219a3.224,3.224,0,0,1-.033.519c.049.056-.024.382.046.407a2.937,2.937,0,0,0-.071.468c0,.083.043.124.05.226h-.036l.037.14-.043.074.009.1c0-.038.017-.081.027-.075a.833.833,0,0,1-.045.37l.029.355c-.015-.008-.019-.068-.029-.114.036.189-.038.034,0,.208.008-.023.021.013.029.016a1.819,1.819,0,0,0-.015.43l-.025-.028c-.007.263.01.555.009.851.012-.106.055-.082.059,0l-.039.035c.024.056.015-.091.043.024,0,.111-.044.074-.056.011l.013.134c-.012.008-.018-.024-.032-.032.024.055-.039.232,0,.311l-.011.007c0,.3.008.431.012.671.033,0,.026.1.052.171-.011.177-.038.373-.036.587.016.15.028.043.048.111-.03.011-.028.224-.049.113a5.618,5.618,0,0,0,.028.651c.013-.035.018-.075.028-.054,0,.059-.013.134-.028.125v-.015c.046.365-.1.835-.024,1.131v-.016c.014.1.024.2.043.3,0,.14-.028-.083-.04.022.07.324.032.522.115.786a2.693,2.693,0,0,0,.272,1.017l.01-.025c.056.057.035.086.06.139.01-.015-.025-.082.008-.046a2.217,2.217,0,0,0,1.618,1.1c.241.035.148-.091.429-.01l-.084.03c.461,0,.932.1,1.383.112-.028.006-.03.017-.074.013a.728.728,0,0,0,.353.016c.069.01.013.022.054.039.092.027.243-.01.289.023.008.006-.028.006-.046.007a.409.409,0,0,1,.07,0h.024c.028.017.065.045.054.014a2.41,2.41,0,0,1,.3.314.284.284,0,0,1,.089.087c.087.126.267.138.285.094,0,.013.026.021.074.009a.331.331,0,0,0,.147-.1,1.4,1.4,0,0,0,.155-.188c-.014.036.077-.052.063-.007.085-.084.158-.162.125-.169.1-.049.174-.127.222-.147a.258.258,0,0,1,.222-.008c.352-.049.693-.075,1.018-.1-.01.054-.361.018-.345.073a6.035,6.035,0,0,1,.794-.082c.08,0-.044.024-.071.035a2.523,2.523,0,0,0,.893-.157.467.467,0,0,1-.054.034c.054-.021.129-.037.114-.057l-.05.025c-.094,0,.185-.146.179-.175-.053.108.256-.115.166.035.03-.024.063-.06.048-.069.049-.027.069-.029.031.018.166-.124.091-.1.233-.218.007.009-.019.036-.025.059a2,2,0,0,1,.226-.26c0,.012.018,0-.014.038a4.4,4.4,0,0,0,.4-.62c.006.1.059-.079.1-.073a1.526,1.526,0,0,0,.055-.147l-.043.049c.051-.126.073-.246.12-.351,0,.033-.009.066-.016.1.028-.08.048-.162.071-.244l-.059.132c.02-.137-.057,0,.008-.169,0,.036.039-.127.077-.189h0a.781.781,0,0,1,.032-.231c.018-.023.045.029.056.014-.026-.071.043-.312.007-.4.007.028.029.032.034.024l-.038-.044c.015-.061.021-.069.038-.057.021-.186-.059.055-.019-.164,0,.016.007.008.01.046.021-.222-.006-.429.007-.63.044-.059.011.175.048.108-.008-.291-.053-.6-.043-.884l-.005.052c-.062-.039.031-.21,0-.352,0,.035.035.046.028.036a6.557,6.557,0,0,0-.035-.687l.016.036c.014-.113.008-.3.015-.422-.016-.036-.013-.106-.036-.064.091-.379-.049-.722.027-1.058,0,.041.014.1.014.064l-.015-.286c-.027.022-.016.037-.037.1a.521.521,0,0,1-.029-.188c.018.128.044,0,.059-.057-.008.009-.017-.009-.026,0,.048-.149-.055-.025-.022-.229l.015.011a1.346,1.346,0,0,1-.022-.229c.031-.034.014.082.041.088,0-.116-.06-.228-.029-.333l.018.168a.586.586,0,0,0,.033-.211v.008l.016-.2-.01.049c-.082-.145-.015-.294-.069-.49.051.189.029.031.065.046.01-.049.021-.125.031-.1-.029-.092.022-.154-.02-.284C32.7,28.909,32.686,28.816,32.715,28.832Zm-.466,3.736a.184.184,0,0,1-.028-.077l.028-.04Zm0,.808-.032-.115c.008-.019.021-.033.032-.026Zm0-3.741c-.012-.007-.022-.031-.028-.092a.034.034,0,0,1,.028,0ZM27.5,37.808l.069.073c0,.015-.011.022-.025.006a.316.316,0,0,0-.047-.079Zm.13.108.027-.029-.027.03Zm4.559-3.424a.082.082,0,0,0,.007-.043l-.039-.04.01.087h0c-.024.013-.046.051-.066.154.01.052.02.1.026.156l-.03.048.007-.13a.248.248,0,0,0,0,.174.106.106,0,0,0-.034.062l.034.156c-.023.015-.034-.072-.058.027.015.074.056-.062.057.058-.034.069-.053.044-.047.133-.016.009-.021-.009-.021-.044a1.669,1.669,0,0,0-.012.245c-.047.068-.056.256-.107.232a.631.631,0,0,1-.023.208c-.011-.141-.1.244-.151.184.012.109-.127.313-.2.459a.066.066,0,0,1,.017-.039.885.885,0,0,1-.133.12c.029.04-.064.149-.1.226-.117.039.016-.085-.042-.094.035.029-.124.148-.075.151-.084.031-.065.038-.124.028.018.056-.062.048-.1.114-.123.03-.051-.035-.167.034-.064.007.036-.056.036-.056-.122.049-.042.063-.06.1-.153.064-.083-.008-.141-.014a.771.771,0,0,1-.243.1c-.007-.007-.021-.007-.005-.018-.1.052-.34.021-.473.07a.032.032,0,0,1-.018-.01.061.061,0,0,1,.023.059c-.067,0-.123.032-.149,0a.086.086,0,0,0,.063-.021l-.07.014c-.064-.038.1-.017.094-.048a2.351,2.351,0,0,1-.4.049c-.023-.039.245-.022.1-.052l.162.009c-.126-.059.1,0-.017-.063-.214,0-.238.029-.451.024-.047.024.017.033-.03.056-.3.05-.241-.093-.464-.029a.283.283,0,0,1-.239.066l.052-.05c-.218.02-.111.065-.352.093.038-.035.175-.056.14-.055-.163,0-.107.048-.22.093l-.041-.024a1.322,1.322,0,0,0-.292.239l-.126.134-.065.077c0-.021.01-.044,0-.048l-.007.01a.547.547,0,0,1-.07-.066c-.057-.057-.116-.116-.18-.172a1.081,1.081,0,0,0-.225-.154,1.241,1.241,0,0,0-.247-.062l-.119.021c-.026,0-.046-.021-.017-.024-.113-.025-.009.021-.067.028s-.084-.029-.041-.035a3.206,3.206,0,0,1-.8-.061l.043-.006c-.166-.032-.2.05-.348,0h.03a7.682,7.682,0,0,1-1.024-.15c-.061.046-.322-.1-.361-.044a3.139,3.139,0,0,1-.327-.246c-.054-.043-.106-.033-.181-.084l.023-.028-.108-.063-.01-.075-.055-.063c.017.028.027.068.016.07a.481.481,0,0,1-.133-.3,2.055,2.055,0,0,1-.15-.277c.015,0,.037.051.063.085-.1-.144.024-.041-.056-.176,0,.022-.024,0-.032-.006a2.62,2.62,0,0,0-.08-.38l.029.021a6.858,6.858,0,0,1-.1-.771c-.006.1-.05.079-.059,0l.036-.034c-.027-.05-.01.085-.045-.021,0-.1.04-.07.055-.013l-.018-.123c.011-.008.018.021.033.028-.025-.051.035-.215-.008-.288l.012-.007-.013-.63c-.033,0-.026-.093-.052-.16.011-.167.038-.351.036-.552-.016-.141-.028-.041-.048-.1.03-.01.028-.21.049-.106,0-.241,0-.308-.028-.612-.013.033-.018.07-.028.051,0-.055.013-.125.028-.118v.015c-.044-.342.091-.788.028-1.06v.015l-.022-.283c.006-.13.022.078.041-.018-.049-.3.009-.481-.024-.731a8.63,8.63,0,0,0,.054-.95l-.021.015c-.021-.068.012-.082.017-.132-.016.007-.019.073-.03.031-.023-.574.035-1.183.055-1.771.007-.215-.108-.122-.057-.393l.039.077-.015-.189a.14.14,0,0,1-.006-.041h.321a4.152,4.152,0,0,0,.462-.017c-.026.009-.026.021-.068.021a.657.657,0,0,0,.332-.017c.066,0,.015.021.056.033.09.017.226-.036.273-.008.008,0-.025.009-.042.011.058-.014.273,0,.217-.029.159.015.3-.015.432,0,.083-.036.273.018.3-.034-.011.053.279.043.38.018-.034.016.088.016.048.039.115,0,.221-.011.2-.038.211.063.426-.051.545.03.342-.029.658-.048.965-.061-.011.053-.34.006-.327.061a5.212,5.212,0,0,1,.749-.055c.075.007-.042.023-.068.032.291-.022.563,0,.822-.024,0,0-.029.01-.055.014.051,0,.118.008.113-.016l-.05.006c-.082-.035.2-.073.212-.091-.087.069.256.017.118.1.034,0,.076-.016.068-.032.05,0,.066.015.015.033.182-.013.118-.039.283-.038,0,.012-.034.016-.051.03a.783.783,0,0,1,.308-.035c-.008.007.008.016-.034.016a5.407,5.407,0,0,1,.674-.039c-.078.051.09.017.1.061l.142-.013-.057-.021a2.984,2.984,0,0,1,.341-.017l-.092.018.233-.008-.132-.017c.126-.022-.014-.056.152-.043a1.229,1.229,0,0,1,.189.027h0a.567.567,0,0,1,.217-.018c.024.014-.019.049,0,.058.061-.036.291-.01.368-.049-.026.009-.027.032-.019.037l.051-.03c.058.009.066.014.057.033.173,0-.055-.056.15-.032-.016,0-.008.007-.042.011a1.8,1.8,0,0,0,.232,0,1.629,1.629,0,0,1,0,.242c-.044.056-.011-.166-.048-.1.008.274.053.566.042.831l.005-.049c.063.036-.031.2,0,.331,0-.033-.035-.043-.028-.034a5.363,5.363,0,0,0,.035.645l-.016-.034c-.015.107-.008.281-.015.4.016.035.014.1.037.06-.091.356.049.679-.028.994,0-.038-.014-.09-.014-.06l.015.269c.027-.021.016-.035.038-.092a.525.525,0,0,1,.028.177c-.018-.121-.044,0-.059.053.008-.009.017.009.026,0-.049.14.055.023.022.215l-.014-.01a1.412,1.412,0,0,1,.022.216c-.032.032-.015-.077-.041-.082,0,.109.06.215.028.313l-.017-.159a.485.485,0,0,0-.034.2v-.006l-.017.184.01-.047c.082.136.015.277.069.46-.051-.179-.029-.029-.065-.043-.01.047-.021.118-.031.1.028.086-.023.145.019.266-.011.006,0,.093-.03.073.009.113.02-.027.035-.016.039.174-.048.408.006.658.02.2.055.253.075.418v.044c-.017.033-.037-.063-.037-.063a.96.96,0,0,0,0,.293c-.01-.021-.019,0-.031.032,0,.082.042.055.025.162a.255.255,0,0,1-.046-.082l.042.293c-.02.027-.03-.061-.043-.1a1.033,1.033,0,0,0,.049.327l.012-.071c0,.041-.028.021-.033-.009-.025-.1.011-.139.022-.145l.007.071c.067-.074-.011-.287-.007-.431l.04.049v1.112A.159.159,0,0,0,32.189,34.492Zm.442-7.035c-.008.02-.021.034-.031.026v-.151Zm-7.377-1.3h0Zm-.177,0c.011.011,0,.023-.032.022.017-.007-.056-.014-.1-.024Zm7.551,5.255a.045.045,0,0,1-.028,0v-.1c.011.01.021.035.027.1ZM32.6,28.319v-.125a.216.216,0,0,1,.028.082Z",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22228",
    "data-name": "Path 22228",
    d: "M31.057,28.594a2.747,2.747,0,0,0,.019-.35.48.48,0,0,0-.017-.151.36.36,0,0,0-.427-.237.311.311,0,0,1,.084-.035.377.377,0,0,0-.287.124.392.392,0,0,0-.1.285v.376a5.457,5.457,0,0,1-.052.766c.035-.182.073-.135.057.018l-.048.054c.007.1.041-.155.035.049-.039.191-.065.12-.058.009-.007.078-.021.154-.034.232-.014.011-.008-.044-.02-.061.009.1-.137.375-.147.514l-.016.008a2.294,2.294,0,0,1-.61.933c.016.031-.109.127-.2.214a2.772,2.772,0,0,1-.953.306c-.255.052-.071.039-.186.072-.092-.021-.166-.016-.1-.041-.02.007-.018-.009-.018-.021v-.3c0-.034-.023-.071.021-.071l.028-.007.089-.015a1.793,1.793,0,0,0,.2-.054c-.068,0-.14.017-.1,0a.553.553,0,0,1,.235-.033.159.159,0,0,1-.027.012,2.7,2.7,0,0,0,.957-.576,1.993,1.993,0,0,0,.536-.849,3.859,3.859,0,0,0,.132-.521c.056-.25-.009.156.048-.026.044-.3.063-.535.084-.758l.007-.166V28.21a.392.392,0,0,0-.021-.126.341.341,0,0,0-.435-.2l-.014.005a.319.319,0,0,0-.21.16.351.351,0,0,0-.043.16l-.006.1c-.009.143-.02.3-.041.47a2.18,2.18,0,0,1-.267.863l.031-.015a.462.462,0,0,1-.126.2c.02,0,.086-.1.056-.031a1.476,1.476,0,0,1-.514.564,1.291,1.291,0,0,1-.352.162,1.2,1.2,0,0,1-.163.045L28,30.57c-.021,0,0-.029-.006-.039L28,30.349c0-.2,0-.141.025-.153a1.47,1.47,0,0,0,.818-.449.616.616,0,0,0,.175-.336,3.086,3.086,0,0,1,.145-.425,1.489,1.489,0,0,1-.006.163,3.134,3.134,0,0,0,.1-.661,2.614,2.614,0,0,0,0-.354.364.364,0,0,0-.722.065c0,.106,0,.2-.009.3a1.835,1.835,0,0,1-.119.553.457.457,0,0,1,.025-.114,1.928,1.928,0,0,1-.165.277c-.068.088-.145.147-.141.158-.089.047-.044,0-.081.007-.017,0-.026.014-.047.02s-.014-.033,0-.042.009.007.012.009A1.133,1.133,0,0,1,28,29.149c0-.1-.006-.179-.022-.125.016-.306-.015-.584.005-.828a.669.669,0,0,1-.014-.148.365.365,0,0,0-.09-.253.277.277,0,0,0-.357-.074c0-.014-.048-.014-.12.034a.343.343,0,0,0-.141.289,3.682,3.682,0,0,0,.021.445c-.016-.065-.017.168-.039.092,0,.221.011.422.038.383a1.654,1.654,0,0,0-.009.466c0,.047-.083.02-.166-.062a.861.861,0,0,1-.4-.674,2.908,2.908,0,0,1-.036-.438.55.55,0,0,0-.014-.14.285.285,0,0,0-.094-.141.323.323,0,0,0-.308-.054c0-.014.075-.048.163-.034a.316.316,0,0,1,.259.216.343.343,0,0,1,.014.1v.166c.005.054.014.087.028.081l-.011-.194a.5.5,0,0,0-.018-.133.32.32,0,0,0-.08-.132.35.35,0,0,0-.252-.1.321.321,0,0,0-.237.1.362.362,0,0,0-.1.217v.186a3.8,3.8,0,0,0,.026.39c.015.143-.035-.081-.046-.131a2.286,2.286,0,0,0,.234.827,1.209,1.209,0,0,0,.6.562A.377.377,0,0,1,26.735,30c.094.055.224.113.222.085l-.1-.034c-.07-.053.033-.019.156.007a.874.874,0,0,0,.27.022c-.068.02,0,.04.048.049,0,.082-.011.166-.06.092v.017l.007.045c.006.026.013.042.021.035,0,.1-.014.126-.033.029l.012.188a.127.127,0,0,0,.013.044c0,.014.051.094-.067.061,0-.013.03-.013.034-.026a.41.41,0,0,1-.13.012,1.216,1.216,0,0,1-.308-.086c.016,0-.007-.021.062.009a1.509,1.509,0,0,1-.936-.754c.113.1-.066-.153-.03-.2a2.516,2.516,0,0,1-.106-.237l.016.1a2.283,2.283,0,0,1-.17-.612c.015.056.028.112.047.167a3.68,3.68,0,0,1-.068-.431,1.71,1.71,0,0,0,.012.248c-.053-.232-.055.033-.075-.281a2.937,2.937,0,0,1,.013-.363.27.27,0,0,0-.309-.224.341.341,0,0,0-.055.014c-.058.011.023-.063-.015-.057a.34.34,0,0,0-.163.37,1.364,1.364,0,0,0,.044.366c-.014-.049-.037-.05-.04-.033l.039.1c0,.112,0,.129-.022.113.046.335.037-.113.077.285-.007-.031-.009-.015-.024-.078a3.224,3.224,0,0,0,.381,1.077c.015.119-.167-.281-.14-.153a2.334,2.334,0,0,0,1.114,1.04c.089-.022.346.181.616.191-.063-.008-.09.017-.071.014.192.069.341-.022.3.149,0,.093.009.192.014.3-.006.029.024.1-.012.1h-.134a.256.256,0,0,0,.046-.011,4.168,4.168,0,0,1-.707-.155c-.066,0-.181-.049-.119,0a4.055,4.055,0,0,1-.806-.505,1.687,1.687,0,0,1-.514-.731c.033.063.089.143.064.093A2.8,2.8,0,0,1,24.94,30c-.013.047.006.068.022.176a1.152,1.152,0,0,1-.133-.31c.081.217.041-.014.03-.113,0,.018-.021-.013-.028,0-.01-.271-.07-.03-.1-.4l.017.017a2.533,2.533,0,0,1-.069-.406c.026-.064.026.144.055.151a2.325,2.325,0,0,1-.062-.594c.01.088.014.215.028.3a2.4,2.4,0,0,0,.023-.38v.015l.008-.175a.379.379,0,0,0-.03-.215.3.3,0,0,1,.028.121.3.3,0,0,0-.371-.206l-.02.006a.244.244,0,0,0-.145.2,1.524,1.524,0,0,0,.021.253c-.051-.342-.029-.056-.065-.083-.01.09-.019.228-.03.189a3.864,3.864,0,0,0,.046.516c-.011.012.018.18-.015.145.034.217.014-.054.031-.037a4.181,4.181,0,0,0,.3,1.241,2.933,2.933,0,0,0,.5.724c.063.115-.1-.06-.1-.06a1.6,1.6,0,0,0,.374.428c-.035-.021-.013.015.026.065.126.1.107.039.268.176a.517.517,0,0,1-.158-.058,2.761,2.761,0,0,0,.511.267c.038.042-.119-.025-.187-.049a1.784,1.784,0,0,0,.606.21l-.129-.056c.075.026.029.04-.028.025-.187-.045-.246-.118-.251-.132l.129.051c-.1-.11-.5-.234-.714-.43.04.013.079.026.12.035a2.1,2.1,0,0,1-.241-.155c-.021-.031-.03-.057-.012-.056h0a3.206,3.206,0,0,0,2.131.856c-.013,0-.025.018-.036.053l-.076.031h.066a1.593,1.593,0,0,0-.031.226l.034.3-.027.1V32.7a.909.909,0,0,0,.013.341.319.319,0,0,0-.029.128l.052.3c-.021.036-.042-.134-.055.066.025.14.048-.134.064.1-.025.146-.045.1-.024.274-.014.024-.023-.012-.029-.08a4.288,4.288,0,0,0,.036.482c-.031.152.008.514-.044.5a.438.438,0,0,0,.017.083.427.427,0,0,1,.018.068.209.209,0,0,1-.055.008c.023-.015.012-.023,0-.028h-.132c-.155,0-.332,0-.3-.037a1.989,1.989,0,0,1-.455.037h-.29a.989.989,0,0,0-.316.037l.017-.007a.351.351,0,0,0-.265.331h0c.017,0,.029.014.053.037a.2.2,0,0,0,.1.05l-.057.023-.016-.005c-.071-.02-.05-.033-.048-.046s0-.026-.041-.046c.018.012.025.02.02.026a.112.112,0,0,1-.037.019c-.016.006-.077.013-.044.024a1.141,1.141,0,0,1-.259-.05c-.021.032-.082.041-.154.082a.319.319,0,0,0-.165.23.57.57,0,0,0-.028.242c.01.022-.009.093.175.219.09.056.046.048-.025.015a.242.242,0,0,1-.062-.042c.109.1.176.083.176.083s-.015-.036.031-.036a1.665,1.665,0,0,0,.2.012c.033,0,.045.008.051.014s-.006.029.053.04c.213-.012.377-.052.536-.05.012.007.043.01.007.019.225-.035.669,0,.932-.045a.135.135,0,0,1,.034.011c-.042-.022-.049-.044-.04-.06.128,0,.238-.028.286,0a.316.316,0,0,0-.122.02l.134-.013c.121.041-.183.014-.183.044.262-.013.568-.047.768-.035.042.04-.47.014-.2.049l-.311-.015c.238.063-.189,0,.029.063.409.012.457-.02.865-.008.092-.022-.03-.033.062-.055.58-.04.456.1.883.047a.89.89,0,0,1,.457-.05l-.1.045a1.032,1.032,0,0,0,.313-.027.638.638,0,0,1,.108-.015,1.04,1.04,0,0,0,.255-.017c-.13.063-.34.029-.287.044a.9.9,0,0,0,.147.011.239.239,0,0,0,.1-.022.568.568,0,0,0,.193-.155.313.313,0,0,0,.068-.03.4.4,0,0,0-.167-.54.448.448,0,0,0-.083-.033,1.258,1.258,0,0,0-.281-.005l-.083.005H29.6a.077.077,0,0,0,.028-.023.08.08,0,0,1-.039.024H29.6a.08.08,0,0,0,.068-.031s.006.007.047-.023a.071.071,0,0,0,.01-.033.348.348,0,0,0-.138-.287.43.43,0,0,0-.283-.068l-.435-.006-.835-.029a.133.133,0,0,1-.055.029l-.005,0c0-.019.015-.035.022-.026.013-.05-.022.007-.035-.023,0-.124.02-.166.03-.086a11.652,11.652,0,0,1-.021-1.518l.01.08c.014-.32-.07-.361-.038-.659l.006.057V32.4c0-.016-.011-.051.019-.043h.06l.135-.012c.09-.01.179-.021.267-.036a4.652,4.652,0,0,0,.933-.261,3.315,3.315,0,0,1,.34-.223c.143-.1.267-.209.259-.251a2.2,2.2,0,0,0,.592-.65,2.855,2.855,0,0,0,.136-.4l.035.008c.024-.084.038-.171.054-.256.029-.039.057-.078.083-.118l.04-.175c-.021.069-.057.141-.064.128a5.875,5.875,0,0,1,.184-.66,6.2,6.2,0,0,0,.028-.654.323.323,0,0,1,.014.106c0-.18.045,0,.024-.277C31.076,28.665,31.069,28.6,31.057,28.594ZM25.8,35.477a.236.236,0,0,0,.071.014.1.1,0,0,1-.07-.014Zm3.579.014a.318.318,0,0,0,.052-.01l-.007.01Zm-3.908-4.5a.03.03,0,0,1-.012.021c-.04-.043-.075-.089-.111-.134a.679.679,0,0,1,.124.11Zm-1.009-.811V30.1c.023.071.054.14.081.211a.723.723,0,0,1-.078-.137Zm2.948,2.076v.028a.372.372,0,0,0-.045-.033.232.232,0,0,1,.046,0Zm2,2.737a.307.307,0,0,1,.164.076c.011.029-.014.009-.077-.026.019.007-.007-.016-.059-.033a1.29,1.29,0,0,0-.152-.02.937.937,0,0,1,.129,0Z",
    fill: "#2d82f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22229",
    "data-name": "Path 22229",
    d: "M20.2,21.252c-.011.033-.043,0-.035-.035.024-.1.109-.081.118-.067a.176.176,0,0,0-.044.042c.056.014.1-.014.158-.027a.8.8,0,0,1,.188-.04l-.036.058h-.167a.158.158,0,0,0-.158.158h0V21.5a.158.158,0,0,0,.158.159h.011a.405.405,0,0,0-.012.084.075.075,0,0,0-.05-.016.281.281,0,0,1-.064.039.278.278,0,0,0,.115.009v-.007c.008.035.037.069.118.1l.118-.046.038.039h-.1c.057.037.093,0,.133-.018a.078.078,0,0,0,.05.042l.117-.077c.014.031-.052.063.026.08.055-.035-.053-.07.038-.094.057.036.04.066.107.035.01.021,0,.034-.031.043.06-.025.158-.011.189-.053.059.044.2-.012.2.064a.344.344,0,0,1,.16-.063c-.1.091.2.006.178.1.074-.082.267-.036.4-.082-.007.006-.021.02-.033.015a.484.484,0,0,1,.142.047c.01-.068.125-.083.186-.125.091.065-.055.079-.027.142,0-.055.157-.055.126-.1.069.041.06.02.1.076.012-.084.064-.014.121-.066.1.042.026.079.136.054.052.026-.045.056-.045.056.112,0,.052-.062.076-.1.133-.018.062.047.107.079.083-.017.147-.076.21-.073,0,.01.016.014,0,.028.088-.051.262,0,.364-.066a.065.065,0,0,1,.013.016.145.145,0,0,1-.016-.087c.05,0,.093-.041.112,0-.031,0-.033.015-.048.028l.053-.018c.047.06-.072.021-.072.065a1.016,1.016,0,0,1,.3-.052c.016.058-.184.02-.079.071l-.122-.022c.093.092-.074-.007.012.092.16.017.179-.03.338-.013.036-.033-.012-.048.024-.081.227-.058.178.147.345.07.043-.039.06-.113.179-.074l-.041.066c.155.007.089-.1.251-.05-.029.026-.122.022-.1.029.105.052.075-.037.155-.037l.017.059c.165-.009.346-.052.529-.063-.01.018-.041.036,0,.054a2.751,2.751,0,0,1,.713.042l.085-.05c.02,0,.037.023.015.033.086.019,0-.032.046-.052.049,0,.065.029.034.044a1.258,1.258,0,0,1,.6-.038l-.032.015c.126.021.141-.1.258-.057l-.022.009a3.519,3.519,0,0,1,.78.052c.04-.073.269.033.287-.069a1.116,1.116,0,0,0,.33.1c.058,0,.087-.063.159-.074v.053l.1-.056.052.063.068-.014c-.027,0-.057-.024-.053-.039a.32.32,0,0,1,.26.064l.25-.045c-.006.021-.048.029-.081.042.133-.054.024.056.147.006-.016-.012.009-.031.012-.042a.635.635,0,0,0,.3.019l-.02.037c.185.009.391-.018.6-.017-.075-.017-.057-.08,0-.086l.024.056c.04-.035-.064-.021.017-.063.078.006.052.063.007.082l.095-.02c.006.017-.017.026-.022.047.039-.035.163.056.219,0l0,.017c.208,0,.3-.019.472-.021,0-.049.07-.038.12-.077a2.49,2.49,0,0,0,.413.049c.1-.024.031-.041.078-.07.008.044.158.04.08.072a2.723,2.723,0,0,0,.458-.045c-.025-.018-.053-.026-.038-.041.042-.007.094.019.088.04h-.011c.256-.066.59.129.794.037H33.11l.213-.038c.1.007-.058.033.014.061.228-.074.36.01.548-.039a.254.254,0,0,0,.145.055.835.835,0,0,0,.1,0,.781.781,0,0,0,.18-.014.41.41,0,0,0,.259-.2c.058-.082.031-.239.06-.348l-.029.031c-.027-.1.02-.137,0-.2-.014.021.006.1-.024.058a.4.4,0,0,0-.43-.238,3.3,3.3,0,0,1-.347-.02l-.667-.06c-.161-.008-.091.159-.295.085l.058-.057c-.325.068-.665,0-.983.056.019-.013.02-.03.051-.03-.067-.042-.249,0-.25.032-.05,0-.012-.03-.042-.048-.067-.023-.169.054-.2.013-.006-.007.019-.014.031-.016-.044.02-.2-.005-.162.042-.12-.023-.229.021-.324-.007-.062.053-.2-.026-.224.05.008-.078-.209-.063-.285-.027.025-.023-.066-.025-.036-.056-.086,0-.165.015-.15.055-.159-.092-.319.076-.408-.043-.256.042-.493.07-.723.089.008-.078.254-.008.245-.09a2.178,2.178,0,0,1-.561.08c-.056-.011.032-.034.05-.047-.218.032-.422-.007-.616.035,0-.007.021-.015.041-.021-.038,0-.089-.011-.084.024l.037-.01c.061.051-.152.107-.159.134.065-.1-.192-.026-.089-.154-.025.007-.056.023-.051.047-.037-.007-.049-.021-.011-.048-.137.019-.088.057-.212.056,0-.017.025-.024.038-.044a.35.35,0,0,1-.231.052c.006-.01-.006-.024.025-.023a2.274,2.274,0,0,1-.5.056c.058-.074-.067-.025-.078-.089l-.106.019.042.031c-.093,0-.175.046-.255.025l.069-.027-.175.012.1.024c-.094.033.01.082-.114.064.025-.007-.093,0-.142-.04h0a.235.235,0,0,1-.162.027c-.018-.021.014-.071,0-.085-.045.054-.218.015-.276.071a.049.049,0,0,0,.014-.054l-.038.043c-.043-.014-.049-.021-.042-.048-.13-.008.042.082-.113.047.012,0,.006-.009.031-.016-.154-.019-.3.028-.441.006-.042-.064.125-.016.077-.07a5.019,5.019,0,0,1-.623.063l.037.007c-.028.092-.147-.045-.248,0,.024-.007.032-.051.026-.041a2.128,2.128,0,0,0-.484.05l.025-.023a2.523,2.523,0,0,0-.3-.022c-.026.023-.075.02-.045.054-.267-.134-.508.071-.745-.04.028,0,.067-.021.045-.021l-.2.021c.016.04.026.024.069.055a.228.228,0,0,1-.133.042c.091-.027,0-.064-.04-.086.007.012-.007.026,0,.038-.1-.071-.017.08-.161.032l.007-.021a.563.563,0,0,1-.162.033c-.024-.046.057-.021.061-.06-.082,0-.161.087-.234.042.035-.013.084-.013.119-.026a.218.218,0,0,0-.149-.049h.006l-.138-.025.035.014c-.1.119-.207.021-.345.1.134-.075.022-.043.033-.1-.035-.014-.089-.031-.073-.045-.065.042-.108-.034-.2.028,0-.017-.069,0-.055-.044-.084.014.02.029.013.05-.13.057-.306-.07-.493.009-.149.03-.189.08-.313.11h-.033c-.024-.025.047-.054.047-.054a.372.372,0,0,0-.219,0c.015-.014,0-.027-.024-.047-.064,0-.035.062-.128.036a.392.392,0,0,1,.067-.068.772.772,0,0,0-.257.086c-.041-.014.027-.063.059-.082-.127.012-.229.2-.172.246A.185.185,0,0,1,20.2,21.252Zm5.23.537h0Zm.124,0a.022.022,0,0,1,.007-.03.022.022,0,0,1,.016,0c-.012.012.04.021.072.035Zm-2.118-.643a.141.141,0,0,1,0,.041h-.069c.008-.019.023-.034.069-.044Zm-2.209,0,.03.041h-.088a.107.107,0,0,1,.055-.043Zm-.577-.006a.039.039,0,0,1,.012.046h-.1Z",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22230",
    "data-name": "Path 22230",
    d: "M32.509,43.877c0-.025.039,0,.046.018.035.078-.02.089-.037.082a.2.2,0,0,0-.006-.049c-.075,0-.028.181-.145.207a.416.416,0,0,0-.006-.071.151.151,0,0,0,.1-.136v-.159a.158.158,0,0,0-.157-.159h-.009a.6.6,0,0,0,.009-.084.038.038,0,0,0,.036.015.272.272,0,0,1,.048-.048.243.243,0,0,0-.085,0V43.5a.126.126,0,0,0-.086-.094l-.087.049-.028-.039h.073c-.042-.037-.068,0-.1.018a.068.068,0,0,0-.036-.043l-.085.077c-.01-.031.038-.063-.019-.08-.04.036.038.07-.028.094-.041-.036-.029-.066-.078-.035-.007-.02,0-.034.023-.043-.043.025-.114.011-.137.053-.043-.045-.146.012-.142-.064a.245.245,0,0,1-.116.063c.073-.091-.149-.006-.129-.1-.054.082-.195.036-.29.082.006-.006.016-.02.024-.015-.054-.007-.069-.032-.1-.047-.007.068-.09.083-.135.125-.065-.065.04-.079.02-.142,0,.055-.114.055-.092.1-.05-.041-.043-.02-.069-.076-.009.084-.047.014-.089.066-.073-.042-.019-.079-.1-.054-.038-.026.033-.056.033-.056-.081,0-.038.062-.056.1-.1.018-.045-.047-.078-.079-.061.017-.107.076-.152.073,0-.01-.012-.014,0-.027-.064.05-.19,0-.265.066a.039.039,0,0,1-.01-.016.211.211,0,0,1,.012.087c-.036,0-.068.041-.081,0,.022,0,.024-.015.035-.028l-.038.018c-.035-.06.052-.021.052-.065-.075.019-.161.069-.218.052-.012-.058.133-.02.057-.071l.088.022c-.068-.092.054.006-.008-.092-.116-.017-.13.03-.246.013-.026.033.009.048-.017.081-.165.058-.13-.148-.251-.069-.031.039-.043.113-.13.074l.029-.066c-.112-.006-.064.1-.182.051.021-.026.088-.022.071-.03-.077-.052-.054.037-.112.037l-.013-.058c-.119.009-.252.051-.384.062.007-.017.03-.036,0-.054a1.442,1.442,0,0,1-.519-.042l-.062.05c-.014,0-.027-.023-.011-.033-.063-.019,0,.032-.034.052-.036,0-.047-.029-.025-.044a.672.672,0,0,1-.433.038l.023-.015c-.091-.02-.1.1-.187.056l.016-.009a1.864,1.864,0,0,1-.567-.052c-.029.073-.2-.032-.209.069-.113-.05-.08-.069-.239-.1-.043,0-.063.064-.116.074V43.41l-.071.056-.038-.064-.049.014c.02,0,.042.024.039.039a.192.192,0,0,1-.182-.068l-.182.045c0-.021.035-.029.059-.043-.1.054-.018-.056-.107-.005.012.012-.006.03-.008.042a.34.34,0,0,0-.22-.019l.014-.036c-.135-.01-.285.016-.436.016a.044.044,0,0,1,.033.053.04.04,0,0,1-.033.033l-.018-.056c-.028.036.046.022-.013.065-.056-.008-.038-.065-.006-.082l-.069.018c0-.017.012-.026.016-.046-.028.033-.119-.056-.16,0v-.017c-.151,0-.22.018-.343.021,0,.049-.05.038-.087.077a1.335,1.335,0,0,0-.3-.05c-.077.024-.022.041-.057.07-.006-.044-.114-.04-.058-.072a1.492,1.492,0,0,0-.333.045c.018.018.038.026.028.041-.03.007-.068-.019-.064-.04h.008c-.186.066-.429-.129-.577-.037h.008l-.154.047c-.07-.008.042-.032-.01-.06-.18.073-.231-.011-.43.039a.27.27,0,0,0-.365.111l-.007.015a.377.377,0,0,0-.044.117v.157a2.379,2.379,0,0,0-.005.267l.022-.028c.049.04.017.077.042.12.012-.019-.018-.072.017-.051a.4.4,0,0,0,.338.149,2.561,2.561,0,0,1,.276.02l.485.06c.117.008.067-.158.214-.085l-.042.057c.236-.068.483,0,.715-.056-.014.013-.014.03-.037.03.049.041.181,0,.182-.032.036,0,.008.03.03.048.049.024.123-.053.149-.012,0,.007-.014.013-.022.016.032-.02.148.005.118-.042.087.023.166-.021.235.007.045-.053.148.026.163-.05-.006.078.152.063.207.027-.019.023.048.024.026.057.063,0,.12-.016.109-.056.115.093.232-.075.3.044a4.893,4.893,0,0,1,.526-.089c-.006.078-.185.008-.178.09a1.184,1.184,0,0,1,.408-.08c.041.011-.023.034-.037.047.158-.032.307.007.448-.035,0,.007-.015.015-.03.021.028,0,.064.011.062-.024l-.027.01c-.045-.051.11-.107.115-.134-.047.1.14.026.064.154.018-.006.041-.023.037-.047.028.007.036.021.008.048.1-.019.064-.056.155-.056,0,.017-.019.024-.028.044a.2.2,0,0,1,.168-.052c0,.01,0,.024-.019.024.131-.006.224-.089.367-.057-.042.074.049.025.056.089l.077-.019-.031-.031c.068,0,.127-.046.186-.024l-.05.026.127-.012-.085-.031c.069-.033-.007-.082.083-.065-.019.008.068,0,.1.04h0a.129.129,0,0,1,.118-.027c.013.022-.011.071,0,.085.033-.054.159-.015.2-.071a.058.058,0,0,0-.01.054l.028-.043c.031.014.035.021.031.047.094.009-.03-.082.082-.046-.009,0,0,.01-.023.016.113.018.218-.027.321-.005.03.064-.09.016-.056.07a2.761,2.761,0,0,1,.453-.064l-.027-.007c.02-.092.107.045.18,0-.018.007-.023.051-.019.041a1.1,1.1,0,0,0,.351-.051l-.017.026a1.718,1.718,0,0,0,.216.023c.019-.024.055-.02.033-.054.194.134.37-.071.541.04-.021,0-.049.021-.033.021l.147-.03c-.012-.04-.019-.024-.05-.055a.131.131,0,0,1,.1-.042c-.066.027,0,.064.029.086a.1.1,0,0,0,0-.039c.077.071.013-.08.117-.031l-.006.021c.039-.011.075-.038.117-.033.018.046-.041.022-.044.06.059,0,.117-.087.171-.042-.025.013-.062.013-.087.026a.135.135,0,0,0,.108.049h0l.1.024-.025-.015c.074-.12.151-.022.251-.1-.1.075-.016.043-.023.1.025.014.064.031.053.046.047-.043.078.032.145-.029,0,.017.05,0,.04.044.062-.014-.015-.029-.009-.051.1-.057.222.069.358-.009.109-.03.14-.08.231-.11h.02c.018.025-.034.054-.034.054a.233.233,0,0,0,.183,0c-.007.015.011.026.041.039.053-.023,0-.059.077-.079a.137.137,0,0,1-.006.085.258.258,0,0,0,.081-.2c.032,0,.03.062.028.1a.245.245,0,0,0-.03-.246Zm-3.872-.4h0Zm-.09,0c.006.017,0,.034-.017.033.009-.012-.029-.022-.053-.036Zm1.719.643a.141.141,0,0,1,0-.041h.05a.062.062,0,0,1-.047.049Zm1.606,0-.022-.041h.064a.107.107,0,0,1-.045.049Zm.436,0a.054.054,0,0,1-.026-.045h.026c.019,0,.033-.014.049-.022a.2.2,0,0,1-.049.078Z",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18555",
    "data-name": "Group 18555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22231",
    "data-name": "Path 22231",
    d: "M30.29,48.9H25.485a.512.512,0,0,0-.512.512h0v1.246h1.933a1.012,1.012,0,0,1,1.964,0H30.8V49.413a.512.512,0,0,0-.512-.512Z",
    fill: "#2d82f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22232",
    "data-name": "Path 22232",
    d: "M27.887,51.918a1.013,1.013,0,0,1-.982-.768H24.972V52.4a.512.512,0,0,0,.512.512h4.805A.513.513,0,0,0,30.8,52.4h0V51.15H28.869A1.016,1.016,0,0,1,27.887,51.918Z",
    fill: "#2d82f7"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_442",
    "data-name": "Ellipse 442",
    cx: 0.729,
    cy: 0.729,
    r: 0.729,
    transform: "translate(27.158 50.176)",
    fill: "#2d82f7"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18557",
    "data-name": "Group 18557"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_150",
    "data-name": "Ellipse 150",
    cx: 23.444,
    cy: 23.444,
    r: 23.444,
    transform: "translate(26.755 8.488)",
    fill: "#d2e4ff",
    opacity: 0.6,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_151",
    "data-name": "Ellipse 151",
    cx: 18.906,
    cy: 18.906,
    r: 18.906,
    transform: "translate(31.293 13.026)",
    fill: "#bbdaff",
    opacity: 0.8,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 14.33,
    cy: 14.33,
    r: 14.33,
    transform: "translate(35.869 17.602)",
    fill: "#2d82f7",
    opacity: 0.2,
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 10.817,
    cy: 10.817,
    r: 10.817,
    transform: "translate(39.382 21.115)",
    fill: "#2d82f7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23442",
    "data-name": "Path 23442",
    d: "M41.917,19H62.032c5.494,0,4.316,4.454,4.316,9.947v32.5A9.948,9.948,0,0,1,56.4,71.4H48.18a9.947,9.947,0,0,1-9.947-9.947v-32.5C38.233,23.458,36.424,19,41.917,19Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18558",
    "data-name": "Group 18558"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22233",
    "data-name": "Path 22233",
    d: "M60.264,21.038h-.01v-.009a.2.2,0,0,0,.017-.053.387.387,0,0,0,.049.01.267.267,0,0,1,.066-.026.33.33,0,0,0-.121-.014h0c-.014-.027-.057-.051-.166-.071l-.168.038-.054-.03h.141a.25.25,0,0,0-.188.014.108.108,0,0,0-.07-.034l-.165.06c-.02-.025.074-.049-.037-.063-.077.028.074.055-.054.074-.08-.028-.057-.052-.151-.027-.013-.016.007-.027.044-.034-.084.02-.222.008-.266.042-.084-.035-.283.009-.275-.05a.823.823,0,0,1-.225.049c.141-.071-.289,0-.252-.08-.1.064-.377.028-.562.064a.077.077,0,0,1,.047-.012,1.037,1.037,0,0,1-.2-.037c-.014.053-.175.065-.263.1-.127-.051.077-.062.037-.111.006.043-.222.043-.178.079-.1-.033-.084-.015-.134-.059-.017.066-.091.011-.172.052-.141-.034-.036-.063-.191-.042-.074-.021.064-.044.064-.044-.158,0-.074.049-.108.078h-.052c-.113,0-.053-.043-.1-.062h0c.008,0-.024.007-.02.01l-.01.012c-.006.008-.029.017-.016.023.032.01-.057-.013-.077-.013s-.026-.015,0-.022a.262.262,0,0,1-.056,0v0h-.014v-.031a.161.161,0,0,0,0,.031h-.009v0h-.006a.022.022,0,0,1-.022,0h-.026v0h0v0h0v0h0v-.017c0-.007-.005.014-.008.014h0v-.015h0v-.013s0,.014-.006.016v.008h-.023l.007.006h-.007v.026c0-.1-.007.007-.01-.057v.087h-.012v.029l-.017-.01v-.04l-.009.012a.06.06,0,0,0,0,.019h-.013a.185.185,0,0,0-.007-.041l-.013.031h0v-.026h.012c-.006-.029-.011,0-.017.014v-.028h0a.1.1,0,0,0-.033-.023H56.07a.043.043,0,0,1,0-.016l-.005.017h-.056v0h-.021v-.02a.067.067,0,0,1,0,.02h-.049a.068.068,0,0,1,.006-.04c-.009,0-.009.019-.009.041h-.012v-.027a.085.085,0,0,0-.013.027h-.076v-.021c-.02-.013-.023.023-.042.009a.024.024,0,0,0,0,.012h-.018l-.013,0c0-.01-.006-.014-.01,0a.15.15,0,0,1-.047-.04c.014.016,0,.042-.042.059v-.044l-.106-.014-.125.034c-.028,0-.051-.02-.02-.026-.053-.009-.093-.006-.071,0s.037.027-.015.031h-.021l-.008,0c-.009-.008,0-.017.013-.023a.126.126,0,0,1-.033,0h0l.008-.013a.011.011,0,0,1-.012.007v.01h-.024v-.007c-.009-.019-.011-.007-.014.009h-.019v0H55.2v.02h-.013a.073.073,0,0,1-.007-.03l-.031.035a.084.084,0,0,1,.01-.033c-.017.042,0-.044-.018,0a.1.1,0,0,1,0,.025c-.008,0-.011-.034-.024-.014H55.1V20.8c-.023-.008-.048.013-.074.012a.11.11,0,0,1,0,.051h-.006v-.024a.024.024,0,0,0,0,.012h0c0,.008,0,.01-.007.013a.1.1,0,0,1,.005-.035l-.012.014V20.8c0,.027-.02-.045-.027,0v.01c-.026,0-.037.014-.059.016,0,.038-.009.029-.016.06-.015-.012-.032-.042-.05-.04a.061.061,0,0,0-.009.042h0c0-.018-.014-.024-.006-.044a.079.079,0,0,0-.043.023l-.013-.008h0l.01.01-.008.006v-.016h0v-.006l-.048.009c-.02-.026-.039-.059-.054-.019h0l-.027.037c-.012-.006.007-.026,0-.048-.029.057-.044-.009-.068.029-.016-.1-.068.006-.081-.06v.024c-.007.023-.007-.014-.011-.02,0,.019.006.022,0,.035a.039.039,0,0,1-.02.006c-.005.023,0-.038,0,.028h0v.011h-.016v0h-.2l-.141-.015h0a.269.269,0,0,0-.046-.014c-.006,0-.01,0-.013.007v0l-.006.017h-.035v-.006a.017.017,0,0,0-.013.006h-.3a.045.045,0,0,0-.016-.015l.013-.013a.028.028,0,0,1-.021.007v.02h-.009v0h-.042v-.009c-.016-.017-.02-.006-.024.009-.065,0-.13-.01-.194-.02V20.86h-.01a.114.114,0,0,1-.067.019v-.055h-.085l.057-.025a.248.248,0,0,0-.072.005v.063h0v.007a.042.042,0,0,0-.033.026c-.109-.021-.148-.035-.2-.046a.83.83,0,0,0-.093-.016l-.072-.009a.369.369,0,0,1-.082-.012.176.176,0,0,0-.079,0,.3.3,0,0,0-.05.019.392.392,0,0,1-.12.034v-.041l-.138.044h-.006c-.014-.006.017-.012-.011-.019l-.038-.027-.1.01c.039,0,.081.019.074.031h-.1a.572.572,0,0,1-.255-.056l-.272.023h-.04l.028-.012h0l-.028.012H51.6l.048-.014a.115.115,0,0,1-.037,0l-.05.012-.018.028-.005.007h0l.006-.008.021-.031.041-.008c-.034-.008.005-.042-.116-.014.023.009-.012.025-.016.034a.961.961,0,0,0-.233-.019h-.165l.017-.018h-.419l-.291,0c.1.013.078.063-.008.068l-.032-.044c-.057.027.089.017-.027.05-.109,0-.071-.05-.008-.065l-.134.015c-.007-.013.025-.02.034-.037-.038.019-.128-.008-.207-.012h-.02a.146.146,0,0,0-.092.016l-.007-.013h-.12V20.8h-.039a.311.311,0,0,0-.061,0,.405.405,0,0,0-.11,0,.161.161,0,0,0-.054.009h-.081c-.008.036-.1.034-.158.058h-.049l-.263-.016H48.7a.234.234,0,0,0-.064.012l.051.007c-.042,0-.018.016-.04.023l-.043-.006a.073.073,0,0,1-.017.012c-.007-.017-.063-.021-.1-.024-.02,0-.039,0-.036-.007s-.007-.008.024-.016h-.035l.041-.031-.464.056h-.035l.023.008.006.019h0v-.005a.435.435,0,0,1-.052-.006v-.015h-.018c-.012,0-.02-.011-.017-.017h.015c-.35.056-.828-.107-1.119-.036h.016l-.136.016a.192.192,0,0,0-.074-.043H46.6V20.8h.033a.186.186,0,0,1,.068.039h-.018a.131.131,0,0,0-.057-.03H46.6l-.005.047h0l.005-.047h0l-.006.047h-.029v.027a.194.194,0,0,1-.054-.038l-.013.039v-.026c-.012-.015,0,.025-.007.041s-.009-.023,0-.035l-.016.02c-.014-.015-.027.008-.04.025a.026.026,0,0,1-.029-.017v-.012c-.009-.009-.014.013-.019.031a.161.161,0,0,0-.012-.033c-.012-.016-.017.014-.023.034h-.014v-.08h0v.01h0v-.01H46.22l.012-.006.026-.01a.054.054,0,0,1,.025-.006h.054V20.8H46.28a.168.168,0,0,0-.049.017l-.013.007H46.2V20.82a.013.013,0,0,1-.011.005h-.251s-.023.006-.015.006l0,0h0l-.02-.007H45.9c0-.006-.009-.008-.012,0h-.016v-.031a.984.984,0,0,0-.133,0,.383.383,0,0,0-.08.006.373.373,0,0,0-.1.023h-.173V20.8l-.1-.007a.5.5,0,0,1-.056-.01l.016.024c-.072.023-.087-.014-.141-.02.008.019.079.022.034.035h-.772a.428.428,0,0,0-.272.114h0a.368.368,0,0,0-.1.4.438.438,0,0,0,.277.266l.1-.186-.076.182.388.032a.378.378,0,0,0,.1,0v-.061a.317.317,0,0,1,.19.013l-.078.04h.3l.012-.006h.316l.336-.006V21.6h0v0h.024l.151-.011c-.027.01-.027.024-.072.023a.66.66,0,0,0,.36-.024h.019a.134.134,0,0,1-.007-.052.115.115,0,0,1,.068-.1l.006.192c.1,0,.214-.048.262-.021.009,0-.027.012-.045.015a1.926,1.926,0,0,1,.2-.017h.007c.01,0,.01-.008-.005-.017.2.029.338-.017.474,0a.153.153,0,0,1,.067-.015h.046v-.019l.007-.037c.022-.053-.006-.088.027-.087v.151c.074,0,.145.008.16-.025-.006.03.064.042.149.043h0a1.242,1.242,0,0,0,.242-.03c-.036.02.1.017.056.043h.062v0A.261.261,0,0,0,48.2,21.6c.015-.006.021-.014.014-.024a1.408,1.408,0,0,0,.458,0,.342.342,0,0,0,.072.016.1.1,0,0,1,.057.024c.218-.019.425-.034.618-.046h.032c.1-.007.2-.012.293-.015-.011.051-.265.016-.324.049v.019a4.368,4.368,0,0,1,.775-.057c.084.006-.047.028-.074.038.063,0,.122-.008.193-.017l.033,0h.18V21.56l.052,0h0c.011-.009.017-.019.013-.027a.044.044,0,0,0-.013-.014h.033a.627.627,0,0,0,.152-.043c-.046.04.022.045.082.053.044.006.07.014.066.034l.007-.044c0-.021.011-.042,0-.049s0-.023.011-.019h0v.139c.018-.006.031-.015.026-.026.052.006.069.017.016.037.194-.014.125-.044.3-.042,0,.013-.036.019-.054.034a.782.782,0,0,1,.326-.04c-.009.008.008.019-.036.018a5.464,5.464,0,0,1,.712-.041c-.082.058.1.019.109.07l.15-.014-.06-.025h.051v.014l.06.012v-.03h.019v-.023a.5.5,0,0,1,.077,0l-.011-.007.019.005h-.009l.008.006h.035a.081.081,0,0,1,.031-.006l-.016-.01a.018.018,0,0,1-.006-.019h0a.513.513,0,0,1,.1.007.087.087,0,0,1,.036.013h0a.032.032,0,0,1,0,.027s-.005.017-.027.014v.012c0,.005.025,0,.022.005a.263.263,0,0,1,.111-.023h.031l.078-.006a.376.376,0,0,0,.123-.03c-.026.011-.028.038-.02.043a.6.6,0,0,1,.051-.032.449.449,0,0,1,.059.019c.01,0,.009.012,0,.022.183.006-.058-.064.159-.036-.017,0-.009.008-.044.013h.065v.072h.092v-.073h.01v-.019h0v.027H53.5l.02.006.008.085v-.082a.2.2,0,0,0,.059.008l-.02-.023h-.039V21.52h.027c.032,0,.013-.008,0-.007a.706.706,0,0,1,.13,0c.027.026-.017.028-.06.03h-.035v.02l.2-.011.225-.017a3.549,3.549,0,0,1,.438-.012l-.052-.006c.04-.07.217.034.354,0-.034.006-.044.04-.035.032h.18l.009-.033v0h0v.012h.022a.193.193,0,0,0-.019-.039h0v-.017a.088.088,0,0,0,.009.02h0a.073.073,0,0,0,.016.014l.008.021h-.019v.107a.244.244,0,0,0,0,.054v-.114h0v0l-.006.085v-.114h.012v.028h0v-.03h0v-.011h0v.093l-.006-.069c0-.009.008.081.008.067v-.035c.006.053,0,.032.005.051v-.022c0-.02.008.056.005.021l-.008-.08v-.028h.006l.005.051v.012h0l-.006-.055v.042l-.006-.044v.011h0v.026c0,.016-.007-.056,0,0v.015l.006.047v-.022l.006.056v-.007l-.006-.056c0,.028-.005-.057,0-.015v.028l.007.058v-.04s.011.084.007.047v-.011h0c0,.006-.007-.064-.007-.049-.005-.042,0-.009,0-.025l.011.081v.007c0-.005-.006-.057,0-.026l-.007-.055v.009l-.006-.046V21.6l-.005-.041h0v-.031h0v.021h0v-.02h0v.06c0-.017.011.073.009.048l-.01-.07v.018l.006.04c-.014-.091.011.056,0,0l-.007-.044v-.023h0l-.005-.035H55l.08-.005.172-.012-.036.018.1.013h.29l.017-.006.028-.008h.008l.016-.011c.34.081.658-.062.967.025-.04,0-.095.016-.063.016h.071c.028,0,.076.007.089-.013-.049,0,.043-.006.08,0-.019-.032-.041-.023-.089-.048a.423.423,0,0,1,.184-.022c-.105.01-.04.037.016.058h.012l.034.01c-.01-.009.007-.02,0-.03.1.035.072-.006.112-.027a.072.072,0,0,1,.03-.016.051.051,0,0,1,.03.007l-.011.016a1.445,1.445,0,0,1,.228-.024c.033.036-.081.016-.087.046.115,0,.228-.067.331-.031-.049.01-.119.01-.168.019a.5.5,0,0,0,.209.04h-.008l.194.02-.049-.012c.146-.093.293-.015.488-.076-.19.057-.032.034-.047.074.049.011.124.025.1.036.092-.032.152.027.282-.02.006.013.1,0,.076.035.119-.01-.028-.023-.017-.04a.9.9,0,0,1,.284,0c.053,0,.107.011.163.014H59.2l.107-.006.007-.025h.013l.05-.009v-.021h0v.007h0l.01,0H59.4a2.371,2.371,0,0,1,.252-.044H59.7c.021.011-.005.024-.026.034h-.006l-.039.009.038.007h.01a1.124,1.124,0,0,0,.259-.009h.021l-.013.01h-.008v.011h0v.03a.254.254,0,0,0,.045-.013c.017,0,.037-.007.071-.011v.03a.158.158,0,0,1-.042.009v.007a.2.2,0,0,0,.047-.011l-.006-.035h.038c.061-.006.138-.022.154-.049a.26.26,0,0,1-.088,0c.049,0,.022.031-.01.038a.18.18,0,0,1-.1,0L60.04,21.5h.024a.174.174,0,0,0-.027-.014v-.024h.135a.211.211,0,0,0,.217-.2A.214.214,0,0,0,60.264,21.038ZM56.4,20.89m-.208.088-.1-.057ZM55.7,20.91l-.009-.006H55.7Zm.492.045Zm-.091-.037-.008-.006h-.006c0-.01,0-.012-.006,0h0a.074.074,0,0,1,0-.021H56.1v.029Zm-.328,0h0v-.007h.005l-.007.011Zm0-.007v.007H55.74a.022.022,0,0,0,0-.02h0l.009.01v-.009Zm-7.543.1.03-.022.053.019Zm-4.054.1h0l-.057-.041h0Zm0,0h0l-.083-.06h0l.016.012h0Zm10.814.421v0Zm4.424-.07h0c-.057.013-.044.012-.008.011Zm.575-.029h.042v.007H60.01a.15.15,0,0,0-.037,0Zm.047.007v-.007h0Zm0,.013,0,0,.062.048.009-.009v.008Zm.03,0-.014-.013.008-.007h.019v.02Zm0-.049v-.012l-.009.008a.243.243,0,0,0-.066,0h-.022v-.008h.1v.019Zm-3.724-.56-.2.034h0v.021h0v.009h0V20.93h0Zm0,.018v.013h-.008Zm-.088-.025h0v-.033h.011Zm-.024-.033-.012.013c-.021,0-.012,0,0,0Zm-.326.016h.007c-.016.007-.018.008-.015.009ZM54.7,20.872Zm-.006,0h-.017c-.031,0-.01,0,.009.007Zm-6.251,0,.007.006h0l-.049.111h0v-.016l0-.036-.008-.053.033-.025a.044.044,0,0,1,.014.025Zm-.056-.027h-.008v-.006a.014.014,0,0,0,0,.018Zm-2.23.008Zm-.015.015h0l-.01.009h0Zm-.765-.01v.01a.148.148,0,0,1-.029-.012v-.023a.1.1,0,0,0,.022.041Zm-.059-.036h.024l.006.007h-.029l-.009,0Zm-.024.113v.039c0-.047-.027.073-.007-.028Zm-.143.685.659-.123v0Zm.017.051Zm.075.039h-.006l-.013,0c-.009,0-.017.011-.028.006s-.016-.042-.021-.054l0-.035.008-.054h0l.059.126Zm2.162.016v.019h0l.023-.1h0v.017a.741.741,0,0,0-.031.076Zm.018.024v-.009a.182.182,0,0,1,0-.033h0Zm.005-.041h0v0ZM48.1,21.5V21.48h0Zm2.32-.042v.032l-.008-.034Zm.02.117.029.008H50.5c.005,0,0,.011,0,.013a.305.305,0,0,1-.043,0Zm2.14-.121H52.6s-.009.01,0-.012h0l.013.008c-.009,0,0,0,.011.008H52.6Zm2.313.031,0,0h0v0Zm.062.027Zm0,.017v-.017h0v.016c-.008-.024,0,.045-.005.012Zm0-.017h0v0Zm0,0h0v0Zm.008.014v-.014h0c0,.02,0,.033,0,.025Zm1.313-.051a.047.047,0,0,1,0-.033h.1c-.012.023-.037.037-.1.044Zm3.026,0-.043-.033H59.4a.089.089,0,0,1-.025.014.377.377,0,0,1-.054.034Zm.059.051c-.01,0,0,0,0,0h0a.019.019,0,0,1,0,.018Zm.641-.061v-.006h0v.006h0v-.006l-.033.011c-.021-.009-.033-.024-.026-.036h.058a.1.1,0,0,1,.027.011l-.026.009v.011Zm.118.023h-.006l-.005-.035h.005Zm-.009-.054h-.006v-.02h.006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22234",
    "data-name": "Path 22234",
    d: "M54.98,21.6Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22235",
    "data-name": "Path 22235",
    d: "M54.971,21.6",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22236",
    "data-name": "Path 22236",
    d: "M54.957,21.565Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22237",
    "data-name": "Path 22237",
    d: "M54.955,21.6h0a.067.067,0,0,0,0,.02Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22238",
    "data-name": "Path 22238",
    d: "M54.929,21.586",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22239",
    "data-name": "Path 22239",
    d: "M54.96,21.57v-.016h0v.016Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22240",
    "data-name": "Path 22240",
    d: "M54.929,21.645Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22241",
    "data-name": "Path 22241",
    d: "M54.929,21.586v.057h0S54.929,21.609,54.929,21.586Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22242",
    "data-name": "Path 22242",
    d: "M54.956,21.581",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22243",
    "data-name": "Path 22243",
    d: "M54.955,21.577",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22244",
    "data-name": "Path 22244",
    d: "M54.955,21.587Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22245",
    "data-name": "Path 22245",
    d: "M54.932,21.652",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22246",
    "data-name": "Path 22246",
    d: "M54.956,21.571",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22247",
    "data-name": "Path 22247",
    d: "M54.924,21.556v.031h0v0C54.924,21.576,54.921,21.583,54.924,21.556Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22248",
    "data-name": "Path 22248",
    d: "M54.934,21.695v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22249",
    "data-name": "Path 22249",
    d: "M54.923,21.594v.01h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22250",
    "data-name": "Path 22250",
    d: "M54.923,21.578h0v-.006C54.924,21.579,54.926,21.547,54.923,21.578Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22251",
    "data-name": "Path 22251",
    d: "M54.957,21.59h0v-.008h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22252",
    "data-name": "Path 22252",
    d: "M54.923,21.606v.037a.171.171,0,0,0,0,.032V21.7l.009-.107v-.009C54.926,21.618,54.926,21.593,54.923,21.606Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22253",
    "data-name": "Path 22253",
    d: "M54.938,21.668",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22254",
    "data-name": "Path 22254",
    d: "M54.944,21.57v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22255",
    "data-name": "Path 22255",
    d: "M54.96,21.567v-.006h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22256",
    "data-name": "Path 22256",
    d: "M54.938,21.659",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22257",
    "data-name": "Path 22257",
    d: "M54.96,21.537",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22258",
    "data-name": "Path 22258",
    d: "M54.938,21.639v0h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22259",
    "data-name": "Path 22259",
    d: "M54.962,21.544",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22260",
    "data-name": "Path 22260",
    d: "M54.939,21.614v.016h0v-.016Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22261",
    "data-name": "Path 22261",
    d: "M54.933,21.626",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22262",
    "data-name": "Path 22262",
    d: "M54.957,21.571v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22263",
    "data-name": "Path 22263",
    d: "M54.956,21.566v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22264",
    "data-name": "Path 22264",
    d: "M54.929,21.642h0v-.014h0v-.051C54.93,21.6,54.93,21.62,54.929,21.642Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22265",
    "data-name": "Path 22265",
    d: "M54.954,21.571v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22266",
    "data-name": "Path 22266",
    d: "M54.954,21.537v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22267",
    "data-name": "Path 22267",
    d: "M54.95,21.569v0S54.95,21.6,54.95,21.569Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22268",
    "data-name": "Path 22268",
    d: "M54.938,21.65v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22269",
    "data-name": "Path 22269",
    d: "M54.992,21.565",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22270",
    "data-name": "Path 22270",
    d: "M55,21.6h0v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22271",
    "data-name": "Path 22271",
    d: "M54.981,21.573Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22272",
    "data-name": "Path 22272",
    d: "M54.961,21.59v-.01h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22273",
    "data-name": "Path 22273",
    d: "M55,21.577v.009h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22274",
    "data-name": "Path 22274",
    d: "M55.005,21.6v.008C55.008,21.616,55.007,21.611,55.005,21.6Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22275",
    "data-name": "Path 22275",
    d: "M55,21.586",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22276",
    "data-name": "Path 22276",
    d: "M54.961,21.627v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22277",
    "data-name": "Path 22277",
    d: "M55,21.585h0v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22278",
    "data-name": "Path 22278",
    d: "M54.991,21.578v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22279",
    "data-name": "Path 22279",
    d: "M54.938,21.668Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22280",
    "data-name": "Path 22280",
    d: "M54.988,21.547h0v.017c0,.015.006.047.005.03v.045l-.005-.04v-.005l-.007-.046S54.984,21.513,54.988,21.547Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22281",
    "data-name": "Path 22281",
    d: "M54.991,21.551",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22282",
    "data-name": "Path 22282",
    d: "M54.96,21.582",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22283",
    "data-name": "Path 22283",
    d: "M54.96,21.567",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22284",
    "data-name": "Path 22284",
    d: "M54.958,21.633v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22285",
    "data-name": "Path 22285",
    d: "M55.01,21.64v.012h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22286",
    "data-name": "Path 22286",
    d: "M54.974,21.638v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22287",
    "data-name": "Path 22287",
    d: "M54.958,21.595v.014C54.959,21.63,54.959,21.616,54.958,21.595Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22288",
    "data-name": "Path 22288",
    d: "M46.383,20.889l-.013.013.01-.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22289",
    "data-name": "Path 22289",
    d: "M60.521,21.133c-.016-.022-.066-.108-.118-.1a.345.345,0,0,1,.1.291c-.021.019-.02-.009-.025-.016,0,.076-.083.166-.006.165.045-.094.076-.117.045-.218C60.513,21.184,60.5,21.13,60.521,21.133Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22290",
    "data-name": "Path 22290",
    d: "M58.857,20.861v.007C58.857,20.875,58.867,20.861,58.857,20.861Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22291",
    "data-name": "Path 22291",
    d: "M60.1,21.548a.05.05,0,0,1-.034.018h.041C60.111,21.556,60.111,21.55,60.1,21.548Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22292",
    "data-name": "Path 22292",
    d: "M48,21.645h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22293",
    "data-name": "Path 22293",
    d: "M47.344,21.643a.249.249,0,0,0-.087-.026.044.044,0,0,0-.019.01Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22294",
    "data-name": "Path 22294",
    d: "M49.39,21.592v.032h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22295",
    "data-name": "Path 22295",
    d: "M54.916,21.539h0v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22296",
    "data-name": "Path 22296",
    d: "M52.684,21.557h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22297",
    "data-name": "Path 22297",
    d: "M46.289,20.853v-.027h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22298",
    "data-name": "Path 22298",
    d: "M46.565,20.817h0v.009h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22299",
    "data-name": "Path 22299",
    d: "M47.99,20.914h-.007v.009h.006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22300",
    "data-name": "Path 22300",
    d: "M52.661,21.555l-.027-.006a.011.011,0,0,1-.009-.006l-.077.016Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22301",
    "data-name": "Path 22301",
    d: "M44.988,21.648a.12.12,0,0,0,.043,0h-.048S44.983,21.646,44.988,21.648Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22302",
    "data-name": "Path 22302",
    d: "M47.374,21.6",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22303",
    "data-name": "Path 22303",
    d: "M45.817,21.623",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22304",
    "data-name": "Path 22304",
    d: "M51.639,20.829h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22305",
    "data-name": "Path 22305",
    d: "M50.888,21.6h0c-.007,0,0,.01,0-.011v-.011a.1.1,0,0,1-.026.028Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22306",
    "data-name": "Path 22306",
    d: "M50.894,21.568v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22307",
    "data-name": "Path 22307",
    d: "M51.65,20.821l.03-.007-.03.006-.063.012h.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22308",
    "data-name": "Path 22308",
    d: "M54.916,21.539",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22309",
    "data-name": "Path 22309",
    d: "M46.335,21.648h.008c-.039-.012-.01-.028-.046-.036C46.306,21.641,46.32,21.659,46.335,21.648Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22310",
    "data-name": "Path 22310",
    d: "M50.556,21.571h0c-.019.005-.015.008-.007.009h0c-.015.006-.008,0,0,0h0l.015-.006v-.008h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22311",
    "data-name": "Path 22311",
    d: "M60.024,21.5",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22312",
    "data-name": "Path 22312",
    d: "M60.025,21.462h0v.021h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22313",
    "data-name": "Path 22313",
    d: "M60.021,21.5",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22314",
    "data-name": "Path 22314",
    d: "M60.025,21.517",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22315",
    "data-name": "Path 22315",
    d: "M60.021,21.462v.022h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22316",
    "data-name": "Path 22316",
    d: "M60.021,21.5Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22317",
    "data-name": "Path 22317",
    d: "M60.021,21.5Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22318",
    "data-name": "Path 22318",
    d: "M54.913,21.519h0v.014h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22319",
    "data-name": "Path 22319",
    d: "M60.023,21.5v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22320",
    "data-name": "Path 22320",
    d: "M52.508,20.824v.01l.027-.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22321",
    "data-name": "Path 22321",
    d: "M57.726,21.54l.1.014A.84.84,0,0,0,57.726,21.54Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22322",
    "data-name": "Path 22322",
    d: "M58.292,21.562a.061.061,0,0,0,.012-.016h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22323",
    "data-name": "Path 22323",
    d: "M52.73,21.533h.022c.019,0,.033,0,.04-.021l-.039.013Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22324",
    "data-name": "Path 22324",
    d: "M48.017,21.645",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22325",
    "data-name": "Path 22325",
    d: "M60.25,21.553v-.006h-.031Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22326",
    "data-name": "Path 22326",
    d: "M60.3,21.541c-.018,0-.041,0-.042.006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22327",
    "data-name": "Path 22327",
    d: "M60.382,21.51a.438.438,0,0,1-.086.03A.149.149,0,0,0,60.382,21.51Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22328",
    "data-name": "Path 22328",
    d: "M59.619,21.562a1.123,1.123,0,0,1,.133.024l.019-.039-.019.026A.286.286,0,0,0,59.619,21.562Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22329",
    "data-name": "Path 22329",
    d: "M59.79,21.575h-.014v-.026l.007.038h.059l.007-.011a.063.063,0,0,1-.033,0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22330",
    "data-name": "Path 22330",
    d: "M53.57,21.534h-.018l.009.01h.015Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22331",
    "data-name": "Path 22331",
    d: "M62.1,18.377Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22332",
    "data-name": "Path 22332",
    d: "M62.094,18.38s-.007-.013-.018-.038l.013.032v.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22333",
    "data-name": "Path 22333",
    d: "M67.071,23.827a.083.083,0,0,0-.027.012h.01Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22334",
    "data-name": "Path 22334",
    d: "M67.067,25.364h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22335",
    "data-name": "Path 22335",
    d: "M67.068,23.75Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22336",
    "data-name": "Path 22336",
    d: "M65.737,20.031l.025-.023Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22337",
    "data-name": "Path 22337",
    d: "M65.807,20.045h0l-.01.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22338",
    "data-name": "Path 22338",
    d: "M65.777,20.1l.007-.006-.007.005Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22339",
    "data-name": "Path 22339",
    d: "M65.77,20.064h0l.011-.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22340",
    "data-name": "Path 22340",
    d: "M65.335,19.585h0v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22341",
    "data-name": "Path 22341",
    d: "M64.6,19.3a.122.122,0,0,0,0-.027V19.3Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22342",
    "data-name": "Path 22342",
    d: "M65.046,19.474",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22343",
    "data-name": "Path 22343",
    d: "M65.082,19.424l-.006.01h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22344",
    "data-name": "Path 22344",
    d: "M65.353,19.607l.008-.006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22345",
    "data-name": "Path 22345",
    d: "M65.311,19.57s-.011.028,0,.023l.007-.009C65.3,19.6,65.326,19.552,65.311,19.57Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22346",
    "data-name": "Path 22346",
    d: "M64.77,19.346l-.009.012.01-.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22347",
    "data-name": "Path 22347",
    d: "M65.5,19.794l.022-.027C65.506,19.788,65.5,19.794,65.5,19.794Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22348",
    "data-name": "Path 22348",
    d: "M65.465,19.812l-.011.012Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22349",
    "data-name": "Path 22349",
    d: "M65.579,19.821l.01-.01h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22350",
    "data-name": "Path 22350",
    d: "M65.554,19.832h0l.01-.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22351",
    "data-name": "Path 22351",
    d: "M38.428,49.1",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22352",
    "data-name": "Path 22352",
    d: "M38.406,49.266h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22353",
    "data-name": "Path 22353",
    d: "M66.221,27.425",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22354",
    "data-name": "Path 22354",
    d: "M66.224,27.429Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22355",
    "data-name": "Path 22355",
    d: "M66.219,27.42h0l.008,0C66.208,27.416,66.194,27.418,66.219,27.42Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22356",
    "data-name": "Path 22356",
    d: "M66.211,27.335",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22357",
    "data-name": "Path 22357",
    d: "M66.257,31.272c-.027.075-.037-.636-.034.223A1.561,1.561,0,0,1,66.257,31.272Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22358",
    "data-name": "Path 22358",
    d: "M66.233,63.291a1.32,1.32,0,0,0,0,.178Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22359",
    "data-name": "Path 22359",
    d: "M38.418,51.558",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22360",
    "data-name": "Path 22360",
    d: "M38.409,51.659v-.1h0v.049c-.006.069-.009.143-.011.218a.429.429,0,0,0,.01.089Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22361",
    "data-name": "Path 22361",
    d: "M38.413,51.558",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22362",
    "data-name": "Path 22362",
    d: "M38.421,51.616l.009.2v-.245c-.005-.014-.007-.012-.007,0h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22363",
    "data-name": "Path 22363",
    d: "M38.412,51.557h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22364",
    "data-name": "Path 22364",
    d: "M38.429,54.367v.1A.37.37,0,0,0,38.429,54.367Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22365",
    "data-name": "Path 22365",
    d: "M40.839,70.758",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22366",
    "data-name": "Path 22366",
    d: "M38.358,41.564h-.012v.006l.012.006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22367",
    "data-name": "Path 22367",
    d: "M65.374,19.6Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22368",
    "data-name": "Path 22368",
    d: "M56.7,70.781h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22369",
    "data-name": "Path 22369",
    d: "M66.263,62.587V62.6S66.261,62.564,66.263,62.587Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22370",
    "data-name": "Path 22370",
    d: "M52.626,70.813s-.024-.01-.034,0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22371",
    "data-name": "Path 22371",
    d: "M66.169,21.031v-.006h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22372",
    "data-name": "Path 22372",
    d: "M66.208,68.267v-.033A.047.047,0,0,0,66.208,68.267Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22373",
    "data-name": "Path 22373",
    d: "M63.924,70.738h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22374",
    "data-name": "Path 22374",
    d: "M65.993,20.13",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22375",
    "data-name": "Path 22375",
    d: "M38.351,38.044v0l-.008-.014A.027.027,0,0,1,38.351,38.044Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22376",
    "data-name": "Path 22376",
    d: "M38.34,38.018Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22377",
    "data-name": "Path 22377",
    d: "M38.34,38.018Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22378",
    "data-name": "Path 22378",
    d: "M38.348,38.026c-.013-.022,0-.005-.007-.01h0l.007.011.005.01h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22379",
    "data-name": "Path 22379",
    d: "M38.37,41.578l-.012,0v.056c0,.017.007,0,.009-.025v-.015Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22380",
    "data-name": "Path 22380",
    d: "M38.371,41.6v.012c-.013.048.028-.013,0-.043V41.6Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22381",
    "data-name": "Path 22381",
    d: "M38.364,38.071l.006.066c0,.051.006.118.01.183v-.265c-.029-.068-.021-.037-.022-.041v.019h0a.066.066,0,0,1,.009.019Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22382",
    "data-name": "Path 22382",
    d: "M38.358,33.745v.071C38.359,33.787,38.358,33.765,38.358,33.745Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22383",
    "data-name": "Path 22383",
    d: "M38.344,38.024Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22384",
    "data-name": "Path 22384",
    d: "M66.221,62h.009l-.008-.127Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22385",
    "data-name": "Path 22385",
    d: "M52.687,19.019c.033.005.066.008.1.01A.678.678,0,0,0,52.687,19.019Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22386",
    "data-name": "Path 22386",
    d: "M56.1,19.027l.483.014Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22387",
    "data-name": "Path 22387",
    d: "M58.733,19.041a.178.178,0,0,0,.051-.016h-.005Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22388",
    "data-name": "Path 22388",
    d: "M38.379,38.319v.1C38.389,38.659,38.386,38.5,38.379,38.319Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22389",
    "data-name": "Path 22389",
    d: "M38.295,26.592c.006.132.012.262.017.4A1.34,1.34,0,0,0,38.295,26.592Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22390",
    "data-name": "Path 22390",
    d: "M38.434,50.511",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22391",
    "data-name": "Path 22391",
    d: "M38.31,27.575c.008-.221.007-.406,0-.578C38.309,27.175,38.305,27.387,38.31,27.575Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22392",
    "data-name": "Path 22392",
    d: "M40.185,19.167l-.035.047.095-.03V19.17C40.206,19.174,40.17,19.179,40.185,19.167Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22393",
    "data-name": "Path 22393",
    d: "M38.335,21.569",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22394",
    "data-name": "Path 22394",
    d: "M38.335,21.569Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22395",
    "data-name": "Path 22395",
    d: "M38.337,21.574Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22396",
    "data-name": "Path 22396",
    d: "M38.336,21.569",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22397",
    "data-name": "Path 22397",
    d: "M66.234,39.743l.026-.008h-.01Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22398",
    "data-name": "Path 22398",
    d: "M66.248,39.716l-.014-.005.012.011Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22399",
    "data-name": "Path 22399",
    d: "M66.216,28.523h0C66.212,28.513,66.213,28.518,66.216,28.523Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22400",
    "data-name": "Path 22400",
    d: "M66.3,52.264",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22401",
    "data-name": "Path 22401",
    d: "M66.231,52.255h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22402",
    "data-name": "Path 22402",
    d: "M66.236,52.268l.052.007h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22403",
    "data-name": "Path 22403",
    d: "M66.286,52.276",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22404",
    "data-name": "Path 22404",
    d: "M66.3,52.278Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22405",
    "data-name": "Path 22405",
    d: "M66.24,52.266h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22406",
    "data-name": "Path 22406",
    d: "M66.243,52.27h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22407",
    "data-name": "Path 22407",
    d: "M66.246,52.267",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22408",
    "data-name": "Path 22408",
    d: "M66.23,52.267l.058.008-.034-.005h-.033Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22409",
    "data-name": "Path 22409",
    d: "M66.228,52.265Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22410",
    "data-name": "Path 22410",
    d: "M66.274,52.275h-.021C66.229,52.268,66.256,52.271,66.274,52.275Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22411",
    "data-name": "Path 22411",
    d: "M66.282,52.275h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22412",
    "data-name": "Path 22412",
    d: "M66.254,52.274",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22413",
    "data-name": "Path 22413",
    d: "M66.287,52.277h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22414",
    "data-name": "Path 22414",
    d: "M66.264,52.274h.011l-.033,0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22415",
    "data-name": "Path 22415",
    d: "M66.251,52.272l-.034-.006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22416",
    "data-name": "Path 22416",
    d: "M66.27,52.275l-.04-.007h.02l.042.007-.027-.005h-.028Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22417",
    "data-name": "Path 22417",
    d: "M66.24,52.253Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22418",
    "data-name": "Path 22418",
    d: "M66.26,52.247",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22419",
    "data-name": "Path 22419",
    d: "M66.254,52.249",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22420",
    "data-name": "Path 22420",
    d: "M66.25,52.251h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22421",
    "data-name": "Path 22421",
    d: "M66.256,52.247",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22422",
    "data-name": "Path 22422",
    d: "M66.251,52.251h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22423",
    "data-name": "Path 22423",
    d: "M66.254,52.249Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22424",
    "data-name": "Path 22424",
    d: "M66.238,52.248",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22425",
    "data-name": "Path 22425",
    d: "M66.257,52.247",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22426",
    "data-name": "Path 22426",
    d: "M66.253,52.246",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22427",
    "data-name": "Path 22427",
    d: "M66.266,52.254",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22428",
    "data-name": "Path 22428",
    d: "M66.263,52.245l.028,0-.031.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22429",
    "data-name": "Path 22429",
    d: "M66.258,52.247",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22430",
    "data-name": "Path 22430",
    d: "M66.258,52.247h0l.025-.006-.026.006h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22431",
    "data-name": "Path 22431",
    d: "M66.259,52.247",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22432",
    "data-name": "Path 22432",
    d: "M66.251,52.251",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22433",
    "data-name": "Path 22433",
    d: "M66.246,52.253h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22434",
    "data-name": "Path 22434",
    d: "M66.25,52.255",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22435",
    "data-name": "Path 22435",
    d: "M66.251,52.253",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22436",
    "data-name": "Path 22436",
    d: "M66.248,52.257h.044l-.04-.006h-.014Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22437",
    "data-name": "Path 22437",
    d: "M66.245,52.25h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22438",
    "data-name": "Path 22438",
    d: "M66.273,52.258",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22439",
    "data-name": "Path 22439",
    d: "M66.248,52.254",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22440",
    "data-name": "Path 22440",
    d: "M66.249,52.252h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22441",
    "data-name": "Path 22441",
    d: "M66.3,52.282",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22442",
    "data-name": "Path 22442",
    d: "M66.246,52.253h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22443",
    "data-name": "Path 22443",
    d: "M66.256,52.249",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22444",
    "data-name": "Path 22444",
    d: "M66.255,52.253",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22445",
    "data-name": "Path 22445",
    d: "M66.253,52.252",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22446",
    "data-name": "Path 22446",
    d: "M66.235,52.251h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22447",
    "data-name": "Path 22447",
    d: "M66.3,52.262",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22448",
    "data-name": "Path 22448",
    d: "M66.3,52.262",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22449",
    "data-name": "Path 22449",
    d: "M66.3,52.263",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22450",
    "data-name": "Path 22450",
    d: "M66.273,52.262h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22451",
    "data-name": "Path 22451",
    d: "M66.262,52.26h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22452",
    "data-name": "Path 22452",
    d: "M66.274,52.262",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22453",
    "data-name": "Path 22453",
    d: "M66.3,52.263",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22454",
    "data-name": "Path 22454",
    d: "M66.295,52.251",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22455",
    "data-name": "Path 22455",
    d: "M66.259,52.247",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22456",
    "data-name": "Path 22456",
    d: "M66.264,52.247",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22457",
    "data-name": "Path 22457",
    d: "M66.259,52.247",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22458",
    "data-name": "Path 22458",
    d: "M66.268,52.25",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22459",
    "data-name": "Path 22459",
    d: "M66.264,52.249",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22460",
    "data-name": "Path 22460",
    d: "M66.277,52.263",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22461",
    "data-name": "Path 22461",
    d: "M66.262,52.259h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22462",
    "data-name": "Path 22462",
    d: "M66.243,52.253",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22463",
    "data-name": "Path 22463",
    d: "M66.245,52.253",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22464",
    "data-name": "Path 22464",
    d: "M66.251,52.253",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22465",
    "data-name": "Path 22465",
    d: "M66.243,52.251",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22466",
    "data-name": "Path 22466",
    d: "M66.241,52.251",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22467",
    "data-name": "Path 22467",
    d: "M66.246,52.254Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22468",
    "data-name": "Path 22468",
    d: "M66.24,52.248",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22469",
    "data-name": "Path 22469",
    d: "M66.251,52.259",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22470",
    "data-name": "Path 22470",
    d: "M66.251,52.258Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22471",
    "data-name": "Path 22471",
    d: "M66.261,52.26",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22472",
    "data-name": "Path 22472",
    d: "M66.249,52.257",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22473",
    "data-name": "Path 22473",
    d: "M66.238,52.257",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22474",
    "data-name": "Path 22474",
    d: "M66.231,52.255",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22475",
    "data-name": "Path 22475",
    d: "M66.293,52.269h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22476",
    "data-name": "Path 22476",
    d: "M66.266,52.266h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22477",
    "data-name": "Path 22477",
    d: "M66.24,52.266h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22478",
    "data-name": "Path 22478",
    d: "M66.272,52.27",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22479",
    "data-name": "Path 22479",
    d: "M66.223,52.264",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22480",
    "data-name": "Path 22480",
    d: "M66.214,52.263",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22481",
    "data-name": "Path 22481",
    d: "M66.269,52.263",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22482",
    "data-name": "Path 22482",
    d: "M66.246,52.262",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22483",
    "data-name": "Path 22483",
    d: "M66.2,52.262",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22484",
    "data-name": "Path 22484",
    d: "M66.23,52.264",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22485",
    "data-name": "Path 22485",
    d: "M66.259,52.268",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22486",
    "data-name": "Path 22486",
    d: "M66.258,52.268h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22487",
    "data-name": "Path 22487",
    d: "M66.214,52.262h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22488",
    "data-name": "Path 22488",
    d: "M66.253,52.268h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22489",
    "data-name": "Path 22489",
    d: "M66.261,52.27h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22490",
    "data-name": "Path 22490",
    d: "M66.241,52.268h-.012l.053,0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22491",
    "data-name": "Path 22491",
    d: "M66.273,52.27h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22492",
    "data-name": "Path 22492",
    d: "M66.2,52.263",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22493",
    "data-name": "Path 22493",
    d: "M66.244,52.267H66.19l.061.006h-.016Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22494",
    "data-name": "Path 22494",
    d: "M66.218,52.262Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22495",
    "data-name": "Path 22495",
    d: "M66.264,52.271h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22496",
    "data-name": "Path 22496",
    d: "M66.214,52.263",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22497",
    "data-name": "Path 22497",
    d: "M66.2,52.263h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22498",
    "data-name": "Path 22498",
    d: "M66.228,52.266",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22499",
    "data-name": "Path 22499",
    d: "M66.241,52.26Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22500",
    "data-name": "Path 22500",
    d: "M66.24,52.254",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22501",
    "data-name": "Path 22501",
    d: "M66.209,52.26h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22502",
    "data-name": "Path 22502",
    d: "M66.254,52.258",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22503",
    "data-name": "Path 22503",
    d: "M66.243,52.253",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22504",
    "data-name": "Path 22504",
    d: "M66.3,52.24l-.033.006h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22505",
    "data-name": "Path 22505",
    d: "M66.19,52.262h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22506",
    "data-name": "Path 22506",
    d: "M66.231,52.255",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22507",
    "data-name": "Path 22507",
    d: "M66.229,52.257Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22508",
    "data-name": "Path 22508",
    d: "M66.212,52.258h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22509",
    "data-name": "Path 22509",
    d: "M66.243,52.258",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22510",
    "data-name": "Path 22510",
    d: "M66.231,52.26",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22511",
    "data-name": "Path 22511",
    d: "M66.208,52.26h.029S66.242,52.255,66.208,52.26Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22512",
    "data-name": "Path 22512",
    d: "M66.247,52.245h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22513",
    "data-name": "Path 22513",
    d: "M66.255,52.254h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22514",
    "data-name": "Path 22514",
    d: "M66.261,52.247h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22515",
    "data-name": "Path 22515",
    d: "M66.265,52.253",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22516",
    "data-name": "Path 22516",
    d: "M66.287,52.264",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22517",
    "data-name": "Path 22517",
    d: "M66.292,52.242l-.027.005h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22518",
    "data-name": "Path 22518",
    d: "M66.223,52.255h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22519",
    "data-name": "Path 22519",
    d: "M66.238,52.253",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22520",
    "data-name": "Path 22520",
    d: "M66.214,52.257h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22521",
    "data-name": "Path 22521",
    d: "M66.283,52.264",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22522",
    "data-name": "Path 22522",
    d: "M66.263,54.232h.014l-.017.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22523",
    "data-name": "Path 22523",
    d: "M66.261,54.236",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22524",
    "data-name": "Path 22524",
    d: "M66.258,54.235l-.038.017.017-.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22525",
    "data-name": "Path 22525",
    d: "M66.261,54.236h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22526",
    "data-name": "Path 22526",
    d: "M66.256,54.234Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22527",
    "data-name": "Path 22527",
    d: "M66.236,54.245l.025-.009-.023.009Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22528",
    "data-name": "Path 22528",
    d: "M66.286,54.229Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22529",
    "data-name": "Path 22529",
    d: "M66.274,54.232h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22530",
    "data-name": "Path 22530",
    d: "M66.265,54.236Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22531",
    "data-name": "Path 22531",
    d: "M66.253,54.452",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22532",
    "data-name": "Path 22532",
    d: "M67.077,39.13h0C67.081,39.142,67.08,39.135,67.077,39.13Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22533",
    "data-name": "Path 22533",
    d: "M67.067,38.075Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22534",
    "data-name": "Path 22534",
    d: "M37.548,60.528h0l.023.01Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22535",
    "data-name": "Path 22535",
    d: "M37.568,60.463h-.01l.012.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22536",
    "data-name": "Path 22536",
    d: "M37.557,60.458",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22537",
    "data-name": "Path 22537",
    d: "M37.547,60.452l.01.008h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22538",
    "data-name": "Path 22538",
    d: "M37.558,60.458l.011.007h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22539",
    "data-name": "Path 22539",
    d: "M37.547,60.531h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22540",
    "data-name": "Path 22540",
    d: "M67.09,43.066v-.008h.042a.148.148,0,0,0-.042,0h0v-.012h.016c.013,0-.024,0-.01-.006H67.09v-.028h0v-.018h0l-.006-.006V42.98h.025c.007,0-.014-.007-.013-.011h.025L67.1,42.96h-.031v-.006h0v-.012c.025,0,.05-.005.012-.008h.01c-.055,0,0-.008-.028-.01h0c.1,0-.009-.009.056-.015H67.1c-.024,0,.014,0,.019-.009-.019,0-.022,0-.035,0l-.007-.011v-.032a.186.186,0,0,0-.015-.032h0c.007-.01.014-.019.02-.029a.069.069,0,0,1-.025-.01c0-.025,0-.053-.007-.081a.046.046,0,0,0,.046.012c-.026,0-.036-.026-.048-.044s0-.031,0-.048a.088.088,0,0,1,.032-.016c-.029,0-.033-.009-.034-.018s0-.037,0-.057c.025-.021.043-.006.026-.051.021-.025.044.022.044.022,0-.052-.043-.029-.072-.037v-.036c0-.013.041,0,.058-.017a.232.232,0,0,0-.039-.062h.017a.592.592,0,0,0-.005-.093.078.078,0,0,1,.005-.034s-.01,0-.016,0,0-.011,0-.016a.046.046,0,0,1,.032.015l-.027-.041v-.018h.009c-.012-.008,0-.024,0-.041l.016.081c0-.181,0-.317-.008-.423V41.7a.078.078,0,0,1-.007.033v-.006c0-.061-.009-.115-.013-.169a.746.746,0,0,0,0-.2h.006v0l.018.012a.044.044,0,0,0-.017-.034,2.915,2.915,0,0,0-.024-.723V40.6c0-.038-.005-.086-.007-.142a.255.255,0,0,0,.022-.187l.022-.055c0-.2,0-.4-.008-.6.009-.056.017-.111.022-.165a.048.048,0,0,0-.026-.049V39.36a.15.15,0,0,0,.013-.033l.013.03a.106.106,0,0,1-.008-.049l-.018.01V39.3h0v-.092a.012.012,0,0,1,.011.007c.019-.037.006-.045-.012-.054v-.074s.005-.008,0-.011v-.208a.118.118,0,0,0,0-.053v-.146h.005a.051.051,0,0,0,0-.042v-.058a.073.073,0,0,1,.01.014.23.23,0,0,1-.011-.064v-.179l.012-.027-.012.015v-.25a.015.015,0,0,1,.016,0,.111.111,0,0,0-.016-.062q-.011-.692-.02-1.394c.014.067.028.276.042-.008-.011-.783-.008-1.623,0-2.456l.01-.008h0l.008-.005H67.1v-.287h0c.01-.691.023-1.371.035-2l-.039-.566c0-.132.019-.244.026-.1.016-.577-.025-.029-.04-.307V30.83h0v-.06h0v-.023h0v-.06l.026,0c0-.007-.011-.009-.026-.009v-.014h0c.008-.136.023-.149.031,0-.015-.234-.025-.515-.033-.82h0v-.04a.039.039,0,0,0,.016-.01l.013.008a.012.012,0,0,1-.007-.013h-.018v-.006h0v-.015l0-.008,0,0H67.1c.021-.011,0-.012-.014-.015v-.016c.007,0,.011,0,.009-.005s-.006,0-.009,0V29.7h.006c-.027,0,.044-.021,0-.028H67.1a.116.116,0,0,0-.012-.044s.008-.007,0-.012h0v0h0c0-.079,0-.156,0-.235v-.135c.04-.023-.029-.06.026-.082h-.024l.023-.007h-.023V29.07c.006-.012.013-.023.02-.035h-.021c0-.153,0-.309-.008-.463h0v-.046h0V28.5H67.07c0-.635,0-1.254.02-1.72l.011.209c.005-.244,0-.424-.008-.579h.042V25.9h-.066v-.22c0-.11,0-.008.008-.011h.012c.006-.008-.006-.013-.02-.017v-.087a.1.1,0,0,1,.068,0c-.027-.014-.083-.037-.067-.053h.012a.017.017,0,0,0-.006-.012l.008-.011h0c.029,0,.015-.019.017-.028a.121.121,0,0,1-.038,0v-.03l.021-.007v0a.091.091,0,0,0,.024-.024c0-.007-.024-.011-.043-.016v-.014h.026l-.026-.009v-.01l.032-.006-.011-.011a.094.094,0,0,1-.02.008v-.027a.073.073,0,0,1,.04-.015l-.036-.04a.052.052,0,0,1,.033.012c-.043-.021.044,0,0-.024a.182.182,0,0,1-.033,0,.032.032,0,0,0,.019-.04l0-.009h.029c.007-.03-.015-.063-.015-.1a.062.062,0,0,1-.035.008v-.011h0v-.008a.053.053,0,0,1,.025,0l-.016-.015h.037c-.028-.006.044-.027,0-.035h.013c0-.034-.016-.049-.019-.076a.06.06,0,0,1-.037-.009v-.041a.054.054,0,0,0,.014-.036.023.023,0,0,1-.014,0v-.02h.015a.15.15,0,0,0-.015-.042v-.078h0V24.7c.023-.024.044-.046.007-.063h0l-.011-.009V24.6a.034.034,0,0,0,.02,0,.048.048,0,0,1-.02-.02v-.072c.078-.026-.016-.081.046-.111h-.024c-.024-.008.014-.01.019-.016-.019,0-.022.009-.035,0-.029-.069.035-.144.057-.215,0-.015-.039-.018-.064-.023v-.023l.042.009c-.052-.051,0-.1-.042-.156h0c.01,0,.022,0,.022.008.031-.011,0-.038-.022-.04h0c.005,0,.022,0,.034-.006s-.041-.027-.009-.033a.014.014,0,0,1,.013,0c-.016-.007,0-.033-.034-.026.018-.019-.017-.037,0-.053l-.01-.006v-.035c.021-.008.016-.025,0-.036v-.007a.059.059,0,0,1,.037,0c0-.012-.013-.022-.037-.023h0c.027-.013.011-.025,0-.036v-.008l.005.008h0l-.011-.012v-.011a.069.069,0,0,1,.028-.008c-.011-.014-.019-.027-.028-.04v-.042a.052.052,0,0,0,.028,0,.154.154,0,0,0-.028-.029V23.5h0v-.045h.009c-.007,0-.009-.009-.009-.012h0c0-.013.03-.025.034-.033l.013.009A.014.014,0,0,1,67.1,23.4l-.032.007c0-.006.006-.012.019-.012h-.027v-.022c.009,0,.017,0,.019.007s0-.008,0-.014h.011c.022-.015,0-.016-.019-.02h-.012c0-.474.006-.928.016-1.348h.014l.006-.16a1.015,1.015,0,0,1-.013-.121v-.034h0c-.008-.134-.014-.326-.022-.537v.018a1.478,1.478,0,0,0-.023-.24c-.005-.021-.008-.042-.012-.063l.036-.005-.011-.071-.01-.047-.006-.023V20.71h0l.023,0h0l-.023,0h-.015l-.023.005a.045.045,0,0,0-.009-.032l-.019-.047h-.007a1.3,1.3,0,0,0-.206-.436l-.162-.3-.14-.208c-.079-.123-.158-.2-.235-.3a2.568,2.568,0,0,0-.345-.315,3.357,3.357,0,0,0-.735-.433,2.248,2.248,0,0,0-.634-.156v-.02l-.034-.006v.021h0v.006l-.338-.042-.007-.043a4.488,4.488,0,0,0-.676.009c-.037,0-.089-.009-.114-.013-.045-.011-.1-.022-.167-.034l-.067-.008-.451.018A1.211,1.211,0,0,1,63,18.4c-.253.009-.542.015-.812.008v0h0V18.39H62.2c-.006-.028-.007,0-.008.015a.16.16,0,0,0-.007-.033v.038h0a.065.065,0,0,0-.009-.039.081.081,0,0,0,0,.038H62.1l-.006-.015h0V18.4h0V18.4h0v-.008h0v-.009l-.007-.016.01.026h0l-.015-.041.015.043h0l-.009-.024.008.026V18.4h0c-.008-.024-.011-.041-.008-.024l-.011-.044.017.068h0l-.013-.053c0,.011.008.042.009.053h0v0h0v0h0v-.039c0-.013,0,.023-.007.01V18.4h-.011c0-.026,0-.05-.008-.019V18.4h-.006v0h0v-.013l-.007.012h-.007c0-.017-.008-.038-.009-.051a.326.326,0,0,1-.07-.007h-.2l-.2,0h-.054l0-.008v.008l-1.308.035a2.411,2.411,0,0,1,.371-.029,4,4,0,0,1-.536-.018h0l-.17.008c.109.009-.059.025-.078.034-.406-.023-1.332-.022-2.019-.014l.132-.028-4,.006c.5.014.384.064-.024.068l-.163-.044c-.263.027.426.018-.115.05-.52-.006-.349-.05-.051-.064l-.632.014c-.037-.013.111-.02.15-.037-.092.006-.185.008-.277,0l-.379-.011h-.29a2.9,2.9,0,0,0-.361.014l-.036-.013h-.56v-.006H51.1v0h-.111l-2.13.017c0,.01-.037.016-.087.021H48.76c.057,0,.146.01.15.042-.012-.027-.05-.011-.075-.016h-.224v-.013H47.273a.131.131,0,0,1,0-.028l-.011.028h-.056a.024.024,0,0,0-.012,0h-.127v0h-.1c0-.012,0-.027-.009-.006v.006h-.037v-.017c-.023-.007-.048.014-.073.013h-.017v-.015c0,.027-.02-.044-.027,0v-.013a.063.063,0,0,0-.033.009v.015h-.1c-.021-.037-.056.03-.076-.026v.024h-.007l0-.019a.06.06,0,0,0,0,.019H46.5a.724.724,0,0,0-.071-.041c-.008,0-.012.019-.015.041h-.017v-.019a.049.049,0,0,1-.024.019h-.09c-.006-.023-.018-.014-.025,0h-.009v-.016c0-.013-.013.012-.019.017h0v-.008a.015.015,0,0,1,0-.013c0,.013-.019,0-.02.021H46.2v-.019h-.1v-.005l.008-.013c0,.008-.008.007-.012.007v.006h-.027c-.008-.016-.01-.008-.012,0h-1.1l-.562.005h-.324l-.406.014H43.7l-.607.013c.165.014.351.02.255.032a2.524,2.524,0,0,1-.589-.03h.073c-.445.013-.926.013-1.417.006v-.015h-.245v.021c-.164,0-.329,0-.5.006a3.538,3.538,0,0,0-.717.115h-.015V18.5l-.019.007v.005a3.13,3.13,0,0,0-.951.425,2.543,2.543,0,0,0-.692.632l.049-.065-.183.236-.027-.021-.052.063.03.023-.01.013.012.01a3.083,3.083,0,0,0-.375.836c-.086.328-.063.231-.047.106s.055-.27-.024-.026a2.349,2.349,0,0,0-.058.567v.516h0v.05c0,.209-.01.41-.014.611,0,.175-.006.351-.01.529h0v.159c0,.059-.009.122-.014.189l-.01.167a3.192,3.192,0,0,1,0,.366v.047a.1.1,0,0,0-.01.037v.775c0,.641.011,1.348.016,2v-.032a.171.171,0,0,1,.008-.019v.066c-.005,0-.008,0-.008-.008v.092h.007V27c0,.2-.01.384-.018.551l.024-.076a4.7,4.7,0,0,1-.02.66c.019-.036.022-.368.035-.158s0,.436,0,.656V29.3q0,.911.008,1.837v-.011c-.013.972-.026,1.953-.039,2.932v.034l-.016,1.429h0v1.234c0,.148,0,.267.007.365v.065h0l.008-.008.006.1.007.057.014.1c.01.068.019.135.025.222a8.251,8.251,0,0,1,0,.917l-.046-.385q.012.628.025,1.263v.384l-.005.08v3.2h0q.009.677.02,1.336a2.106,2.106,0,0,1-.024-.337c-.016.225-.015.64-.008,1a4.959,4.959,0,0,0,.036.668c0,.331-.024.077-.037.282-.018.45.043,1.13.012,1.368,0,.025-.007-.028-.01-.091.008.276.007.777.018.949h.037v.287l-.007-.075v.8a2.987,2.987,0,0,0,.024.641c-.007-.006-.013.006-.018.035l-.008.055v.061h.032l.086.01c.013,0,.03,0,.037,0H37.6c-.025.379-.014,1.34.008,1.731-.018-.168-.02.438-.045.24a4.184,4.184,0,0,0,.042,1c-.074,1.059.057,2.129-.038,2.725.01.6.02,1.189.029,1.7h.021v.29l-.042.012c0,.16,0,.316.007.469v.159l.006.1.017.264v.336h0V59.9c0,.373-.028-.212-.04-.338,0,.2.008.4.013.6v.286h0v.013h0v.023h0s-.021,0,0,.011v.014h0c-.026-.009-.022,0-.034,0l.025.009c-.02-.006-.006,0,.009.01h0l-.025-.013-.029-.011a.36.36,0,0,1,.052.026h0v.009h0v.174h0v.006h-.018c-.026.008.039,0,.007.007h.011v.036h0c-.022.005-.059.013-.032.011h.011l.019-.006h0l-.027.006h.019l-.032.006-.007,0,.013,0h.034V61.91h.015v.231h0v.049h0c0,.009.006,0,0,0v-.016l.006.276a.458.458,0,0,1-.009-.09l-.007-.166v.369c0,.107,0,.19.019.176L37.6,62.49c.041-.407.081,1.016.1,1.062-.078-.435-.023,1.28-.122.59,0,.168.018.379.036.341-.006.249-.017.329-.038.075.013.915.043.59.04,1.419a2.494,2.494,0,0,1-.034-.256c.024.42.051.842.042,1.542-.007-.036-.016.017-.018-.1,0,.383.012.732.022,1.073h-.049c0,.065-.006.129-.006.192h.082c.006.1.013.2.02.309v.015h0a.067.067,0,0,0,0,.02.563.563,0,0,0,.009.1l.031.166a2.584,2.584,0,0,0,.093.342,3.023,3.023,0,0,0,.345.686c-.143-.158-.069-.038.041.128a2.649,2.649,0,0,1,.251.334c.193.153.394.292.59.437l-.219-.2.256.192a1.956,1.956,0,0,0,.274.149c.092.042.184.08.276.115.047.017.09.033.145.048,0,0,.027.007.026,0l-.01,0-.02-.009h0l.02.007.069.024.007.012.005.006.015.013-.072-.022.079.027h.008l.011.005.024.01.036.012.067.018c.043.011.088.022.132.03.089.018.176.033.264.045a4.732,4.732,0,0,0,.532.046,4.644,4.644,0,0,1-.665-.091c.317.039.3.013.311,0a2.413,2.413,0,0,1,.457.02c-.168.007.624-.008.946.027h0c.307-.016.623-.032,1.083-.019.119.016-.1.056-.018.066.3-.042,1.455-.01,1.839-.055-.128.011-.135.037-.093.042l.254-.034c.144.006.226.01.267.015s.054.012.019.022h.107a.167.167,0,0,0,.044-.006h.028l-.024-.038c.059,0,.176,0,.408.009-.08,0-.042.009-.21.012.324.008.64.013.953.013l.464-.012H47.6l.007-.008h.012c-.008.028-.03.03-.053.028h.043l.019-.033h0c-.012.029-.028.062-.064.042h-.016s-.009.005-.012,0h-.22l.3.018.022-.054h.216l.532,0c.28.051-.829.011-.508.055,1.367-.008,2.832-.058,4.155-.044l-.247-.005c.184-.071.985.037,1.655,0-.164,0-.215.04-.171.031.906.013,1.853-.015,3.227-.036l-.17.018c.534.017,1.406.011,1.983.02.171-.018.5-.015.3-.042.144.008.262.015.466.021a.027.027,0,0,1-.011.008h.292v-.007h.018c.915.005,1.791-.031,2.651-.025v.031l.2-.01h-.138l-.064.008v-.026h0v.016h.064c.051-.005.113-.009.186-.011h.084l.017.035.457-.009h.006v-.057a6.43,6.43,0,0,1,.867-.043l-.051.019a4.128,4.128,0,0,0,1.061-.2c.082-.007-.008.026-.121.066a1.347,1.347,0,0,0-.264.082,4.068,4.068,0,0,0,1.421-.665,2.926,2.926,0,0,1-.326.232c-.125.067-.246.143-.354.188a2.3,2.3,0,0,0,.508-.235,2.991,2.991,0,0,0,.37-.267l-.032.025a3.323,3.323,0,0,0,.5-.52,3.24,3.24,0,0,0,.46-2.225c.058.89.034.147.075.215a2.345,2.345,0,0,1,.036-.488c-.033-.433.026-.723-.022-1.334.013-.027,0-.463.035-.366-.01-.563-.023.133-.04.086-.045-.868.055-2.04-.007-3.289-.023-.988-.063-1.238-.086-2.044v-.3c.02-.159.042.344.042.344.02-.544.016-.953,0-1.466.012.1.021,0,.036-.159a7.693,7.693,0,0,1-.028-.817,4.072,4.072,0,0,1,.053.411c-.016-.485-.032-.964-.049-1.465.023-.133.035.3.05.48-.01-.564-.021-1.461-.057-1.635l-.01.272c.008-.069.029.016.034.135a2.377,2.377,0,0,1-.026.724l-.008-.357a21.22,21.22,0,0,0,.008,2.155l-.046-.244v-5.4l.058.005v.136l.045.2-.009-.332h.014l.009-.03c.007-.064.014-.11.02-.2l.009-.138v-.071c0-.023,0-.045,0-.067v-.1l-.01-.2v-.068L67,52.441v-.027c.019-.093.031-.168.044-.251l-.008.165-.006.088v.059a.471.471,0,0,0,.016-.135v-.316h0V52h0v-.011h0v-.01h0v-.017a.134.134,0,0,1,.04,0h-.04v-.006h.025l-.024-.006a.315.315,0,0,0,.009-.042h0v-.031c0-.05.013-.142.015-.26l-.013-.155c.009,0,.022-.008,0-.009h.011c0-.012-.008-.017-.013-.025l-.01-.114H67.04v-.005c.01-.005.013-.01,0-.014v-.026h0v-.038c.052-.012-.026-.031.032-.043H67.04v-.064h-.006v-.108l-.008-.205a2.757,2.757,0,0,0-.025-.3c.008-.127.009-.313.01-.5h.077l-.012-.315v-.325h-.007v-.052c.008-.031.01-.11.021-.017-.011-.145-.016-.328-.019-.53,0-.186,0-.367-.007-.585a1.134,1.134,0,0,0,.02-.128h-.025v-.44c.011.106.022.188.04.122a3.9,3.9,0,0,1-.043-.656v-.029h0c0-.07.011-.111.021-.11-.007.042-.014.079-.02.108.028-.076.029.65.037-.227a.519.519,0,0,1-.012.089c-.011-.1-.019-.226-.025-.372h.055v-.306h0c0-.234-.009-.418-.014-.609l-.009-.431v-.372c-.029-.241-.037.08-.066-.161l-.006-.164v-.154c.012-.006.023-.014.035-.019l.012-.192.006-.092.006-.055c.008-.073.015-.145.02-.227a6.091,6.091,0,0,0,0-.689h0Zm-.058,6.24h0l-.01.007h0ZM37.7,57.777l.027-.013-.016.012-.033.019-.026.007Zm24.1-39.4H61.8v.011h0Zm0,0h0v0ZM67.029,26.4h0Zm.011,14.379v-.093h0c0,.037,0,.084.007.133a.115.115,0,0,0-.014-.032v0Zm-.052,4.974v-.023l0,.023Zm.037.987L67,46.73h0l.022.008Zm-29.336.932h0c.008,0,0,0-.005,0Zm-.018.026a.213.213,0,0,0-.01.04.188.188,0,0,1,.005-.033v-.008ZM63.5,18.944h.119a.549.549,0,0,1,.1.006c-.036,0-.09.009-.179.015-.01,0-.052,0-.009.006h-.022l-.191-.031C63.533,18.947,63.649,18.945,63.5,18.944Zm3.516,16.844c-.013.051-.027,0-.026-.152,0,.04.008-.026.012-.13s.018-.244.021-.354c0,.179-.011.4,0,.636Zm.006,1.188v-.36h0Zm-.034,9.75-.017-.006h0l.016,0ZM39.6,19.354h0l-.01-.018h0ZM38.33,21.566h-.016v-.125l-.009-.012v-.207l-.011-.011v-.018l.035.022v.351Zm.009,11.642v-.027a.01.01,0,0,1,.007.015l-.007.011Zm.045,6.207,0,12.14Zm0,0h0l-.095-.011h0Zm0,.053v-.053h.005Zm-.161-10.093v.011l0-.012Zm0,.059Zm.065,20.346.006-.01ZM38.4,49.253,38.341,41.6v.031a.114.114,0,0,1,0-.052h.008Zm-.1-.094h-.015l.034.008h.023a.18.18,0,0,0-.038-.007Zm.109.015h-.016c.007-.128.013-.091.02,0Zm-.07-8.4h0l0,0Zm.014-1.75h0s0,.006,0,0Zm.005-9.8v-.125h0v.125ZM40.833,70.77Zm15.456.163v.01h0l.008-.013Zm0,0h0c0-.024,0-.017.008-.007Zm-.188-.128,4.325-.015-.059,0,.02-.007h-.048v.048h-.013v.016c-.073,0-.146.007-.215.013l-1.693-.033h-.336c-.689.011-.2.03-.511.049-.051-.035-1.031-.043-.523-.063H56.5v.111c-.007.113,0-.079.006-.11h-.436l-.212.006h-.178a1.929,1.929,0,0,0-.274-.007l-.6.012c.162.014.344.019.25.032a2.323,2.323,0,0,1-.577-.03h.072c-.307.01-.631.013-.963.013l-.987-.011h-.044l-.439-.01-.854-.019c-.525-.01-1.02-.008-1.419.01h-.129l-1.239.041c-.635,0,.381-.028-.088-.047-1.488.068-2.362-.017-3.587.031l-.218-.019-.124-.008-.1-.01h-.025c-.44-.018-1.01-.017-1.607-.013h0l-1.073.01h-.77v-.024h-.033v.008h0v-.008l-.07,0-.053-.006-.1-.015c-.066-.011-.129-.025-.188-.041l.064.037a1.594,1.594,0,0,1-.575-.187c.021.034.309.134.122.084a2.712,2.712,0,0,1-1.04-.648,2.013,2.013,0,0,1-.362-.485,2.086,2.086,0,0,1-.2-.588,2.634,2.634,0,0,1-.034-.633l.006-.672q.006-.6.013-1.2h.007c.01-1.08.019-2.159.028-3.224,0-.93-.095-.688-.086-1.531H38.4v-.334h0l.04.318-.01-.318h-.033v-.19a.9.9,0,0,0,.013-.2V59.535h-.053l-.082-.009c-.012,0-.028-.005-.036-.005h.173c0-.788,0-1.569-.017-2.331a2.3,2.3,0,0,1,.023.331c.017-.22.018-.625.011-.978a4.915,4.915,0,0,0-.034-.654c0-.325.024-.075.038-.275.019-.441-.04-1.107-.008-1.342,0-.026.007.034.009.1a5.416,5.416,0,0,0-.029-.961c.01-.408,0-.8,0-1.167h-.015c0-.14,0-.278.007-.41V51.56h0v-.176l-.005-.036a.224.224,0,0,0-.016-.05c.015.013.024-.038.03-.119v-.146a.542.542,0,0,1,0,.057v.064h0c.016,0,0-.012.008-.011v-.011c0-.151-.006-.291-.011-.409h0a.7.7,0,0,1,.005-.1h.025v.1h0a3.871,3.871,0,0,1-.013.431,5.321,5.321,0,0,0,.015-.536h-.025c0-.1.011-.2.024-.1a4.119,4.119,0,0,0-.051-.979c.009-.088.012-.175.017-.262h.032c.007,0-.014-.007-.013-.01h.025l-.017-.008h-.009s.023,0-.011,0v-.019h.006c.056,0-.025-.008.034-.012H38.41v-.057a.193.193,0,0,0,.05-.013.2.2,0,0,0-.049,0h.026c-.041,0-.019-.009-.026-.013h0v-.005h0v-.009h0v-.008h0V49.11h0c.012-.414-.006-.818-.013-1.182h-.005c.005-.078.011-.155.021-.222v-.061h0v.017a.281.281,0,0,1,0-.041v-.155q0-.307-.009-.612-.008-.6-.016-1.2c-.008-.787-.016-1.551-.023-2.3.064.055,0,1.667.067,1.6l-.04-1.7c-.007-.259-.013-.515-.02-.783s0-.569-.008-.886h-.008v-.02h.008v-.014h-.008V41.53h.016v.038a.022.022,0,0,1,.013.009v-.043h0v-.328h0a.443.443,0,0,0,.008-.08v-.833c0-.31,0-.616.01-.916h0v-.6c0-.12,0-.24-.006-.359v-.354l-.006-.013h0c0,.006.006.011,0,.008v.019h-.006v-.054h0v.028l-.013-.024h0a.357.357,0,0,0-.013.065V38.1l-.005-.047-.006-.075a.06.06,0,0,0,.009-.015c.007-.025,0-.009,0-.016v-.032L38.4,37.9h0a.15.15,0,0,0-.019-.038.1.1,0,0,0-.027-.024c0-.084-.008-.168-.012-.243-.009-.162-.017-.287-.023-.3.079.425.021-1.255.121-.579,0-.165-.018-.372-.037-.334.006-.246.017-.322.038-.074-.015-.9-.044-.578-.043-1.391a2.3,2.3,0,0,1,.034.251c-.026-.412-.052-.825-.04-1.512.007.035.016-.016.018.1v-.562a.368.368,0,0,0-.008-.058.177.177,0,0,0-.007-.027h0V32.67c0-.211,0-.417-.01-.636,0-.108-.009-.217-.014-.328v-.368h0v-.074c0-.113,0-.229,0-.35.057.382.02-.44.071-.508l-.014-.7-.025.279c0-.609-.034-1.148-.016-1.672l.02.453L38.4,27.624l-.021.646c-.025-.616-.064.066-.049-.745,0,.165,0-.609.032-.927h0c-.016-.3-.032-.612-.019-1.062.016-.117.056.1.067.018-.042-.3-.009-1.427-.053-1.8.01.126.037.133.042.091l-.034-.25c.012-.282.017-.323.038-.277.008-.849-.065.269-.035-.738,0,.079.008.041.013.206v-1.2H38.4v-.03l.007-.076.017-.19-.005-.057c-.021-.008-.037-.016-.056-.024a1.834,1.834,0,0,1,.16-.6c.079-.111-.008.068-.058.25s-.068.366-.026.222a2.293,2.293,0,0,1,.638-1.218,2.721,2.721,0,0,1,1.218-.708l.008.03h0l-.008-.03h0l-.008-.033a4.845,4.845,0,0,1,.815-.094c-.159.006-.2.046-.163.035.88,0,1.815-.019,3.159-.043l-.167.018c.523.017,1.379.01,1.945.018.168-.018.492-.015.3-.042,1.744.1,3.327-.056,4.875.031-.185,0-.441.016-.294.016l1.318-.017a2.522,2.522,0,0,0-.45-.043c.167-.019.539-.033.866-.033-.593.021.005.05.261.068-.043-.01.045-.02.023-.03.689.056.115-.063,1.056-.026l-.05.017c.352-.009.676-.03,1.056-.026.157.036-.375.017-.4.047.533,0,1.052-.068,1.534-.032L55.19,19c.525.042.586.032.976.038h-.038l.9.02-.23-.012c.667-.1,1.358-.018,2.257-.079-.873.058-.144.034-.211.075a2.265,2.265,0,0,1,.479.036c.425-.033.709.026,1.308-.022.027.013.454,0,.358.034.552-.01-.131-.023-.084-.04.618-.033,1.408.012,2.246.014h.462c.1,0,.247-.006.369,0l.2.02h0c.034.006.066.016.1.023l.171.042v.017h0l-.011.041c.027.006.042.059.062.084,0,0,.006,0,.011-.014a.054.054,0,0,0,0,.018c.007-.029.016-.04.018-.027v-.035h0c.009-.011.009,0,.007.01l-.015.036.013-.009s0,.005.01,0l-.012.024c.009-.01.019,0,.035-.023h.007c0,.005.014,0,.023-.008s.006,0,.01,0-.009.022-.011.021c0,.032.017.007.025-.018a.352.352,0,0,0-.009.036c0,.013.025-.035.018,0l-.006.011c.007-.012.012,0,.019-.018,0,.008.01,0,.017,0s.008,0,.007.008c.018-.037.009.018.027-.028v.013a.048.048,0,0,0,0,.017.081.081,0,0,0,0,.031v.008c.008.007.021,0,.036-.017.007.006.038-.051.017.02l.022-.015a.058.058,0,0,0,.017.018l0,.01.009-.007a.032.032,0,0,1,.007.02.137.137,0,0,1,.023-.047c0,.013.027-.034.005.016h0c-.018.05,0,.041,0,.044l.017-.039h.007c0,.048.059-.034.034.044.011-.015.016-.012.027-.027h0l-.015.032c.007.014.01.021.027.018l-.014.024s.028-.041.046-.07h.006l-.011.025c.013,0,0,.057.04.016a.113.113,0,0,1-.015.023c.005,0,.006.046.039-.025-.018.037,0,.021.017,0h0l-.011.02.013-.019.061.034a.263.263,0,0,1-.031.057.356.356,0,0,1,.046-.049h.007v.009h.007c.007,0,0,.011,0,.012v0h.006l-.01.016h0s0,.009,0,.011a.153.153,0,0,1,.019-.03l.012.008a.018.018,0,0,1-.007.017l.02-.008c.031.019.061.038.093.061h0l.147.091h.006l.009-.007h0c0,.008-.006.014,0,.017l.013-.01.02.014.085.067h.005l-.026.033.026-.028-.019.024h0c-.018.023,0,0,.011-.009l-.021.027.038-.042h0c-.015.018-.03.034-.037.045.015-.016.027-.031.038-.044h0c-.012.015-.02.025-.007.011l-.022.025.03-.029c-.022.028.009,0-.029.041a.281.281,0,0,1,.034-.035c-.048.053,0,.006-.05.064.043-.048.023-.018.048-.043l-.009.009-.021.03c.025-.028.037-.041.05-.054h0c-.02.023-.033.036-.058.066l.053-.058-.037.047c.043-.05.008-.008.036-.038-.02.026-.04.048-.025.034l-.018.02.041-.046c.011-.009-.023.029-.039.049.01-.009.041-.043.041-.04l-.014.016c.027-.029,0,0,.04-.034l-.008.009.009-.011h0l-.014.017.01-.015-.048.055c-.006.012.018-.015.012,0l.042-.047c.034-.031-.074.089-.03.046l.04-.043h0l-.035.038c0,.006.051-.054.03-.026l-.017.016c-.026.032.021-.021.022-.019l-.031.034c.007,0,.033-.025.041-.029l-.028.031c.019-.013,0,.011-.011.035l.028-.028-.017.019c-.008.012.014-.015.026-.027h0a.262.262,0,0,1-.022.025.251.251,0,0,1,.031-.026l-.005.006.006-.007h0l-.017.02c-.006.008,0,0,.011-.008h0l-.009.008c-.006.01.023-.02.034-.031h0v0h0a.225.225,0,0,1-.024.03.285.285,0,0,0,.023-.026c-.014.019,0,0-.006.017l.01-.011s0,.01-.016.026l-.009.01c.023-.021-.01.018-.013.023l-.01.007c.006,0,.007,0,.007,0l.021-.023-.012.015.04-.042-.02.025-.013.013h0l-.008.008c-.01.013,0,.007.005,0h0l.03-.028h0l-.023.025h0v0l.009-.01h0l.013-.013-.012.013.031-.03h0l-.033.036.008-.007.02-.023c.015-.012-.016.025-.031.04l.016-.012h0c.006-.005.007-.006.007,0l-.016.014c.032-.029-.03.032,0,.006l0,0h0l.008-.009c-.006.009-.006.012,0,.007l-.02.02c0,.008.016,0,.018,0a.227.227,0,0,1,.03-.032H65.7l-.019.02.023-.023.009-.009-.042.043.012-.01-.026.026c.02-.019-.028.034.006,0l-.009.009a.064.064,0,0,1,.019,0c.027-.027.022-.02.044-.041-.006.011-.025.034-.021.034a.355.355,0,0,0,.04-.038.408.408,0,0,1-.039.041c.007,0,.009,0,.032-.018l.007-.007h0l-.008.008h0c.009-.007.008,0,.007,0h0c-.007.007,0,.006,0,0-.013.019-.051.061-.012.028h0l.03-.023c0,.006-.019.017-.034.033.045-.037,0,.011.03-.013-.072.072.013,0-.031.05l.017-.017c.018-.015-.009.011-.012.015l.025-.024h.007l.031-.029h0l-.125.151.145-.152.021.021-.044.042.03-.025-.022.021h0c-.021.02,0,0,.012-.008L65.777,20l.046-.039-.126.047.055-.049c-.021.02-.038.035-.019.02L65.708,20l.033-.025c-.026.024.009,0-.036.036l.039-.031c-.055.046,0,0-.059.056.049-.042.024-.015.052-.037l-.009.008-.026.026.072-.059h0l-.08.07.06-.05-.044.04A.329.329,0,0,1,65.751,20c-.024.023-.047.041-.03.029l-.034.028.059-.05c.022-.018-.027.025-.046.042.011-.008.046-.037.045-.035l-.016.014c.031-.025,0,0,.043-.029l-.009.008.025-.022h0l-.011.009h0L65.769,20l.018-.013h0a.159.159,0,0,0-.032.026L65.767,20l-.055.047c-.008.011.02-.013.011,0l.048-.041c.037-.027-.086.077-.038.04.024-.019.068-.057.046-.035l-.04.033s.058-.047.033-.023l-.019.014c-.03.028.024-.017.024-.017l-.035.03.043-.025-.032.027c.02-.012,0,.01-.018.03l.03-.024h0l-.019.016c-.009.008.007,0,.021-.016h0l-.02.017a.293.293,0,0,1,.037-.024l-.009.008.01-.008h0l-.02.019h0l.038-.028H65.8l-.028.025a.2.2,0,0,0,.027-.022h0c-.016.016,0,0-.009.015l.01-.009a.109.109,0,0,1-.023.025l.017-.012-.023.018c.025-.018-.013.016-.017.02l-.011.007h.007l.025-.021-.014.013.037-.029-.02.019-.01.007h0l-.009.007c-.02.018.005,0,.024-.016l.007-.006.008-.005-.018.014h0l-.012.011.033-.026.013-.01h0l-.038.031.009-.006.023-.02c.016-.011-.02.021-.037.035l.02-.012-.006.005h0l-.015.011c.035-.025-.034.027,0,0l.009-.007h0l.008-.006h0l-.023.018c0,.007.015,0,.016,0l.033-.027h.006l-.02.016.024-.019.009-.006-.044.035.013-.008-.029.022c.022-.016-.033.029,0,0l-.011.008s.015,0,.018,0l.049-.035c-.008.009-.03.029-.026.029l.044-.033c-.027.021-.023.021-.044.035.006,0,.008,0,.033-.015l.009-.007h0l-.01.008h0c.009,0,.01,0,.008,0h0c-.016.016-.062.055-.019.026h0l.032-.02s-.021.015-.038.029c.049-.032,0,.01.03-.011-.081.063.011,0-.039.043l.019-.014c.02-.013-.011.009-.014.012l.027-.021h.007l.059-.043c.013.015.026.027.039.043a2.162,2.162,0,0,1,.168.262l-.023.012a1.326,1.326,0,0,0-.143-.211,2.055,2.055,0,0,1,.132.217l-.082.042a1.907,1.907,0,0,1,.107.269c.014.045.025.09.035.133s.013.063.023.131h0v.009h0c0,.021.005.046.005.062,0,.043,0,.047-.017.034a3.805,3.805,0,0,1,.051.453c.009.095.007.21.01.32v.825c0,.247,0,.487.008.7a1.453,1.453,0,0,1-.01-.218l-.013.383c0-.073,0,.086-.009.161a2.8,2.8,0,0,0-.013.286.106.106,0,0,1,.014.04h.059l.01.153v.381h.014v.065c0,.042-.007.09-.011.144-.032.1-.051-.5-.091-.356a1.9,1.9,0,0,1,.046.47l.018.3v.08l-.007.141a2.031,2.031,0,0,1-.031.231.2.2,0,0,1,.032.1v.15h-.013c-.012.191-.021.228-.026.3v.435c-.021.342-.043-.3-.043-.3,0,.732.049.344.077.5v.3h0a.58.58,0,0,1-.059,0,.168.168,0,0,1,.059.007H66.2c-.013,0,.024,0,.01.006h.027c.023,0-.005.009-.033.013h.037V27.2h0v.006h0c-.025,0-.025,0-.015.005H66.2c-.007,0,.014.007.013.011h-.026l.017.009h.034v.009h0v.008h0c-.014.068-.038-.016-.053.156,0,.231.015.438.027.634l.011.171a.028.028,0,0,0,0,.013l-.013-.03a.111.111,0,0,1,.008.048l.012-.007.006.087v.026s-.008,0-.009-.006c-.019.037-.006.044.011.053v0h0v.055c-.008.007-.013.017-.01.023a.012.012,0,0,1,.01-.015v.057h-.017c.009,0,.012.013.018.02V28.6c-.008.031-.011.11-.022.017.005.067.009.143.012.224h0c.007.188.01.407.013.64v.582c-.007,0-.009.009,0,.025v.15h-.01c-.007.089.014.188.013.289h0v.068l-.016-.006c.027.019-.044.079,0,.105H66.21c0,.1.015.146.017.227a.032.032,0,0,1,.024.009V31a.663.663,0,0,1-.012.088A.314.314,0,0,1,66.27,31v.022a.469.469,0,0,0-.028.158c.019.051.032.015.055.038-.034,0-.031.076-.056.039v.128h0v.174a.7.7,0,0,0-.013.158h.007a.2.2,0,0,0-.009.144.033.033,0,0,1-.025.036c0-.057-.007-.075-.023.018l-.006.007h0a.867.867,0,0,1-.013.089c-.013,1.046.023,1.17.012,2.21.026.235.038-.077.064.158a8.621,8.621,0,0,1-.053,1.4h0l-.009.006h.009a5.072,5.072,0,0,0-.007.845,4.857,4.857,0,0,1,.055,1.168l-.051-.265c-.007.933.061.641.043,1.417H66.2c-.007-.24-.005-.531-.01-.42a3,3,0,0,0,0,.553v.011h0l.014.119a.3.3,0,0,0-.032.059c0,.006.007.009.02.012a.037.037,0,0,0,.007.019h0a.053.053,0,0,1,.019.027v.093h0c-.017,0-.016.013-.008.02l-.009.014a.041.041,0,0,1,.022,0h-.018c-.015.007.019.017.017.023h-.02l0,0c-.01.007-.007.015-.008.023h.032v.03h0l-.045.109v.026h0c0,.1,0,.2,0,.3h0q.011.63.022,1.294h-.022l-.007.045h.03v.026h.009c.007.549.013,1.111.02,1.674-.013-.066-.028-.271-.042.009v.372h-.017l.019.432v.387h-.034l.034.017v.063c-.01.006,0,.017,0,.024h0v.059l-.008.009.008.007v.018h0v.067h0V44.5h0v.011c-.012,0-.025,0,0,.012h0v.048h-.013a.233.233,0,0,0,.012.082v.034H66.2c.028.006-.043.027,0,.035h-.013a.228.228,0,0,0,.017.067c0,.252-.007.5-.011.747a.178.178,0,0,0-.013.032c0,.006,0,.009.013.012-.006.382-.013.759-.02,1.117l.04.556c0,.129-.018.24-.026.1-.015.567.025.029.041.3v.059h-.02l.007.239c-.008.049-.018.029-.023-.078v.149h.022c0,.123.007.25.011.382s-.006.248,0,.379v.151a.084.084,0,0,0,.008.044v.182l0,.217v.788c-.006.34-.011.656-.016.923l-.014-.2c-.008.683.063.871.066,1.355l-.036.007h-.008l.042-.009h0l-.038.007h.008l.031-.006h.005v.032h.006v.005h0c0,.084,0,.178-.007.285l-.007-.146v.768l-.011.147c0,.268.008.538.013.806v.032l-.038.006h.038l-.029.005v-.006c-.028.006,0,.007.015.008a.16.16,0,0,0-.033.008h.05c-.02,0-.04,0-.05.012a.14.14,0,0,0,.05-.006v.01c-.006,0-.011.005-.009.007h-.014l-.041.015.032-.011h.009l.018-.006h.007l-.015,0h0l-.024.009.025-.008h.007c-.023.007-.037.012-.022.008l-.044.012.078-.022c-.021.007-.041.013-.062.018l.036-.008h.027l-.051.006h.051c-.03,0-.067,0-.032.007h.032v.005h-.026a.1.1,0,0,0,.026.012v.012H66.26c.023.01-.006.022-.033.031h.038v.021h0v.044h0v.006c-.012,0-.009.005,0,.008v.005h0v.089h-.029l.021.006H66.24c.042.006-.044,0,0,.008h.032c-.023,0-.024.008-.014.013h-.029a.017.017,0,0,0,.007.016h.032a.076.076,0,0,1-.03,0h-.011c-.009,0-.032.005,0,.008h-.013c0,.009.015.013.017.021a.1.1,0,0,1,.035,0h-.02c.031,0-.033.006-.007.011h.027c-.008,0-.015.006-.013.009h-.006a.044.044,0,0,0,.015.012h0v.023c-.024.007-.05.013-.011.018h.015v.006a.053.053,0,0,0-.025,0c.052.009.007.015.025.022h0c-.091.007.011.022-.053.031h.04c.024.016-.016.032-.042.049h.057v1.27h-.008v.02h-.019l.006.045h.012c0,.288-.011.562-.021.812.059.258-.029,1.761.051,1.876-.042,1.016-.056.724-.086,2.155,0,.383.048.57.056,1.042l-.042.013.039.6h0l-.011.076-.026.169.007.444a1.173,1.173,0,0,1,.034-.349v.492a1.566,1.566,0,0,0,.005.194v-.031l-.005.1h-.018v.083h0c0,.073,0,.147-.006.211l-.01.188a.93.93,0,0,1-.019.176l.02.82.009.389a.182.182,0,0,0-.015.027v.008l-.006-.131,0,.132v.006a.2.2,0,0,0-.009.035v.02a.31.31,0,0,0-.015.121h0v.316H66.2c0,.164,0,.346.007.537l.018.249.006.062v.158h-.006l-.013-.012.007.009.012.01h0v.211h-.022a.085.085,0,0,1,.022,0v.046h0v.017h0v.021h0v.027a.1.1,0,0,1-.035,0c0,.008.016.008.035.008v.01h-.02l.02.008v.068h-.007v.007l-.02-.09v.247h0v.03h0v.2h-.007V68.2h0v.322a2.279,2.279,0,0,1-.066.442,2.082,2.082,0,0,1-.161.423,2.515,2.515,0,0,1-.253.386,2.905,2.905,0,0,1-.378.366c.183-.141.252-.2.253-.175a.8.8,0,0,1-.227.241c-.049.019-.1.037-.148.053-.188.16.338-.209-.063.1-.212.124-.3.139-.288.124a1.25,1.25,0,0,1,.214-.154,2.8,2.8,0,0,1-.525.255c-.036,0,.091-.052.117-.081a1.483,1.483,0,0,1-.347.113c-.076.017-.158.03-.243.042-.057.007-.131.014-.161.016l-.02.005-.1.017-.035-.011c-.482.029-.866.027-1.166.019h0l-1.857.008a.881.881,0,0,1-.306.033Zm-22-20.1v-.065h0a.1.1,0,0,1,.009.056ZM65.543,19.631m-.178-.061Zm0,0Zm.02,0Zm-.422-.179v0h0Zm.028-.023h0c0,.007-.01.023-.009.014,0,.015.009,0,.016-.011h0l-.014.02A.017.017,0,0,0,65,19.385V19.4l.013-.021h.007c-.006.007-.007,0-.019.024l.014,0V19.4l.007-.011.011-.006,0,.008c0,.016.011,0,.02,0l.007,0h0l-.009.021c-.008-.006-.014-.011-.012-.013l0,.012-.06-.032a.092.092,0,0,1,.032-.03Zm.079.076h-.01c.012-.016.023-.028.017-.008V19.43l.012.007a.1.1,0,0,1-.011.028l-.011-.007.007-.015,0-.009Zm.056.012.008.005h0c-.005,0-.007,0-.013.012.009-.007.015-.006.023-.01l.012.007h0l-.009.012v.009l-.04-.02a.154.154,0,0,0,.026-.025Zm.05.054L65.16,19.5l.019-.014.029.017-.015.022a.029.029,0,0,0-.01-.028Zm.016.02h0l0-.011Zm.134,0c.012-.008.008,0,0,.02l-.013-.009Zm.025.026h0v.005h0Zm.007.029-.465-.258-.012.027h-.006l.022-.033Zm.064.066h0V19.4h0Zm0,0,.061.031h0a.674.674,0,0,0-.063-.029Zm.106.057.011.007h0Zm.032.021.017.011Zm.091.051h0l.015-.023.016.009v.005h0l.019.011v0h0a.086.086,0,0,1-.011.024c.022-.025-.008.026.025-.01-.007.011,0,0-.015.03l-.056-.036Zm.072.009h0l.012.006v.015h0a.022.022,0,0,0,.014-.007h0l-.007.011.01-.01.022.011c-.005.015,0,.023.006.017l-.009.011h0l.007-.01h.007l-.013.015.018-.012h.007l.007-.012h0v.006h0l-.007.012h0l-.015.014h.008v0h.006l-.012.022h0c0-.008-.009.009,0-.011l-.008.012h0v.008l-.089-.058a.079.079,0,0,0,.045-.041Zm.073.083h0l-.007.006h-.006Zm.011,0h0l.012-.022.011-.007.015-.006h0a.221.221,0,0,0-.022.029l-.008.006h0l.01-.007h0l.008-.008h0l.014-.014,0,.008h0l-.008.012-.013.01Zm.013-.008-.007.011h0Zm.013.011h.008l.057.019h0V19.63l.063.053-.02.025-.082-.053-.036-.022Zm.44.265-.264-.143Zm.033.019.22.252-.008.007h0l.007-.006Zm-.1-.1Zm.075-.043.025.027-.018.016-.025-.024Zm.014.148,0,0,.007-.006h0Zm.1.108-.009.005Zm-.381-.455-.039-.031-.029-.022a.06.06,0,0,0,0-.019l-.033-.011a.084.084,0,0,1,.012-.023h0v-.007h0l-.009.012.009-.011.01.007c.034.024.062.053.094.08Zm.739,44.12V63.76a.108.108,0,0,1,0-.044c0-.006,0-.009.008-.011v.085h0Zm.024-9.553h0Zm.029-1.969,0,0-.055-13.12s.006.008,0,.013l.017-.005v.02c-.013,0-.023.009-.006.021h-.01C66.238,39.176,66.237,39.166,66.237,39.146Zm0-7.033a.061.061,0,0,1,0,.046l.037-.052a.062.062,0,0,1,.007.056.042.042,0,0,0-.014-.009v0a.014.014,0,0,0-.011.006.048.048,0,0,0,.008.018V32.2l0,.007h0c-.033.224-.026.032-.026-.092Zm.009,7.16v-.032c0,.01,0,.025,0,.032Zm.047,4.82.016,8.149.07,11.564-.1-42.817h0L66.256,21h-.007Zm-.077.045.08,0h0v.017l-.069.04Zm0,3.51V24.6h-.007a.589.589,0,0,1,0-.084c.01-.014.008.023.01.036Zm-.013.4,0,0,0,.322-.006.031c0,.017,0-.014,0-.016v-.013c.007.008.012.006.017,0Zm.022,5.9h0v0Zm-.032,1.034h.022c.014.452.027.895.019,1.226-.046.107-.016-1.2-.057-.516Zm-.017,7.081h-.008v-.008Zm0,.01v.071a.365.365,0,0,0,0-.07Zm.037,3.924h0v-.353c.007.071.008.173.008.349Zm.017,9.027,0,.018,0,.015h0Zm-.018,1.95,0,.209Zm0,.015Zm0,0,0,.006h0v.005h-.008Zm0,.022-.02,9.306Zm-.021,1.832v.071a.06.06,0,0,1,0-.03.141.141,0,0,1,0-.029Zm0,1.971-.008-.035.007.008Zm0-41.554v.179c0,.024,0-.008,0-.018v-.041a.932.932,0,0,1,0-.118ZM66.163,20.4a1.981,1.981,0,0,0-.171-.273c-.011-.014-.026-.027-.037-.041l.015-.011L66,20.12a2.525,2.525,0,0,1,.167.278ZM49.514,18.942a2.317,2.317,0,0,1-.463.032c-.017-.009-.033-.021-.018-.032ZM66.967,46.727h0l.018.008h0Zm.026.013h0c.009.007,0,.021,0,.027a.054.054,0,0,1,0-.018h0ZM61.814,18.383v-.006h.007ZM37.578,37.166,45.49,71.4h0c0-.008,0-.008,0,0ZM66.881,53.337Zm.16-7.1-.006-4.994v-.291a.633.633,0,0,0,.019-.075c0,.144.007.3.009.386a.131.131,0,0,0-.028-.02Zm0-.6.021-15.166c.006.006,0,.008-.01.008v-.01h0Zm-.1-4.763-4.879-2.341v.013h0Zm-.257.014Zm-.01-.008v.007H61.8v-.012a.021.021,0,0,1,.017,0Zm-.029,0v.009h0c0-.008-.008-.009-.011,0v-.013h.016ZM50.956,18.5V18.5c.006,0,.007,0,.007-.012Zm-13.334,39.3L37.6,57.8a.085.085,0,0,1,.034-.014Zm-.04.014v.021c-.014.007-.024.011-.025,0a.086.086,0,0,1,.033-.027Zm0,.92v-.1c-.013.017,0,.045-.005.066v-.038c0-.083-.005-.176-.008-.269v-.542l.018-.009v.1a.228.228,0,0,1,0-.037h0v.662c0,.111,0,.219.007.326a.757.757,0,0,1-.006-.165Zm0,9.711v-.19h.044v.01l-.016.178h.043Zm2.3,2.886a.1.1,0,0,1-.025-.019l-.009-.012.04.014h0l.014.007-.008.015h-.015Zm.185.053-.087-.019-.046-.012-.027-.009H39.9l.009-.018h.008l.026.009.045.014.086.024c.058.015.115.028.172.04-.047-.014-.11-.022-.169-.035Zm5.358.112c-.01,0-.018,0-.018,0Zm.044-.029c-.014,0-.019-.01.008-.012v.006Zm.014-.054h0l.006.009h0Zm2.064.054h.045a.121.121,0,0,1-.038-.006Zm11.764.029h.011c-.007,0-.014.005-.022,0s.012,0,.018-.006Zm.121-.04Zm1.4-.046h.494a2.105,2.105,0,0,1-.475.036c-.011-.019-.028-.031-.013-.042ZM66.9,63.289l-.032.2V62.9a3.461,3.461,0,0,1,.038.381Zm0-3.855c-.009.1-.024.17-.036.137v-.71Zm-.009-6.093Zm.138-2.194h0c.019,0,.007.019.011-.005Zm.022-1.758,0-.021v.018h0v-.018Zm-.024-3.128h0v0ZM67,44.258v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22541",
    "data-name": "Path 22541",
    d: "M66.882,55.144c.022.33.06.711.1.5-.043-.327-.025-.406-.076-.758,0-.282.014-.491.031-.443-.012-.1.01-.436-.018-.588a8.853,8.853,0,0,0-.007,1.313C66.907,55.267,66.89,55.165,66.882,55.144Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22542",
    "data-name": "Path 22542",
    d: "M66.991,58.927c0-.1-.006-.174-.012-.247v.232Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22543",
    "data-name": "Path 22543",
    d: "M66.987,59.077v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22544",
    "data-name": "Path 22544",
    d: "M66.969,58.93a.566.566,0,0,1,.016.147v-.164C66.978,58.9,66.972,58.9,66.969,58.93Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22545",
    "data-name": "Path 22545",
    d: "M37.533,52c0-.28,0-.564.006-.784Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22546",
    "data-name": "Path 22546",
    d: "M62.611,18.367a1.368,1.368,0,0,0-.18.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22547",
    "data-name": "Path 22547",
    d: "M37.568,48.485a.113.113,0,0,0-.011.048v.09l-.011.268.018-.217.008-.115v-.068Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22548",
    "data-name": "Path 22548",
    d: "M37.58,48.484l-.007.015v.016a.048.048,0,0,0,.009-.013v-.015Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22549",
    "data-name": "Path 22549",
    d: "M37.519,37.215v-.029A.043.043,0,0,0,37.519,37.215Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22550",
    "data-name": "Path 22550",
    d: "M67.028,52.459v.006h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22551",
    "data-name": "Path 22551",
    d: "M37.572,50.094Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22552",
    "data-name": "Path 22552",
    d: "M37.538,47.342v-.117A.761.761,0,0,0,37.538,47.342Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22553",
    "data-name": "Path 22553",
    d: "M37.61,67.171V67.1C37.609,67.13,37.609,67.152,37.61,67.171Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22554",
    "data-name": "Path 22554",
    d: "M66.913,56.331a.676.676,0,0,0,0,.09Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22555",
    "data-name": "Path 22555",
    d: "M66.566,69.932c-.042.064-.094.119-.14.179l-.007.015Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22556",
    "data-name": "Path 22556",
    d: "M37.535,26.765Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22557",
    "data-name": "Path 22557",
    d: "M67.029,52.46v.022h0l.006-.022v-.03Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22558",
    "data-name": "Path 22558",
    d: "M67.074,41.627v-.008S67.073,41.614,67.074,41.627Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22559",
    "data-name": "Path 22559",
    d: "M67.034,20.728l0-.022h0v.005Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22560",
    "data-name": "Path 22560",
    d: "M51.1,18.314a.025.025,0,0,0-.031,0H51.1Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22561",
    "data-name": "Path 22561",
    d: "M67.024,20.7",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22562",
    "data-name": "Path 22562",
    d: "M37.556,23.131a.663.663,0,0,0,0,.126v-.232a.081.081,0,0,0,0,.038Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22563",
    "data-name": "Path 22563",
    d: "M37.592,58.206V58.05A1.016,1.016,0,0,0,37.592,58.206Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22564",
    "data-name": "Path 22564",
    d: "M50.987,18.314",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22565",
    "data-name": "Path 22565",
    d: "M48.663,18.362h0C48.634,18.369,48.665,18.36,48.663,18.362Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22566",
    "data-name": "Path 22566",
    d: "M50.987,18.314",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22567",
    "data-name": "Path 22567",
    d: "M52.366,18.317h0a.131.131,0,0,0,.028,0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22568",
    "data-name": "Path 22568",
    d: "M60.6,18.353h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22569",
    "data-name": "Path 22569",
    d: "M60.527,18.357h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22570",
    "data-name": "Path 22570",
    d: "M64.084,18.386v.01l.133.01Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22571",
    "data-name": "Path 22571",
    d: "M66.169,70.413c-.08.078-.153.14-.211.195A2.176,2.176,0,0,0,66.169,70.413Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22572",
    "data-name": "Path 22572",
    d: "M66.325,70.253c-.048.056-.1.108-.152.159C66.219,70.367,66.271,70.316,66.325,70.253Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22573",
    "data-name": "Path 22573",
    d: "M66.976,68.154a.157.157,0,0,0-.016-.052v.005Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22574",
    "data-name": "Path 22574",
    d: "M37.584,62.159h0v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22575",
    "data-name": "Path 22575",
    d: "M42.008,71.455l-.407.017A1.425,1.425,0,0,0,42.008,71.455Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22576",
    "data-name": "Path 22576",
    d: "M37.532,52.082Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22577",
    "data-name": "Path 22577",
    d: "M41.008,71.473c.231.013.418,0,.593,0C41.417,71.464,41.2,71.475,41.008,71.473Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22578",
    "data-name": "Path 22578",
    d: "M67,56.408a.034.034,0,0,0-.006-.015v.144Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22579",
    "data-name": "Path 22579",
    d: "M66.989,56.25a1.138,1.138,0,0,0,0,.143Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22580",
    "data-name": "Path 22580",
    d: "M66.975,55.949l.01.3A2.717,2.717,0,0,0,66.975,55.949Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22581",
    "data-name": "Path 22581",
    d: "M66.98,61.168c0-.257.029-.645.021-1l-.011-.034C67.011,60.3,66.957,60.921,66.98,61.168Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22582",
    "data-name": "Path 22582",
    d: "M47.547,71.486",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22583",
    "data-name": "Path 22583",
    d: "M47.549,71.479h.025l.029-.006C47.585,71.476,47.544,71.473,47.549,71.479Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22584",
    "data-name": "Path 22584",
    d: "M47.551,71.485",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22585",
    "data-name": "Path 22585",
    d: "M47.547,71.484a.021.021,0,0,1,0-.011C47.546,71.48,47.546,71.482,47.547,71.484Z",
    fill: "#515151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_426",
    "data-name": "Ellipse 426"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18560",
    "data-name": "Group 18560"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_443",
    "data-name": "Ellipse 443",
    cx: 1.461,
    cy: 1.461,
    r: 1.461,
    transform: "translate(50.905 65.377)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18559",
    "data-name": "Group 18559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22586",
    "data-name": "Path 22586",
    d: "M52.366,65.484c0-.015,0-.046-.011-.038l-.008.053Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22587",
    "data-name": "Path 22587",
    d: "M52.277,65.389a.162.162,0,0,0-.014.12c.011-.051.016-.03.028-.092.013-.007.023.017.022.036,0-.014.02.01.026-.023-.017-.039-.04-.041-.06-.006A.059.059,0,0,1,52.277,65.389Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22588",
    "data-name": "Path 22588",
    d: "M51.116,65.949h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22589",
    "data-name": "Path 22589",
    d: "M50.807,66.735a.012.012,0,0,0-.011-.011C50.8,66.73,50.8,66.736,50.807,66.735Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22590",
    "data-name": "Path 22590",
    d: "M50.745,66.882v-.009S50.74,66.88,50.745,66.882Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22591",
    "data-name": "Path 22591",
    d: "M51.116,65.947l-.027.009C51.1,65.967,51.106,65.954,51.116,65.947Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22592",
    "data-name": "Path 22592",
    d: "M52.123,65.536a.036.036,0,0,0,.008-.015l-.009.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22593",
    "data-name": "Path 22593",
    d: "M51.337,65.64h0l-.01-.021Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22594",
    "data-name": "Path 22594",
    d: "M51.575,65.464c-.007,0,.014.042.022.06-.006-.018-.007-.028,0-.034A.144.144,0,0,0,51.575,65.464Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22595",
    "data-name": "Path 22595",
    d: "M52.029,65.369l.006-.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22596",
    "data-name": "Path 22596",
    d: "M51.182,65.782l-.014-.009Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22597",
    "data-name": "Path 22597",
    d: "M52.634,65.618v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22598",
    "data-name": "Path 22598",
    d: "M52.366,65.362h0v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22599",
    "data-name": "Path 22599",
    d: "M50.719,67.173h0C50.714,67.163,50.715,67.163,50.719,67.173Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22600",
    "data-name": "Path 22600",
    d: "M52.715,68.448c-.036-.032.034-.062-.017-.1C52.706,68.368,52.674,68.432,52.715,68.448Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22601",
    "data-name": "Path 22601",
    d: "M52.116,65.532h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22602",
    "data-name": "Path 22602",
    d: "M52.7,68.353Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22603",
    "data-name": "Path 22603",
    d: "M51,67.769a.109.109,0,0,0,.013-.017A.037.037,0,0,0,51,67.769Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22604",
    "data-name": "Path 22604",
    d: "M50.848,67.31v.013A.028.028,0,0,0,50.848,67.31Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22605",
    "data-name": "Path 22605",
    d: "M51.206,67.923c0,.007,0,.013.009.015v-.006S51.206,67.933,51.206,67.923Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22606",
    "data-name": "Path 22606",
    d: "M51.394,68.092v-.009h-.008Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22607",
    "data-name": "Path 22607",
    d: "M53.187,65.868a.217.217,0,0,1,.019-.037C53.187,65.859,53.158,65.846,53.187,65.868Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22608",
    "data-name": "Path 22608",
    d: "M52.119,65.512v.02h.006A.059.059,0,0,0,52.119,65.512Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22609",
    "data-name": "Path 22609",
    d: "M51.471,67.685l.016.028A.071.071,0,0,0,51.471,67.685Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22610",
    "data-name": "Path 22610",
    d: "M53.592,67.191v-.009S53.588,67.188,53.592,67.191Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22611",
    "data-name": "Path 22611",
    d: "M51.561,67.771a.073.073,0,0,0-.007.036l.01-.006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22612",
    "data-name": "Path 22612",
    d: "M53.206,65.831",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22613",
    "data-name": "Path 22613",
    d: "M52.972,65.8c.024.016.042-.042.065-.068.041,0-.008.046-.014.078.028,0,.073-.038.085-.025s0,.014-.014.021c.047-.023.059.041.119.013l-.007.014a.353.353,0,0,1,.049-.066c.011.01.045-.009.024.024-.006-.007-.017,0-.028.011h.023c-.026.051-.028,0-.055.032.033.006.091,0,.1.023-.034.043-.052-.022-.063.033l-.012-.039c-.038.082-.011-.018-.055.067.02.041.056.01.074.053.028-.014.03-.034.058-.047.085.012-.068.129.017.114.035-.014.092-.053.084,0l-.056.029c.021.037.086-.033.08.028-.025.007-.037-.016-.039-.006-.022.051.041,0,.055.015l-.043.035c.029.034.093.056.125.1-.016,0-.034,0-.044.023a.2.2,0,0,1,.039.193l.053.007c0,.005-.018.016-.028.013-.012.028.029-.007.049,0s-.022.025-.037.021c.049.028.116.1.07.153l-.015-.007c-.014.036.1.026.063.065l-.009-.005c-.014.078.033.166-.044.221.067.017-.034.072.058.087-.053.038-.068.023-.108.077-.006.014.053.035.058.057l-.048-.01.043.039h-.061l.008.021a.039.039,0,0,1,.039,0c.015.036-.052.06-.077.052l.016.079c-.018-.009-.021-.022-.029-.035.035.052-.051-.013-.019.035.012,0,.026.014.036.018a.065.065,0,0,0-.052.069l-.028-.02c-.027.042-.035.1-.065.148.024-.009.071.027.067.045l-.047-.023c.021.027.026,0,.047.037-.018.015-.058-.022-.065-.041v.031c-.014-.008-.017-.018-.032-.03.02.028-.068,0-.032.049l-.013-.008c-.031.045-.039.072-.066.109.032.032.013.038.029.075-.037.014-.089.013-.117.044-.008.036.018.035.024.064-.028-.031-.059,0-.059-.039a.356.356,0,0,0-.081.107c.015.011.026.013.03.027s-.033,0-.041-.018v-.005c-.034.1-.2-.028-.212.07v0l-.04.062c-.028,0,0-.035-.022-.052-.037.089-.1.017-.135.076-.062-.112-.139.036-.2-.042V68.1c-.012.029-.018-.015-.028-.021,0,.022.016.025.008.041-.12.042-.244-.048-.346-.1-.038-.019-.062.136-.1.057l.031-.047c-.1.035-.165-.062-.265-.055.011-.008.018-.021.025-.018,0-.042-.056-.036-.073-.009-.01-.01.012-.026.013-.044s-.066.019-.053-.021c0-.005.011-.007.015-.007-.02.009-.041-.037-.058.006-.013-.038-.063-.021-.066-.06-.045.026-.026-.054-.077-.007.051-.052,0-.08-.04-.073.021-.01,0-.029.032-.044a.041.041,0,0,0-.058-.008L51.4,67.7c.036-.086-.111-.026-.038-.113a.474.474,0,0,1-.176-.127c.063-.031.041.06.106.019-.058-.033-.125-.042-.138-.1,0-.018.033,0,.046,0-.052-.044-.037-.11-.09-.15a.043.043,0,0,1,.022.006c-.005-.01,0-.027-.027-.017l.011.008c-.042.031-.107-.016-.132-.013.1,0,.009-.061.132-.059a.061.061,0,0,0-.046,0c0-.012.015-.018.042-.013-.027-.033-.057-.014-.062-.049h.042c-.033-.012-.067-.026-.058-.058h.023c-.015-.049-.09-.082-.065-.142.07.015.022-.021.081-.024a.149.149,0,0,1-.018-.03l-.03.012c0-.026-.04-.053-.019-.075l.024.022-.009-.052L51,66.771c-.03-.03-.076,0-.058-.039.006.009,0-.029.04-.04h0c-.017-.016-.034-.033-.017-.052.02,0,.065.014.078.013-.047-.021-.005-.065-.053-.093a.108.108,0,0,0,.049.015L51,66.555c.016-.009.023-.01.047,0,.017-.035-.077,0-.034-.042,0,0,.009,0,.013.013.028-.04,0-.094.032-.128.061.008,0,.039.055.042.008-.057-.026-.142.016-.19l-.011.007c-.072-.045.056-.021.034-.066,0,.009.037.031.029.025.033-.027.023-.079.035-.147l.014.019c.03-.008.046-.043.07-.058-.013-.019,0-.029-.032-.042.144.021.051-.163.179-.137-.006.006,0,.027,0,.023l.03-.055c-.028-.025-.02-.012-.049-.025a.053.053,0,0,1,0-.057c0,.038.038.045.061.054-.009-.008-.013-.02-.022-.028.067.033-.042-.062.021-.053l.01.017c.007-.018,0-.048.022-.055.031.031,0,.027.017.057.018-.016-.007-.1.037-.073,0,.016-.016.023-.017.04.048.027.043.017.063.014h.047l-.016-.006c-.031-.111.041-.052.045-.134-.005.079.012.039.032.083.016.007.036.014.039.028,0-.043.041.015.04-.049.008.014.019-.008.031.03.017-.022-.016-.022-.022-.041.015-.067.106.03.132-.059.037-.042.032-.094.072-.132.021.021,0,.059,0,.059.03.017.046.006.065-.015a.074.074,0,0,0,.015.041c.017-.007,0-.058.03-.039a.462.462,0,0,1-.008.065c.018-.017.035-.05.056-.067.009.027-.008.043-.013.062.022-.016.06-.035.064-.077l-.018-.014c.009,0,.008.036,0,.045-.018.037-.033-.01-.036-.026l.015-.012c-.028-.088-.064.025-.1.024v-.068l-.024.059c-.01-.015-.023-.051-.008-.064-.031-.028-.016.028-.045,0v-.011l-.019.026c0-.015-.015-.045,0-.039-.053-.026-.056.066-.086.022h0c-.052.04.008.048-.016.118l-.069-.1.011.048a.019.019,0,0,1-.024-.015v0c-.01.04.011.018.01.053-.046-.033-.067.05-.1-.018.006.039.038.014.02.051-.044-.072-.027.029-.068.006-.012-.042.023-.034-.021-.056.018.072-.058.01-.072.036.028.051-.032.048-.055.085-.01-.02-.079.016-.122.023l-.005-.009c.03.052-.008.064-.021.093a.08.08,0,0,1-.026-.064l-.02.018a.053.053,0,0,1,0,.049l-.024-.038c-.025.027-.019.085-.071.1.028.03.1.055.094.108-.017-.014-.046-.039-.044-.055,0,0,0,.023-.008.022l-.015-.04c-.025,0,.015.029,0,.039-.023-.022-.025-.007-.042-.025,0-.005.019,0,.014-.014a.083.083,0,0,1-.069,0c.014.011.032.027.026.041-.022.028-.037-.017-.064-.012.011.021-.021.025.016.055-.006.008-.025,0-.037-.009.005.028-.047.073.006.086h.005c0,.072-.089.088-.1.149L51,66.115c0,.039-.026.076-.006.112,0,.009-.037.01-.052,0,0,.03.013.038-.024.065-.016-.035-.026,0-.009-.034-.025.028-.052.027-.024.079a.031.031,0,0,0-.044,0,.028.028,0,0,0-.008.029l.036-.015a.105.105,0,0,1-.019.049l-.048-.025c-.083.058.071.157-.045.189.034.026.032-.035.072-.009-.012.031-.093.054-.1.065-.036.044.069.054.045.1.019,0,.07,0,.086.032-.009.031-.082.035-.1.013a.008.008,0,0,1,.006-.011h0c-.006-.012-.014-.027-.035-.015l.018.005c-.02.017-.02.064-.051.051.017.028.031.013.042-.006-.029.043-.007.069-.022.116.01-.008.032-.015.033-.008-.02.067.037.028.048.071-.028.027-.07,0-.043.038-.018.029-.05.011-.066,0,.037.039-.014.081-.018.108l-.019-.021a.067.067,0,0,1,.014.036l.036-.019c0,.015,0,.025-.019.027.027.009.061-.02.1,0-.016.021.027.047-.02.063.007-.057-.049.016-.065-.029a.034.034,0,0,1,0,.034.012.012,0,0,1-.014,0c-.032.062.062.012.074.065-.03,0-.05.026-.041.033-.005-.022.043-.022.069-.009-.013.039.025.032.027.049l.005-.023c.029,0,.029.016.046.035-.021.009-.022-.015-.028,0,.056.007-.029.072.016.1-.012.023-.049.021-.056.04.048.026-.018.058.029.087.029-.028.02-.024.067-.014l-.056-.054.071.019c-.008-.019-.042-.03-.04-.045.036.008.028.009.052-.012-.04.049.055.037.034.082l-.086.041c-.016.068.085.06.1.127V67.7c.037-.012.026.031.05.042-.028.016-.03.034-.042.052.019-.014.028.042.083.009l-.016.048c.02.054.106-.006.131.036-.036.012-.038.043-.08.034.011.013.018.029.034.014-.008.021.064.006.052.038.015,0,.04-.026.051-.01l-.011.011c.011-.011.036.005.049-.03-.03.1.106.091.09.181a.633.633,0,0,1,.106.049c-.007.007-.009.013-.013.007.024.049.074-.062.1-.008,0,.058-.038.01-.034.035-.047.093.06.022.063.09h-.011c.009.044.079-.006.115.02l-.007.014a.249.249,0,0,1,.151-.032c-.025.034-.025.014-.032.056.02,0,.018-.064.055-.063a.212.212,0,0,1,.014.1.116.116,0,0,1-.035-.01c0,.062.045.013.061.027l-.009.024c.057.006.073-.055.128-.036v-.02c.043-.054.02.039.059,0v.064a.659.659,0,0,1,.12-.057c-.025.046-.072.061-.1.085.021,0,.074.006.088-.023-.009,0-.021.019-.029.008a.119.119,0,0,1,.106-.065c-.013.123.106.038.139.128.074-.047.155.009.245-.014-.048-.089.026-.007,0-.1.018-.009.025-.011.029,0l.074.042c.022.024-.014.026-.007.047.047,0,.029.036.067.052-.015-.032,0-.052.032-.047l-.049-.034c.047-.065.079.062.125-.009l-.009.037c.026-.028.121-.044.117-.132.01.008.029.028.018.041.082-.023.117-.156.194-.147l.008.023c.009-.014,0-.05.026-.042,0,.008.009.023.015.02s.008-.058.031-.058v.032c.084-.021.056-.124.089-.179a.11.11,0,0,0,.139.013l.007.008c.071-.063.063-.155.088-.238.1,0,.125-.127.2-.182-.017.006-.048-.027-.048-.043.021-.012-.021-.069.036-.039v.006c.064.013.068-.032.079-.062l-.077-.035c.148-.036.023-.213.138-.23-.015-.024-.011-.048-.029-.072l.045.009a.3.3,0,0,0,.027-.151l.031.017c.005-.04-.128-.06-.129-.093l.068-.008c.005-.065.057-.138-.007-.2.01,0,.03,0,.033.012,0-.032.031-.13-.059-.1.059-.009,0-.07-.037-.1h.045c-.063-.018-.079-.015-.1-.05,0-.011.033-.017.025,0,.015-.037-.047-.013-.034-.058l.031.006c-.005-.034-.018-.027-.056-.034s-.011-.062.026-.081c-.025,0-.062,0-.058-.023a.039.039,0,0,1,.03,0c.01-.066-.081-.054-.056-.107a.048.048,0,0,0,.021-.017.242.242,0,0,1,.027.072c.038-.016.028-.052.094-.048-.042-.017-.125-.032-.123-.073l.01-.011h.006c0-.01-.007-.015-.016-.017a.058.058,0,0,0,0-.032c.028-.021-.006-.046-.014-.063-.038.024-.044,0-.064.039,0,0,.006,0,.014.01s0,0,.008,0h0l.026.037c-.027,0-.051,0-.04-.034l-.075.017c.042-.052.044-.113.071-.14-.055-.03-.092-.1-.181-.067-.019,0,.007-.029.013-.042s.018.01.031,0c-.037-.009-.069-.063-.116-.026-.007-.047.055-.023.01-.055l.018-.007c-.018-.147-.223,0-.241-.161a.036.036,0,0,1,0,.025c-.083-.12-.251-.1-.341-.215-.029-.03-.046,0-.075.025l.007-.049-.053.044c-.06.028-.063-.143-.149-.077v.034c-.023-.01-.079.007-.07-.029,0,0-.012.032-.02.014V65.35a.507.507,0,0,0-.064.037c-.045-.021.016-.1-.055-.109-.028.008-.076.07-.066.088a.041.041,0,0,1,.026.042l-.022.012a.273.273,0,0,0,.028.205l.035-.044.009.036H52.4c.014.035.025.005.038-.015a.073.073,0,0,0,.011.04l.039-.069c0,.03-.02.056,0,.075.019-.031-.008-.068.02-.086.012.036,0,.063.026.037a.049.049,0,0,1-.014.038c.02-.02.044,0,.06-.041.009.043.058,0,.042.067.008-.015.04-.046.057-.046-.048.075.054.019.022.1.042-.069.078-.007.127-.035,0,0-.012.015-.014.009.017.013.014.036.02.053.026-.057.061-.056.094-.083,0,.066-.046.06-.063.116.02-.047.06-.026.072-.069a.129.129,0,0,1-.008.075c.04-.068.022-.006.059-.04,0,.049-.031.068.007.064C53.008,65.788,52.972,65.8,52.972,65.8Zm.585.424h0l-.009-.013Zm.028.057a.156.156,0,0,0-.011-.026c.013-.009.029-.014.031-.007S53.592,66.266,53.585,66.28ZM53.793,66c.012.008.006.016,0,.021l-.016-.016h-.005l.02-.005Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22614",
    "data-name": "Path 22614",
    d: "M53.73,66.013h-.005l0,.011h.014Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22615",
    "data-name": "Path 22615",
    d: "M51.128,65.943h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22616",
    "data-name": "Path 22616",
    d: "M53.588,67.12H53.6l-.008-.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22617",
    "data-name": "Path 22617",
    d: "M51.5,65.773l.011.006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22618",
    "data-name": "Path 22618",
    d: "M51.631,65.691h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22619",
    "data-name": "Path 22619",
    d: "M51.743,65.651l-.007-.018h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22620",
    "data-name": "Path 22620",
    d: "M51.134,67.213h0C51.148,67.224,51.143,67.217,51.134,67.213Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22621",
    "data-name": "Path 22621",
    d: "M50.985,66.677A.07.07,0,0,1,51,66.7C51.006,66.688,51.009,66.68,50.985,66.677Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22622",
    "data-name": "Path 22622",
    d: "M51.47,67.682Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22623",
    "data-name": "Path 22623",
    d: "M51,66.723a.019.019,0,0,0,0-.026h0C51,66.7,50.993,66.714,51,66.723Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22624",
    "data-name": "Path 22624",
    d: "M52.225,65.526h.006v-.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22625",
    "data-name": "Path 22625",
    d: "M52.227,65.52l.006-.006A.006.006,0,0,0,52.227,65.52Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22626",
    "data-name": "Path 22626",
    d: "M52.249,65.5l-.012.012A.014.014,0,0,0,52.249,65.5Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22627",
    "data-name": "Path 22627",
    d: "M52.067,65.531v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22628",
    "data-name": "Path 22628",
    d: "M52.027,65.546c.012,0,.035.027.047.013v-.013C52.072,65.572,52.031,65.518,52.027,65.546Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22629",
    "data-name": "Path 22629",
    d: "M51.763,65.422h.047c-.014-.014-.033-.032-.014-.043C51.724,65.348,51.824,65.408,51.763,65.422Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22630",
    "data-name": "Path 22630",
    d: "M51.625,65.461c.018-.018-.012-.022-.016-.031C51.6,65.451,51.6,65.457,51.625,65.461Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22631",
    "data-name": "Path 22631",
    d: "M50.939,66.2l-.037-.019C50.9,66.2,50.917,66.188,50.939,66.2Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22632",
    "data-name": "Path 22632",
    d: "M51.073,66.446l.029-.007-.034-.019Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22633",
    "data-name": "Path 22633",
    d: "M50.764,66.479v-.01l.006.035Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22634",
    "data-name": "Path 22634",
    d: "M51.332,68.1l.028-.043C51.344,68.051,51.305,68.094,51.332,68.1Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22635",
    "data-name": "Path 22635",
    d: "M52.035,68.38c0,.028.021.046.038.024C52.057,68.4,52.043,68.38,52.035,68.38Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22636",
    "data-name": "Path 22636",
    d: "M53.922,67.413l.01.021V67.4Z",
    fill: "#515151"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18561",
    "data-name": "Group 18561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22637",
    "data-name": "Path 22637",
    d: "M52.37,65.772c0-.014,0-.045-.008-.039l-.006.053Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22638",
    "data-name": "Path 22638",
    d: "M52.294,65.676a.193.193,0,0,0-.009.121c.008-.051.011-.03.021-.092.01-.007.018.016.018.036,0-.015.016.011.02-.023-.014-.04-.033-.041-.048-.006A.088.088,0,0,1,52.294,65.676Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22639",
    "data-name": "Path 22639",
    d: "M51.35,66.112h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22640",
    "data-name": "Path 22640",
    d: "M51.093,66.754a.012.012,0,0,0-.011-.008S51.088,66.755,51.093,66.754Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22641",
    "data-name": "Path 22641",
    d: "M51.032,66.875v-.007S51.027,66.874,51.032,66.875Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22642",
    "data-name": "Path 22642",
    d: "M51.35,66.115l-.025.005C51.339,66.131,51.341,66.12,51.35,66.115Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22643",
    "data-name": "Path 22643",
    d: "M52.176,65.82l.006-.015-.007.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22644",
    "data-name": "Path 22644",
    d: "M51.525,65.859h0l-.01-.021Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22645",
    "data-name": "Path 22645",
    d: "M51.721,65.713c-.006,0,.015.041.024.059-.007-.017-.008-.027,0-.033A.174.174,0,0,0,51.721,65.713Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22646",
    "data-name": "Path 22646",
    d: "M52.092,65.65v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22647",
    "data-name": "Path 22647",
    d: "M51.4,65.973l-.014-.01Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22648",
    "data-name": "Path 22648",
    d: "M52.573,65.9v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22649",
    "data-name": "Path 22649",
    d: "M52.365,65.65h0v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22650",
    "data-name": "Path 22650",
    d: "M51,67.115h0C50.994,67.109,50.995,67.113,51,67.115Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22651",
    "data-name": "Path 22651",
    d: "M52.653,68.168c-.031-.034.026-.06-.017-.1C52.643,68.089,52.619,68.15,52.653,68.168Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22652",
    "data-name": "Path 22652",
    d: "M52.173,65.814h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22653",
    "data-name": "Path 22653",
    d: "M52.635,68.073Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22654",
    "data-name": "Path 22654",
    d: "M51.236,67.607l.013-.015A.037.037,0,0,0,51.236,67.607Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22655",
    "data-name": "Path 22655",
    d: "M51.122,67.226v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22656",
    "data-name": "Path 22656",
    d: "M51.415,67.726c0,.006,0,.012.007.013v0S51.413,67.737,51.415,67.726Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22657",
    "data-name": "Path 22657",
    d: "M51.569,67.868v-.01h-.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22658",
    "data-name": "Path 22658",
    d: "M53,66.088a.212.212,0,0,1,.021-.036C53,66.078,52.979,66.071,53,66.088Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22659",
    "data-name": "Path 22659",
    d: "M52.172,65.79v.02h0A.084.084,0,0,0,52.172,65.79Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22660",
    "data-name": "Path 22660",
    d: "M51.679,67.488l.012.023A.046.046,0,0,0,51.679,67.488Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22661",
    "data-name": "Path 22661",
    d: "M53.316,67.112v-.007S53.311,67.109,53.316,67.112Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22662",
    "data-name": "Path 22662",
    d: "M51.748,67.555a.075.075,0,0,0-.01.033l.009-.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22663",
    "data-name": "Path 22663",
    d: "M53.023,66.052",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22664",
    "data-name": "Path 22664",
    d: "M52.827,66.047c.018.013.039-.045.061-.071.034,0-.012.044-.02.074.023,0,.065-.042.074-.032a.06.06,0,0,1-.014.021c.043-.027.046.031.1,0l-.007.013a.443.443,0,0,1,.049-.065c.009.007.041-.013.019.019,0-.006-.015.006-.026.013h.02c-.028.049-.025,0-.052.035.028,0,.08-.014.084.01-.035.042-.044-.015-.059.036l-.006-.034c-.042.078-.008-.015-.055.065.013.034.048,0,.059.04.027-.016.03-.033.058-.049.075,0-.076.121,0,.1.034-.017.09-.056.077-.012l-.054.03c.014.03.082-.037.071.016-.024.009-.033-.009-.036,0-.026.046.038-.008.049.007l-.043.034c.024.025.081.037.108.07a.073.073,0,0,0-.044.023c.048.032.039.1.022.153h.051s-.018.014-.028.012c-.013.023.029-.008.049,0s-.023.021-.038.019c.046.019.109.073.062.117h-.015c-.015.029.1.018.061.049H53.4c-.015.061.031.13-.045.172.067.014-.033.054.059.069-.052.028-.067.017-.1.056-.005.011.054.03.06.048l-.049-.01.045.033H53.3l.009.017a.042.042,0,0,1,.038,0c.016.03-.048.045-.073.036l.021.064c-.018-.008-.021-.019-.031-.03.038.045-.05-.014-.016.027a.122.122,0,0,1,.036.018.044.044,0,0,0-.044.044v.007l-.029-.019c-.022.031-.024.078-.047.116.021,0,.069.03.067.044l-.047-.024c.023.025.024,0,.048.036-.015.011-.056-.025-.065-.042v.027a.229.229,0,0,1-.033-.029c.021.026-.062,0-.024.038L53.1,67.43c-.024.035-.026.058-.047.087.032.032.016.035.034.069-.031.009-.077,0-.1.026,0,.032.019.034.028.061-.027-.031-.051-.008-.055-.042a.242.242,0,0,0-.057.091c.013.012.023.014.028.028s-.027,0-.037-.021h0c-.02.087-.166-.046-.168.048h0l-.028.057c-.022,0,0-.034-.021-.052-.024.084-.075.01-.1.066-.053-.113-.108.03-.157-.048v.028c-.009.029-.014-.016-.021-.022,0,.022.013.025.007.041-.093.041-.189-.046-.264-.092-.028-.015-.056.138-.08.062l.027-.048c-.085.041-.126-.048-.209-.031.009-.008.017-.022.023-.019.006-.04-.042-.028-.06,0-.007-.009.013-.026.016-.042s-.058.024-.042-.013c0-.006.01-.008.014-.009-.018.01-.031-.029-.05.012-.007-.033-.052-.013-.05-.047-.042.028-.016-.047-.067,0,.051-.053.007-.071-.027-.061.02-.011.007-.026.034-.042-.012-.012-.034-.015-.06.012.043-.079-.1-.011-.022-.093a.354.354,0,0,1-.153-.089c.064-.031.034.046.1.006-.051-.022-.115-.023-.122-.073,0-.015.032-.006.045-.008-.047-.031-.027-.085-.077-.114a.038.038,0,0,1,.021,0c0-.007,0-.022-.026-.012l.011.006c-.043.027-.1-.007-.13,0,.1-.009.012-.049.134-.054a.072.072,0,0,0-.046,0c0-.01.016-.015.043-.012-.025-.025-.056-.008-.06-.036h.042c-.033-.008-.066-.018-.056-.043h.022c-.012-.038-.088-.063-.062-.111.07.011.022-.016.082-.019l-.018-.023-.03.009c0-.021-.04-.042-.02-.059l.024.017L51.3,66.78l-.024.021c-.03-.025-.076,0-.058-.032.006.007,0-.023.039-.031h0c-.017-.013-.035-.028-.018-.042s.065.013.078.013c-.047-.018-.007-.052-.056-.076a.116.116,0,0,0,.048.014l-.037-.017c.015-.007.022-.007.046,0,.015-.027-.076-.008-.035-.036a.015.015,0,0,1,.013.011c.025-.031-.008-.076.024-.1.06.011,0,.032.056.038,0-.046-.034-.118,0-.154l-.01,0c-.073-.043.052-.013.028-.052,0,.008.038.029.03.023.029-.02.014-.065.019-.121l.014.017c.028,0,.039-.033.058-.043-.014-.018,0-.026-.033-.04.133.034.03-.139.147-.1,0,0,0,.025.005.021l.021-.046c-.027-.026-.019-.013-.046-.028a.048.048,0,0,1,0-.052c0,.034.038.045.058.056-.008-.008-.014-.02-.022-.028.062.036-.043-.061.013-.048l.01.017c0-.016,0-.044.014-.048.03.032,0,.025.02.054.014-.013-.015-.091.025-.064,0,.014-.011.021-.011.036.044.03.039.02.055.019h.039l-.014-.008c-.036-.108.03-.045.026-.123,0,.076.014.038.034.082.013.009.031.017.034.03,0-.042.035.018.029-.043.007.014.015,0,.027.032.012-.02-.015-.023-.021-.042.008-.063.088.036.1-.049.027-.039.02-.091.051-.126.018.021,0,.058,0,.058.025.018.037.009.052-.011a.066.066,0,0,0,.014.041c.013-.006,0-.057.023-.038,0,.022,0,.043,0,.064.014-.017.026-.048.042-.065.008.026-.005.043-.009.061a.1.1,0,0,0,.049-.075l-.015-.015c.007,0,.007.036,0,.045-.013.037-.026-.011-.029-.026l.011-.012c-.025-.089-.051.023-.076.021V65.7l-.017.058c-.009-.016-.021-.052-.009-.064-.026-.028-.012.027-.037,0v-.012l-.015.025c0-.015-.014-.045,0-.039-.046-.028-.043.063-.07.018h0c-.041.036.009.048-.007.114l-.063-.106.012.048s-.016,0-.021-.019c-.006.038.01.019.012.052-.04-.034-.053.044-.089-.025.008.038.033.016.02.051-.042-.073-.021.026-.057,0-.013-.042.017-.031-.022-.055.021.07-.048,0-.058.029.028.051-.024.043-.041.076-.01-.019-.067.008-.1.011l-.005-.008c.032.051,0,.059-.01.084a.09.09,0,0,1-.028-.062l-.017.015a.056.056,0,0,1,0,.044l-.025-.037c-.02.023-.009.077-.055.083.029.03.1.06.1.106-.017-.014-.045-.04-.045-.053s.006.021,0,.019l-.017-.037c-.023,0,.017.028.005.035-.023-.022-.023-.008-.04-.027,0,0,.018,0,.012-.012a.07.07,0,0,1-.063,0c.014.011.032.028.027.039s-.035-.018-.059-.015c.011.019-.017.02.019.05-.005.007-.023-.006-.036-.011.007.025-.038.061.013.077h0c.009.063-.076.068-.085.12l-.014-.008c0,.033-.019.063,0,.1,0,.007-.035.006-.05,0,0,.025.016.033-.019.053-.018-.031-.026,0-.011-.029-.023.022-.049.02-.019.064-.035-.024-.056,0-.049.021l.034-.01a.071.071,0,0,1-.016.04l-.049-.023c-.079.045.077.134-.037.155.034.023.031-.028.072,0-.011.025-.091.041-.093.051-.035.036.071.046.047.083.019,0,.07,0,.087.027-.008.025-.081.027-.1.009s0-.01.012-.009-.014-.022-.035-.012h.019c-.02.012-.02.052-.051.042.017.022.031.01.042-.005-.029.035-.005.057-.021.094.01-.006.032-.012.032-.006-.021.055.037.023.047.058-.028.022-.07,0-.043.032-.018.024-.05.009-.066,0,.037.032-.016.068-.02.09l-.018-.017a.052.052,0,0,1,.013.028l.036-.016c0,.012,0,.021-.02.024.026.007.061-.018.1,0-.017.017.026.037-.021.052.009-.047-.049.015-.064-.021a.026.026,0,0,1,0,.027.012.012,0,0,1-.014,0c-.034.053.061.008.071.051-.029,0-.05.024-.042.029,0-.018.044-.02.069-.01-.014.033.023.025.025.04l.006-.019c.029,0,.028.011.044.026-.02.009-.02-.011-.028,0,.055,0-.032.062.01.079-.013.02-.049.021-.058.037.046.019-.021.051.023.073.03-.026.021-.023.066-.016l-.05-.042.067.012c-.007-.016-.039-.023-.036-.036.035,0,.026.006.052-.014-.042.044.05.027.027.067l-.086.041c-.019.06.078.045.085.1l0-.023c.036-.014.022.026.043.032a.113.113,0,0,0-.043.049c.019-.014.023.034.077,0l-.019.044c.014.046.1-.016.119.02-.035.013-.039.042-.076.037.009.011.014.024.03.01-.009.02.058,0,.044.03.014-.005.039-.027.048-.014l-.011.011c.011-.011.032,0,.047-.032-.037.1.086.073.063.158a.62.62,0,0,1,.089.037c-.007.007-.009.013-.012.008.016.044.069-.064.087-.016-.008.055-.034.013-.032.036-.048.092.051.016.047.082h-.009c0,.042.068-.011.1.011l-.007.014a.211.211,0,0,1,.129-.041c-.023.035-.022.015-.03.057.017,0,.019-.064.05-.065a.244.244,0,0,1,.006.093l-.029-.007c0,.06.037.011.049.024l-.009.023c.047,0,.063-.057.108-.041v-.02c.037-.055.014.039.048,0v.064a.589.589,0,0,1,.1-.06c-.021.046-.06.063-.088.088.018,0,.061,0,.072-.025-.008.005-.018.019-.024.008.027-.045.056-.07.088-.066-.012.123.086.036.113.127.06-.046.127.012.2-.009-.043-.09.021-.006,0-.1.015-.009.021-.009.024,0l.063.044c.019.025-.01.025,0,.046.039,0,.026.036.059.055-.015-.032,0-.052.025-.045l-.043-.035c.036-.063.069.065.1,0l-.006.035c.02-.026.1-.036.091-.121.009.008.027.03.019.041.069-.017.089-.142.157-.127l.009.023c.007-.013-.006-.048.019-.037,0,.009.01.023.015.02s0-.054.023-.052V68c.073-.014.039-.112.064-.158a.1.1,0,0,0,.127.024l.006.008c.06-.051.045-.136.061-.207.09.012.108-.1.177-.144a.068.068,0,0,1-.049-.041c.02-.008-.026-.06.032-.031h0c.063.016.064-.022.073-.047l-.077-.035c.143-.022.011-.178.125-.185-.016-.02-.013-.04-.031-.06l.045.009A.215.215,0,0,0,53.73,67l.032.015c0-.034-.128-.051-.13-.079l.068-.006c0-.053.058-.114-.006-.165.01,0,.029,0,.033.009,0-.026.033-.109-.057-.086.06-.009,0-.058-.034-.08h.045c-.062-.013-.078-.01-.1-.038,0-.009.033-.016.024,0,.016-.032-.046-.009-.031-.046H53.6c0-.027-.017-.021-.054-.025s-.006-.051.03-.069c-.025,0-.06,0-.055-.016a.048.048,0,0,1,.029,0c.013-.056-.075-.041-.047-.088a.057.057,0,0,0,.022-.016c.015.033.026.061.021.06.038-.016.031-.047.094-.047-.04-.012-.119-.019-.114-.054l.011-.01h.006c0-.008-.006-.012-.014-.014a.061.061,0,0,0,0-.027c.028-.02,0-.04-.009-.054-.038.024-.042,0-.064.04a.02.02,0,0,1,.013.007h.007l.022.03c-.026,0-.049,0-.036-.026l-.072.021c.044-.049.051-.1.079-.128-.049-.022-.078-.08-.163-.044-.017,0,.009-.027.016-.039s.016.007.028,0c-.034,0-.058-.051-.1-.014,0-.042.052-.026.014-.05l.017-.009c0-.133-.2.022-.2-.128a.033.033,0,0,1,0,.024c-.063-.107-.208-.069-.275-.181-.023-.027-.039.008-.065.029l.009-.049-.046.045c-.05.031-.046-.138-.119-.07v.033c-.019-.009-.064.009-.056-.027,0,0-.011.033-.016.015v-.025c-.019.012-.036.025-.053.038-.037-.02.014-.1-.044-.108-.023.009-.062.071-.054.088.008,0,.021.017.021.042l-.018.012a.343.343,0,0,0,.022.205l.027-.044.007.037H52.4c.011.035.019,0,.03-.015a.078.078,0,0,0,.008.04l.032-.07c0,.03-.017.057,0,.075.015-.031,0-.067.018-.086.009.036,0,.063.02.036a.06.06,0,0,1-.012.039c.016-.021.034,0,.048-.043.005.042.046,0,.03.066.007-.016.034-.049.047-.048-.042.077.042.016.011.1.037-.07.062-.014.1-.044,0,0-.011.016-.012.011.013.011.008.034.012.05.026-.057.054-.059.084-.088-.008.064-.042.062-.061.117.02-.047.052-.031.065-.072a.159.159,0,0,1-.013.072c.039-.068.019-.007.052-.042,0,.045-.032.067,0,.058C52.858,66.032,52.827,66.047,52.827,66.047Zm.474.309h0l-.008-.01Zm.022.045a.066.066,0,0,0-.008-.021c.013-.008.028-.014.03-.009s-.013.017-.026.031Zm.221-.252c.011.006,0,.013,0,.019l-.014-.013h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22665",
    "data-name": "Path 22665",
    d: "M53.483,66.163h0l-.006.009h.014Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22666",
    "data-name": "Path 22666",
    d: "M51.361,66.113Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22667",
    "data-name": "Path 22667",
    d: "M53.308,67.055h.011l-.009-.006Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22668",
    "data-name": "Path 22668",
    d: "M51.68,66l.01.007Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22669",
    "data-name": "Path 22669",
    d: "M51.785,65.934h.023A.045.045,0,0,0,51.785,65.934Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22670",
    "data-name": "Path 22670",
    d: "M51.877,65.906l-.007-.018h0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22671",
    "data-name": "Path 22671",
    d: "M51.409,67.129Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22672",
    "data-name": "Path 22672",
    d: "M51.268,66.711l.019.017C51.292,66.719,51.294,66.713,51.268,66.711Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22673",
    "data-name": "Path 22673",
    d: "M51.678,67.487Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22674",
    "data-name": "Path 22674",
    d: "M51.285,66.748a.013.013,0,0,0,0-.017l0,0C51.284,66.733,51.279,66.741,51.285,66.748Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22675",
    "data-name": "Path 22675",
    d: "M52.256,65.812h0v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22676",
    "data-name": "Path 22676",
    d: "M52.264,65.806v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22677",
    "data-name": "Path 22677",
    d: "M52.273,65.788l-.009.011S52.273,65.8,52.273,65.788Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22678",
    "data-name": "Path 22678",
    d: "M52.132,65.811v0Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22679",
    "data-name": "Path 22679",
    d: "M52.1,65.825c.01,0,.029.029.039.015v-.013C52.136,65.851,52.1,65.795,52.1,65.825Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22680",
    "data-name": "Path 22680",
    d: "M51.875,65.687h.039c-.012-.015-.029-.033-.015-.043C51.835,65.612,51.923,65.676,51.875,65.687Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22681",
    "data-name": "Path 22681",
    d: "M51.76,65.713c.014-.016-.012-.022-.016-.031C51.74,65.7,51.74,65.708,51.76,65.713Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22682",
    "data-name": "Path 22682",
    d: "M51.2,66.315l-.037-.019C51.163,66.315,51.179,66.306,51.2,66.315Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22683",
    "data-name": "Path 22683",
    d: "M51.347,66.53h.028l-.034-.017Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22684",
    "data-name": "Path 22684",
    d: "M51.042,66.542v-.008l.008.03Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22685",
    "data-name": "Path 22685",
    d: "M51.513,67.876l.029-.042C51.528,67.834,51.49,67.876,51.513,67.876Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22686",
    "data-name": "Path 22686",
    d: "M52.1,68.1c0,.026.016.046.031.023C52.115,68.118,52.1,68.1,52.1,68.1Z",
    fill: "#515151"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22687",
    "data-name": "Path 22687",
    d: "M53.654,67.314l.011.018V67.3Z",
    fill: "#515151"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19042",
    "data-name": "Group 19042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23457",
    "data-name": "Path 23457",
    d: "M49.586,39.415c.11.1.219.2.282.276.025.029.063.029.1.043a.4.4,0,0,0,.051.023l.008,0,.08.08a.275.275,0,0,0,.042.227l.073.075a.223.223,0,0,0,.081.038c.018.02.032.038.054.059,0,.012,0,.024.006.035a1.01,1.01,0,0,0,.064.082.249.249,0,0,0,.048.06.529.529,0,0,0,.2.114l.01.008a.247.247,0,0,0,.115.028h0a.274.274,0,0,0,.048.017l.03.031a.235.235,0,0,0,.085.2l.018.013a.217.217,0,0,0,.04.1.717.717,0,0,1,.07.09.242.242,0,0,0,.16.1l.111.095c0,.005,0,.011,0,.016.011.021.03.037.043.057h0a.246.246,0,0,0,.094.167l.131.1a.242.242,0,0,0,.07.024v.006h0l0,.008c.005.006.012.009.017.015a.288.288,0,0,0,.032.039c.011.009.02.014.03.023a.228.228,0,0,0,.049.136,2.854,2.854,0,0,0,.238.2l.011,0a1.309,1.309,0,0,0,.111.089c.009.006.019,0,.028.009l.026.028.01.008a.905.905,0,0,0,.079.1c.017.017.041.014.061.026.03.028.053.05.077.071l.005.013c.046.052.091.107.172.207.027.023.046.035.068.052a.227.227,0,0,0,.056.08l.13.091c.012.008.027.006.04.012a.246.246,0,0,0,.085.146L53.1,43c.016.013.037.011.055.019a.63.63,0,0,0,.05.068.3.3,0,0,1,.037.052.246.246,0,0,0,.114.094l.063.062.023.022c.015.028.014.063.039.084h0v0l.1.09.012.011c.016.015.038.012.056.022l.025.029a1.648,1.648,0,0,1,.129.154.248.248,0,0,0,.1.08h0c.012.017.017.041.033.054h0l.008.008.006,0,.012.013,0,.005.013.005c.011.012.019.023.031.035h0c.006.007.01.016.016.022L54.1,44l.012.005a.64.64,0,0,0,.193.184c.005,0,.012,0,.018,0s.005.015.011.02a2.023,2.023,0,0,0,.179.167.943.943,0,0,0,.282.185.672.672,0,0,0,.4.045.619.619,0,0,0,.186-.059.723.723,0,0,0,.11-.071l.031-.021a.862.862,0,0,0,.2-.232.674.674,0,0,0,.09-.345.778.778,0,0,0-.134-.433,1.493,1.493,0,0,0-.226-.27c-.016-.014-.031-.031-.047-.046-.062-.073-.117-.132-.164-.182l-.007,0a1.515,1.515,0,0,0-.144-.145l-.043-.046c-.075-.069-.155-.142-.229-.217a.275.275,0,0,0-.067-.1c-.042-.039-.1-.1-.152-.156a2.2,2.2,0,0,0-.2-.2,7.9,7.9,0,0,0-.673-.7.228.228,0,0,0-.074-.043c-.108-.107-.22-.211-.36-.338a.221.221,0,0,0-.076-.046c-.059-.057-.123-.127-.192-.2-.045-.048-.091-.1-.14-.15l0,0-.007-.01a3.5,3.5,0,0,0-.437-.441,3.845,3.845,0,0,1-.36-.355.771.771,0,0,1-.1-.1h0l-.009-.012-.071-.087a.294.294,0,0,0-.041-.031l-.013-.018a.521.521,0,0,0-.208-.18c-.013-.007-.021-.018-.035-.024a.879.879,0,0,0-.119-.124c-.022-.021-.059-.054-.065-.063a.2.2,0,0,0-.092-.106c-.025-.018-.068-.058-.117-.1a2.407,2.407,0,0,0-.239-.2c-.048-.054-.1-.1-.152-.154a.26.26,0,0,0-.089-.116l-.1-.07a.239.239,0,0,0-.083-.129c-.122-.1-.17-.143-.214-.183s-.067-.06-.127-.109a.229.229,0,0,0-.054-.063c-.075-.061-.144-.126-.191-.173a6.992,6.992,0,0,0-.527-.559c-.22-.221-.466-.468-.65-.674a.255.255,0,0,0-.088-.063v0a.763.763,0,0,0-.175-.136.424.424,0,0,0-.062-.029.225.225,0,0,0-.1-.048.779.779,0,0,0-.356,0,.746.746,0,0,0-.274.122.665.665,0,0,0-.238.305.39.39,0,0,0-.028.049.267.267,0,0,0-.04.089.7.7,0,0,0-.018.157.9.9,0,0,0,0,.116.466.466,0,0,0,.02.124.38.38,0,0,0,.038.112,1.217,1.217,0,0,0,0,.148.209.209,0,0,0-.009.051,4.224,4.224,0,0,0,.012.644,1.147,1.147,0,0,0,0,.194v.487a.231.231,0,0,0,.018.091,1.047,1.047,0,0,1,0,.177l0,.027a2.376,2.376,0,0,0-.006.33,1.952,1.952,0,0,1-.009.266.213.213,0,0,0,.034.132c0,.029-.005.063-.008.1a2.536,2.536,0,0,0-.015.4v.007c0,.052-.012.106-.02.163a.242.242,0,0,0-.045.124.763.763,0,0,0,.008.281.49.49,0,0,0-.014.126,1.4,1.4,0,0,0,.008.27,2.841,2.841,0,0,1,.012.482.22.22,0,0,0,.024.133c-.01.156-.007.305,0,.452a.248.248,0,0,0-.029.107.5.5,0,0,0,.024.134l.006.115c.005.117.012.247.021.335a2.257,2.257,0,0,0-.011.552c.005.1.011.187.009.245a.261.261,0,0,0-.024.107v.369a.221.221,0,0,0-.007.046,2.353,2.353,0,0,0,.019.444.285.285,0,0,0,0,.04,4.426,4.426,0,0,0,.014.763.274.274,0,0,0-.012.109c0,.038,0,.117-.007.219-.007.181-.018.423-.01.65,0,.011,0,.023-.005.035a8.612,8.612,0,0,0,.021,1.275l.019.3a.3.3,0,0,0,.006.043,1.967,1.967,0,0,0-.015.261c0,.054,0,.107,0,.142a.28.28,0,0,0-.013.081v.286a1.336,1.336,0,0,0,.016.195.784.784,0,0,0,.081.231.723.723,0,0,0,.381.33.665.665,0,0,0,.232.042h.027a.858.858,0,0,0,.225-.036.7.7,0,0,0,.228-.12.685.685,0,0,0,.175-.207.852.852,0,0,0,.08-.221,1.427,1.427,0,0,0,.025-.182c0-.055,0-.106,0-.156s0-.078,0-.117a1.928,1.928,0,0,0,0-.2v-.082a.239.239,0,0,0-.009-.066,1.192,1.192,0,0,0,0-.189.269.269,0,0,0,.017-.093v-.144a.248.248,0,0,0-.016-.086,1.66,1.66,0,0,1-.007-.241.348.348,0,0,0,.018-.1V47.2a.248.248,0,0,0-.039-.135c.013-.182.013-.458.011-.8,0-.17,0-.311,0-.4a5.648,5.648,0,0,1-.015-.6.242.242,0,0,0-.011-.08,1.388,1.388,0,0,0,.023-.258,1.768,1.768,0,0,1,.017-.251.179.179,0,0,0,0-.04c0-.01.011-.016.011-.026s-.012-.021-.014-.034,0-.023,0-.033l0-.107a1.958,1.958,0,0,0-.012-.212.321.321,0,0,0,.019-.117c-.013-.221-.006-.469,0-.729.005-.212.011-.432.007-.655a.278.278,0,0,0-.02-.094l.028-.2a.592.592,0,0,0-.026-.165.306.306,0,0,1,.006-.068.234.234,0,0,0-.014-.124c.013-.4.01-.8.007-1.2,0-.558-.01-1.135.03-1.694a.2.2,0,0,0-.017-.1v-.117h-.017l.017-.247a.156.156,0,0,0-.008-.086l0-.013.181.181a.238.238,0,0,0,.085.179l.128.1c.016.013.036.011.053.019a.249.249,0,0,0,.063.134Z",
    fill: "#0068f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23458",
    "data-name": "Path 23458",
    d: "M57.78,49.564a.962.962,0,0,0,0-.142.229.229,0,0,0,.011-.058,3.848,3.848,0,0,0-.014-.638,1.018,1.018,0,0,0,0-.2v-.486a.255.255,0,0,0-.017-.092,1.05,1.05,0,0,1,0-.177l0-.026a2.391,2.391,0,0,0,.006-.331,2.442,2.442,0,0,1,.009-.266.212.212,0,0,0-.034-.131c0-.028.006-.06.009-.094a2.729,2.729,0,0,0,.014-.4v0c.005-.057.013-.112.021-.168a.247.247,0,0,0,.039-.117.727.727,0,0,0-.009-.279.433.433,0,0,0,.015-.127,1.361,1.361,0,0,0-.009-.272,3.175,3.175,0,0,1-.012-.481.217.217,0,0,0-.022-.13c.01-.158.007-.316,0-.47a.262.262,0,0,0,.018-.082.487.487,0,0,0-.014-.116l-.006-.141c-.005-.117-.013-.247-.022-.336a2.132,2.132,0,0,0,.011-.555c0-.1-.011-.185-.009-.243a.25.25,0,0,0,.025-.107v-.369a.222.222,0,0,0,.007-.045,2.238,2.238,0,0,0-.02-.444.194.194,0,0,0,.006-.042,4.283,4.283,0,0,0-.016-.761.3.3,0,0,0,.014-.113c0-.038,0-.119.006-.222.008-.18.018-.42.01-.645,0-.011,0-.023.005-.035a8.919,8.919,0,0,0-.02-1.276l-.02-.3a.3.3,0,0,0-.006-.043,2.171,2.171,0,0,0,.014-.261c0-.054,0-.107,0-.142a.246.246,0,0,0,.014-.081v-.29a1.289,1.289,0,0,0-.017-.191.771.771,0,0,0-.071-.219.673.673,0,0,0-.394-.344.8.8,0,0,0-.229-.042.822.822,0,0,0-.238.029.682.682,0,0,0-.415.328.823.823,0,0,0-.079.216,1.078,1.078,0,0,0-.026.182c-.006.077-.007.147-.008.216v.347a.224.224,0,0,0,.01.068.974.974,0,0,0,0,.187.257.257,0,0,0-.016.091v.144a.249.249,0,0,0,.015.087,1.425,1.425,0,0,1,.008.243.291.291,0,0,0-.016.063.438.438,0,0,0,0,.118v.312a.251.251,0,0,0,.04.135c-.012.187-.013.47-.012.8,0,.169,0,.306,0,.4a5.6,5.6,0,0,1,.014.594.262.262,0,0,0,.011.08,1.493,1.493,0,0,0-.022.257,1.632,1.632,0,0,1-.018.252c0,.008,0,.015,0,.023s-.017.027-.017.044.017.035.023.055v.011l0,.107a2.013,2.013,0,0,0,.012.214.324.324,0,0,0-.019.114c.013.222.006.47,0,.731-.005.211-.011.431-.008.653a.239.239,0,0,0,.021.1l-.028.2a.546.546,0,0,0,.026.165.314.314,0,0,1-.006.069.22.22,0,0,0,.014.123c-.014.4-.01.805-.007,1.214.005.556.01,1.131-.03,1.684a.179.179,0,0,0,.009.057,1.258,1.258,0,0,0,0,.176h.026l-.017.231a.15.15,0,0,0,.009.086l0,.012-.186-.186a.244.244,0,0,0-.088-.165l-.129-.1c-.014-.011-.032-.006-.047-.013a.247.247,0,0,0-.069-.144l-.172-.163c-.115-.106-.23-.213-.3-.287a.238.238,0,0,0-.117-.057l-.025-.013-.088-.089a.3.3,0,0,0-.048-.215L55,46.732a.256.256,0,0,0-.064-.032c-.021-.023-.044-.045-.066-.067,0-.006,0-.013,0-.02a.592.592,0,0,0-.072-.1.25.25,0,0,0-.046-.057.518.518,0,0,0-.2-.121l0,0c-.024-.013-.051,0-.077-.009a.218.218,0,0,0-.061-.02l-.06-.06a.242.242,0,0,0-.086-.181l-.015-.012a.232.232,0,0,0-.042-.1.539.539,0,0,1-.071-.09.23.23,0,0,0-.143-.093l-.007,0s-.01,0-.014-.005l-.107-.092c0-.006,0-.012,0-.018a.534.534,0,0,0-.041-.056l0-.006h0a.253.253,0,0,0-.1-.166l-.129-.1c-.019-.014-.043-.008-.064-.016V45.3h0v0h0V45.29c0-.005-.009-.005-.012-.009a.25.25,0,0,0-.046-.056c-.01-.009-.018-.014-.027-.021a.233.233,0,0,0-.047-.136c-.07-.066-.144-.128-.219-.187l-.005-.008a1.417,1.417,0,0,0-.128-.1c-.013-.01-.03-.005-.045-.012a.916.916,0,0,0-.1-.128c-.021-.02-.048-.017-.072-.027s-.049-.048-.069-.065c0,0,0-.011-.006-.016-.047-.052-.093-.107-.173-.207-.025-.022-.045-.035-.067-.052s-.028-.061-.057-.08l-.129-.091c-.012-.008-.027,0-.04-.009a.241.241,0,0,0-.085-.147l-.073-.059c-.007-.005-.016,0-.023-.007a.511.511,0,0,0-.068-.092.275.275,0,0,1-.038-.052.246.246,0,0,0-.115-.095l-.062-.062c-.016-.015-.033-.029-.048-.044s-.006-.03-.018-.041l-.012-.011h0l-.1-.1c-.006-.005-.014,0-.02-.008l-.049-.057c-.038-.043-.081-.09-.128-.152a.238.238,0,0,0-.1-.081l-.029-.026-.005,0-.029-.03c-.006-.005-.013,0-.019-.008l-.018-.02v-.005a.221.221,0,0,0-.029-.033l-.073-.073s-.011,0-.016-.006a.628.628,0,0,0-.182-.175.221.221,0,0,0-.026-.044l-.148-.15a.881.881,0,0,0-.131-.12.713.713,0,0,0-.2-.1.7.7,0,0,0-.386-.021.683.683,0,0,0-.277.118.22.22,0,0,0-.025.017.714.714,0,0,0-.218.251.748.748,0,0,0-.081.25.31.31,0,0,0-.011.051.759.759,0,0,0,.123.487,1.629,1.629,0,0,0,.229.245l.006.006c.008.013.007.029.017.041.068.08.125.14.176.193l0,0a1.584,1.584,0,0,0,.22.221c.012.009.028.007.04.014.058.053.117.107.172.162a.259.259,0,0,0,.067.1c.042.039.1.1.154.157a2.036,2.036,0,0,0,.2.2,7.789,7.789,0,0,0,.673.7.209.209,0,0,0,.074.043c.107.107.22.211.359.338a.2.2,0,0,0,.078.046c.058.057.123.128.192.2l.143.154.013.018a3.664,3.664,0,0,0,.431.432,3.821,3.821,0,0,1,.358.354.675.675,0,0,1,.1.1l.014.017.062.075v.005l.04.055c.088.121.163.215.283.224a.983.983,0,0,0,.1.1c.021.021.059.054.064.063a.2.2,0,0,0,.094.106c.025.018.067.059.115.1.087.079.154.139.209.181a.286.286,0,0,0,.05.042c.043.046.088.091.134.133a.265.265,0,0,0,.088.116l.1.07a.251.251,0,0,0,.083.129c.121.1.168.142.211.181s.069.061.13.112a.263.263,0,0,0,.054.061,2.573,2.573,0,0,1,.191.176,7.441,7.441,0,0,0,.535.566c.217.219.461.464.643.668a.267.267,0,0,0,.083.06v0a.858.858,0,0,0,.166.135c.017.01.033.018.05.026a.24.24,0,0,0,.11.062.793.793,0,0,0,.188.023.721.721,0,0,0,.18-.022.846.846,0,0,0,.253-.107.644.644,0,0,0,.262-.312.193.193,0,0,0,.029-.047.241.241,0,0,0,.041-.087.765.765,0,0,0,.022-.165.869.869,0,0,0,0-.125.61.61,0,0,0-.02-.117A.338.338,0,0,0,57.78,49.564Z",
    fill: "#0068f5"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiometricPasport);
export default __webpack_public_path__ + "static/media/biometric-pasport.41ecd0cf9f56f7e67f6a1c03662a964d.svg";
export { ForwardRef as ReactComponent };